import * as i0 from '@angular/core';
import { Injectable, inject, ElementRef, NgZone, EventEmitter, Injector, Renderer2, afterNextRender, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, Optional, SkipSelf, InjectionToken, ChangeDetectorRef, ViewChild, ViewContainerRef, DOCUMENT, booleanAttribute, Directive, forwardRef, signal, HostAttributeToken, ContentChild, TemplateRef, NgModule } from '@angular/core';
import { Subject, Subscription, merge, of } from 'rxjs';
import { DateAdapter, MAT_DATE_FORMATS } from './date-formats.mjs';
import { _IdGenerator, CdkMonitorFocus, CdkTrapFocus, A11yModule } from '@angular/cdk/a11y';
import { Directionality } from '@angular/cdk/bidi';
import { coerceStringArray } from '@angular/cdk/coercion';
import { ESCAPE, hasModifierKey, SPACE, ENTER, PAGE_DOWN, PAGE_UP, END, HOME, DOWN_ARROW, UP_ARROW, RIGHT_ARROW, LEFT_ARROW, BACKSPACE } from '@angular/cdk/keycodes';
import { createRepositionScrollStrategy, FlexibleConnectedPositionStrategy, createOverlayRef, OverlayConfig, createBlockScrollStrategy, createGlobalPositionStrategy, createFlexibleConnectedPositionStrategy, OverlayModule } from '@angular/cdk/overlay';
import { Platform, _getFocusedElementPierceShadowDom } from '@angular/cdk/platform';
import { ComponentPortal, CdkPortalOutlet, TemplatePortal, PortalModule } from '@angular/cdk/portal';
import { startWith, take, filter } from 'rxjs/operators';
import { NgClass } from '@angular/common';
import { _CdkPrivateStyleLoader, _VisuallyHiddenLoader } from '@angular/cdk/private';
import { _StructuralStylesLoader } from './structural-styles.mjs';
import { MatButton, MatButtonModule } from './button.mjs';
import { MatIconButton } from './icon-button.mjs';
import { MatTooltip } from './tooltip2.mjs';
import { _animationsDisabled } from './animation.mjs';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, Validators, ControlContainer, NgForm, FormGroupDirective, NgControl } from '@angular/forms';
import { MAT_INPUT_VALUE_ACCESSOR } from './input-value-accessor.mjs';
import { MAT_FORM_FIELD, MatFormFieldControl } from './form-field2.mjs';
import { ErrorStateMatcher } from './error-options.mjs';
import { _ErrorStateTracker } from './error-state.mjs';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { MatCommonModule } from './common-module.mjs';
import './ripple-module.mjs';
import './ripple.mjs';
import './ripple-loader.mjs';
import '@angular/cdk/layout';
import '@angular/cdk/observers/private';

/** @docs-private */
const _c0 = ["mat-calendar-body", ""];
function _forTrack0($index, $item) {
  return this._trackRow($item);
}
const _forTrack1 = ($index, $item) => $item.id;
function MatCalendarBody_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 0)(1, "td", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("padding-top", ctx_r0._cellPadding)("padding-bottom", ctx_r0._cellPadding);
    i0.ɵɵattribute("colspan", ctx_r0.numCols);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label, " ");
  }
}
function MatCalendarBody_For_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("padding-top", ctx_r0._cellPadding)("padding-bottom", ctx_r0._cellPadding);
    i0.ɵɵattribute("colspan", ctx_r0._firstRowOffset);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0._firstRowOffset >= ctx_r0.labelMinRequiredCells ? ctx_r0.label : "", " ");
  }
}
function MatCalendarBody_For_2_For_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 6)(1, "button", 7);
    i0.ɵɵlistener("click", function MatCalendarBody_For_2_For_3_Template_button_click_1_listener($event) {
      const item_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0._cellClicked(item_r3, $event));
    })("focus", function MatCalendarBody_For_2_For_3_Template_button_focus_1_listener($event) {
      const item_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0._emitActiveDateChange(item_r3, $event));
    });
    i0.ɵɵelementStart(2, "span", 8);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const ɵ$index_14_r4 = ctx.$index;
    const ɵ$index_7_r5 = i0.ɵɵnextContext().$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("width", ctx_r0._cellWidth)("padding-top", ctx_r0._cellPadding)("padding-bottom", ctx_r0._cellPadding);
    i0.ɵɵattribute("data-mat-row", ɵ$index_7_r5)("data-mat-col", ɵ$index_14_r4);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("mat-calendar-body-disabled", !item_r3.enabled)("mat-calendar-body-active", ctx_r0._isActiveCell(ɵ$index_7_r5, ɵ$index_14_r4))("mat-calendar-body-range-start", ctx_r0._isRangeStart(item_r3.compareValue))("mat-calendar-body-range-end", ctx_r0._isRangeEnd(item_r3.compareValue))("mat-calendar-body-in-range", ctx_r0._isInRange(item_r3.compareValue))("mat-calendar-body-comparison-bridge-start", ctx_r0._isComparisonBridgeStart(item_r3.compareValue, ɵ$index_7_r5, ɵ$index_14_r4))("mat-calendar-body-comparison-bridge-end", ctx_r0._isComparisonBridgeEnd(item_r3.compareValue, ɵ$index_7_r5, ɵ$index_14_r4))("mat-calendar-body-comparison-start", ctx_r0._isComparisonStart(item_r3.compareValue))("mat-calendar-body-comparison-end", ctx_r0._isComparisonEnd(item_r3.compareValue))("mat-calendar-body-in-comparison-range", ctx_r0._isInComparisonRange(item_r3.compareValue))("mat-calendar-body-preview-start", ctx_r0._isPreviewStart(item_r3.compareValue))("mat-calendar-body-preview-end", ctx_r0._isPreviewEnd(item_r3.compareValue))("mat-calendar-body-in-preview", ctx_r0._isInPreview(item_r3.compareValue));
    i0.ɵɵproperty("ngClass", item_r3.cssClasses)("tabindex", ctx_r0._isActiveCell(ɵ$index_7_r5, ɵ$index_14_r4) ? 0 : -1);
    i0.ɵɵattribute("aria-label", item_r3.ariaLabel)("aria-disabled", !item_r3.enabled || null)("aria-pressed", ctx_r0._isSelected(item_r3.compareValue))("aria-current", ctx_r0.todayValue === item_r3.compareValue ? "date" : null)("aria-describedby", ctx_r0._getDescribedby(item_r3.compareValue));
    i0.ɵɵadvance();
    i0.ɵɵclassProp("mat-calendar-body-selected", ctx_r0._isSelected(item_r3.compareValue))("mat-calendar-body-comparison-identical", ctx_r0._isComparisonIdentical(item_r3.compareValue))("mat-calendar-body-today", ctx_r0.todayValue === item_r3.compareValue);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r3.displayValue, " ");
  }
}
function MatCalendarBody_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 1);
    i0.ɵɵconditionalCreate(1, MatCalendarBody_For_2_Conditional_1_Template, 2, 6, "td", 4);
    i0.ɵɵrepeaterCreate(2, MatCalendarBody_For_2_For_3_Template, 5, 48, "td", 5, _forTrack1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r6 = ctx.$implicit;
    const ɵ$index_7_r5 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ɵ$index_7_r5 === 0 && ctx_r0._firstRowOffset ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(row_r6);
  }
}
function MatMonthView_For_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 2)(1, "span", 6);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 3);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const day_r1 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(day_r1.long);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(day_r1.narrow);
  }
}
const _c1 = ["*"];
function MatCalendar_ng_template_0_Template(rf, ctx) {}
function MatCalendar_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-month-view", 4);
    i0.ɵɵtwoWayListener("activeDateChange", function MatCalendar_Case_2_Template_mat_month_view_activeDateChange_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.activeDate, $event) || (ctx_r1.activeDate = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("_userSelection", function MatCalendar_Case_2_Template_mat_month_view__userSelection_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._dateSelected($event));
    })("dragStarted", function MatCalendar_Case_2_Template_mat_month_view_dragStarted_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._dragStarted($event));
    })("dragEnded", function MatCalendar_Case_2_Template_mat_month_view_dragEnded_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._dragEnded($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("activeDate", ctx_r1.activeDate);
    i0.ɵɵproperty("selected", ctx_r1.selected)("dateFilter", ctx_r1.dateFilter)("maxDate", ctx_r1.maxDate)("minDate", ctx_r1.minDate)("dateClass", ctx_r1.dateClass)("comparisonStart", ctx_r1.comparisonStart)("comparisonEnd", ctx_r1.comparisonEnd)("startDateAccessibleName", ctx_r1.startDateAccessibleName)("endDateAccessibleName", ctx_r1.endDateAccessibleName)("activeDrag", ctx_r1._activeDrag);
  }
}
function MatCalendar_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-year-view", 5);
    i0.ɵɵtwoWayListener("activeDateChange", function MatCalendar_Case_3_Template_mat_year_view_activeDateChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.activeDate, $event) || (ctx_r1.activeDate = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("monthSelected", function MatCalendar_Case_3_Template_mat_year_view_monthSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._monthSelectedInYearView($event));
    })("selectedChange", function MatCalendar_Case_3_Template_mat_year_view_selectedChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._goToDateInView($event, "month"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("activeDate", ctx_r1.activeDate);
    i0.ɵɵproperty("selected", ctx_r1.selected)("dateFilter", ctx_r1.dateFilter)("maxDate", ctx_r1.maxDate)("minDate", ctx_r1.minDate)("dateClass", ctx_r1.dateClass);
  }
}
function MatCalendar_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-multi-year-view", 6);
    i0.ɵɵtwoWayListener("activeDateChange", function MatCalendar_Case_4_Template_mat_multi_year_view_activeDateChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.activeDate, $event) || (ctx_r1.activeDate = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("yearSelected", function MatCalendar_Case_4_Template_mat_multi_year_view_yearSelected_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._yearSelectedInMultiYearView($event));
    })("selectedChange", function MatCalendar_Case_4_Template_mat_multi_year_view_selectedChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._goToDateInView($event, "year"));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("activeDate", ctx_r1.activeDate);
    i0.ɵɵproperty("selected", ctx_r1.selected)("dateFilter", ctx_r1.dateFilter)("maxDate", ctx_r1.maxDate)("minDate", ctx_r1.minDate)("dateClass", ctx_r1.dateClass);
  }
}
function MatDatepickerContent_ng_template_2_Template(rf, ctx) {}
const _c2 = ["button"];
const _c3 = [[["", "matDatepickerToggleIcon", ""]]];
const _c4 = ["[matDatepickerToggleIcon]"];
function MatDatepickerToggle_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 2);
    i0.ɵɵelement(1, "path", 3);
    i0.ɵɵelementEnd();
  }
}
const _c5 = [[["input", "matStartDate", ""]], [["input", "matEndDate", ""]]];
const _c6 = ["input[matStartDate]", "input[matEndDate]"];
function MatDatepickerActions_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0);
    i0.ɵɵprojection(1);
    i0.ɵɵdomElementEnd();
  }
}
function createMissingDateImplError(provider) {
  return Error(`MatDatepicker: No provider found for ${provider}. You must add one of the following ` + `to your app config: provideNativeDateAdapter, provideDateFnsAdapter, ` + `provideLuxonDateAdapter, provideMomentDateAdapter, or provide a custom implementation.`);
}

/** Datepicker data that requires internationalization. */
let MatDatepickerIntl = /*#__PURE__*/(() => {
  class MatDatepickerIntl {
    /**
     * Stream that emits whenever the labels here are changed. Use this to notify
     * components if the labels have changed after initialization.
     */
    changes = new Subject();
    /** A label for the calendar popup (used by screen readers). */
    calendarLabel = 'Calendar';
    /** A label for the button used to open the calendar popup (used by screen readers). */
    openCalendarLabel = 'Open calendar';
    /** Label for the button used to close the calendar popup. */
    closeCalendarLabel = 'Close calendar';
    /** A label for the previous month button (used by screen readers). */
    prevMonthLabel = 'Previous month';
    /** A label for the next month button (used by screen readers). */
    nextMonthLabel = 'Next month';
    /** A label for the previous year button (used by screen readers). */
    prevYearLabel = 'Previous year';
    /** A label for the next year button (used by screen readers). */
    nextYearLabel = 'Next year';
    /** A label for the previous multi-year button (used by screen readers). */
    prevMultiYearLabel = 'Previous 24 years';
    /** A label for the next multi-year button (used by screen readers). */
    nextMultiYearLabel = 'Next 24 years';
    /** A label for the 'switch to month view' button (used by screen readers). */
    switchToMonthViewLabel = 'Choose date';
    /** A label for the 'switch to year view' button (used by screen readers). */
    switchToMultiYearViewLabel = 'Choose month and year';
    /**
     * A label for the first date of a range of dates (used by screen readers).
     * @deprecated Provide your own internationalization string.
     * @breaking-change 17.0.0
     */
    startDateLabel = 'Start date';
    /**
     * A label for the last date of a range of dates (used by screen readers).
     * @deprecated Provide your own internationalization string.
     * @breaking-change 17.0.0
     */
    endDateLabel = 'End date';
    /**
     * A label for the Comparison date of a range of dates (used by screen readers).
     */
    comparisonDateLabel = 'Comparison range';
    /** Formats a range of years (used for visuals). */
    formatYearRange(start, end) {
      return `${start} \u2013 ${end}`;
    }
    /** Formats a label for a range of years (used by screen readers). */
    formatYearRangeLabel(start, end) {
      return `${start} to ${end}`;
    }
    static ɵfac = function MatDatepickerIntl_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatDatepickerIntl)();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MatDatepickerIntl,
      factory: MatDatepickerIntl.ɵfac,
      providedIn: 'root'
    });
  }
  return MatDatepickerIntl;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let uniqueIdCounter$1 = 0;
/**
 * An internal class that represents the data corresponding to a single calendar cell.
 * @docs-private
 */
class MatCalendarCell {
  value;
  displayValue;
  ariaLabel;
  enabled;
  cssClasses;
  compareValue;
  rawValue;
  id = uniqueIdCounter$1++;
  constructor(value, displayValue, ariaLabel, enabled, cssClasses = {}, compareValue = value, rawValue) {
    this.value = value;
    this.displayValue = displayValue;
    this.ariaLabel = ariaLabel;
    this.enabled = enabled;
    this.cssClasses = cssClasses;
    this.compareValue = compareValue;
    this.rawValue = rawValue;
  }
}
/** Event options that can be used to bind an active, capturing event. */
const activeCapturingEventOptions = {
  passive: false,
  capture: true
};
/** Event options that can be used to bind a passive, capturing event. */
const passiveCapturingEventOptions = {
  passive: true,
  capture: true
};
/** Event options that can be used to bind a passive, non-capturing event. */
const passiveEventOptions = {
  passive: true
};
/**
 * An internal component used to display calendar data in a table.
 * @docs-private
 */
let MatCalendarBody = /*#__PURE__*/(() => {
  class MatCalendarBody {
    _elementRef = inject(ElementRef);
    _ngZone = inject(NgZone);
    _platform = inject(Platform);
    _intl = inject(MatDatepickerIntl);
    _eventCleanups;
    /**
     * Used to skip the next focus event when rendering the preview range.
     * We need a flag like this, because some browsers fire focus events asynchronously.
     */
    _skipNextFocus;
    /**
     * Used to focus the active cell after change detection has run.
     */
    _focusActiveCellAfterViewChecked = false;
    /** The label for the table. (e.g. "Jan 2017"). */
    label;
    /** The cells to display in the table. */
    rows;
    /** The value in the table that corresponds to today. */
    todayValue;
    /** Start value of the selected date range. */
    startValue;
    /** End value of the selected date range. */
    endValue;
    /** The minimum number of free cells needed to fit the label in the first row. */
    labelMinRequiredCells;
    /** The number of columns in the table. */
    numCols = 7;
    /** The cell number of the active cell in the table. */
    activeCell = 0;
    ngAfterViewChecked() {
      if (this._focusActiveCellAfterViewChecked) {
        this._focusActiveCell();
        this._focusActiveCellAfterViewChecked = false;
      }
    }
    /** Whether a range is being selected. */
    isRange = false;
    /**
     * The aspect ratio (width / height) to use for the cells in the table. This aspect ratio will be
     * maintained even as the table resizes.
     */
    cellAspectRatio = 1;
    /** Start of the comparison range. */
    comparisonStart;
    /** End of the comparison range. */
    comparisonEnd;
    /** Start of the preview range. */
    previewStart = null;
    /** End of the preview range. */
    previewEnd = null;
    /** ARIA Accessible name of the `<input matStartDate/>` */
    startDateAccessibleName;
    /** ARIA Accessible name of the `<input matEndDate/>` */
    endDateAccessibleName;
    /** Emits when a new value is selected. */
    selectedValueChange = new EventEmitter();
    /** Emits when the preview has changed as a result of a user action. */
    previewChange = new EventEmitter();
    activeDateChange = new EventEmitter();
    /** Emits the date at the possible start of a drag event. */
    dragStarted = new EventEmitter();
    /** Emits the date at the conclusion of a drag, or null if mouse was not released on a date. */
    dragEnded = new EventEmitter();
    /** The number of blank cells to put at the beginning for the first row. */
    _firstRowOffset;
    /** Padding for the individual date cells. */
    _cellPadding;
    /** Width of an individual cell. */
    _cellWidth;
    /** ID for the start date label. */
    _startDateLabelId;
    /** ID for the end date label. */
    _endDateLabelId;
    /** ID for the comparison start date label. */
    _comparisonStartDateLabelId;
    /** ID for the comparison end date label. */
    _comparisonEndDateLabelId;
    _didDragSinceMouseDown = false;
    _injector = inject(Injector);
    comparisonDateAccessibleName = this._intl.comparisonDateLabel;
    /**
     * Tracking function for rows based on their identity. Ideally we would use some sort of
     * key on the row, but that would require a breaking change for the `rows` input. We don't
     * use the built-in identity tracking, because it logs warnings.
     */
    _trackRow = row => row;
    constructor() {
      const renderer = inject(Renderer2);
      const idGenerator = inject(_IdGenerator);
      this._startDateLabelId = idGenerator.getId('mat-calendar-body-start-');
      this._endDateLabelId = idGenerator.getId('mat-calendar-body-end-');
      this._comparisonStartDateLabelId = idGenerator.getId('mat-calendar-body-comparison-start-');
      this._comparisonEndDateLabelId = idGenerator.getId('mat-calendar-body-comparison-end-');
      inject(_CdkPrivateStyleLoader).load(_StructuralStylesLoader);
      this._ngZone.runOutsideAngular(() => {
        const element = this._elementRef.nativeElement;
        const cleanups = [
        // `touchmove` is active since we need to call `preventDefault`.
        renderer.listen(element, 'touchmove', this._touchmoveHandler, activeCapturingEventOptions), renderer.listen(element, 'mouseenter', this._enterHandler, passiveCapturingEventOptions), renderer.listen(element, 'focus', this._enterHandler, passiveCapturingEventOptions), renderer.listen(element, 'mouseleave', this._leaveHandler, passiveCapturingEventOptions), renderer.listen(element, 'blur', this._leaveHandler, passiveCapturingEventOptions), renderer.listen(element, 'mousedown', this._mousedownHandler, passiveEventOptions), renderer.listen(element, 'touchstart', this._mousedownHandler, passiveEventOptions)];
        if (this._platform.isBrowser) {
          cleanups.push(renderer.listen('window', 'mouseup', this._mouseupHandler), renderer.listen('window', 'touchend', this._touchendHandler));
        }
        this._eventCleanups = cleanups;
      });
    }
    /** Called when a cell is clicked. */
    _cellClicked(cell, event) {
      // Ignore "clicks" that are actually canceled drags (eg the user dragged
      // off and then went back to this cell to undo).
      if (this._didDragSinceMouseDown) {
        return;
      }
      if (cell.enabled) {
        this.selectedValueChange.emit({
          value: cell.value,
          event
        });
      }
    }
    _emitActiveDateChange(cell, event) {
      if (cell.enabled) {
        this.activeDateChange.emit({
          value: cell.value,
          event
        });
      }
    }
    /** Returns whether a cell should be marked as selected. */
    _isSelected(value) {
      return this.startValue === value || this.endValue === value;
    }
    ngOnChanges(changes) {
      const columnChanges = changes['numCols'];
      const {
        rows,
        numCols
      } = this;
      if (changes['rows'] || columnChanges) {
        this._firstRowOffset = rows && rows.length && rows[0].length ? numCols - rows[0].length : 0;
      }
      if (changes['cellAspectRatio'] || columnChanges || !this._cellPadding) {
        this._cellPadding = `${50 * this.cellAspectRatio / numCols}%`;
      }
      if (columnChanges || !this._cellWidth) {
        this._cellWidth = `${100 / numCols}%`;
      }
    }
    ngOnDestroy() {
      this._eventCleanups.forEach(cleanup => cleanup());
    }
    /** Returns whether a cell is active. */
    _isActiveCell(rowIndex, colIndex) {
      let cellNumber = rowIndex * this.numCols + colIndex;
      // Account for the fact that the first row may not have as many cells.
      if (rowIndex) {
        cellNumber -= this._firstRowOffset;
      }
      return cellNumber == this.activeCell;
    }
    /**
     * Focuses the active cell after the microtask queue is empty.
     *
     * Adding a 0ms setTimeout seems to fix Voiceover losing focus when pressing PageUp/PageDown
     * (issue #24330).
     *
     * Determined a 0ms by gradually increasing duration from 0 and testing two use cases with screen
     * reader enabled:
     *
     * 1. Pressing PageUp/PageDown repeatedly with pausing between each key press.
     * 2. Pressing and holding the PageDown key with repeated keys enabled.
     *
     * Test 1 worked roughly 95-99% of the time with 0ms and got a little bit better as the duration
     * increased. Test 2 got slightly better until the duration was long enough to interfere with
     * repeated keys. If the repeated key speed was faster than the timeout duration, then pressing
     * and holding pagedown caused the entire page to scroll.
     *
     * Since repeated key speed can verify across machines, determined that any duration could
     * potentially interfere with repeated keys. 0ms would be best because it almost entirely
     * eliminates the focus being lost in Voiceover (#24330) without causing unintended side effects.
     * Adding delay also complicates writing tests.
     */
    _focusActiveCell(movePreview = true) {
      afterNextRender(() => {
        setTimeout(() => {
          const activeCell = this._elementRef.nativeElement.querySelector('.mat-calendar-body-active');
          if (activeCell) {
            if (!movePreview) {
              this._skipNextFocus = true;
            }
            activeCell.focus();
          }
        });
      }, {
        injector: this._injector
      });
    }
    /** Focuses the active cell after change detection has run and the microtask queue is empty. */
    _scheduleFocusActiveCellAfterViewChecked() {
      this._focusActiveCellAfterViewChecked = true;
    }
    /** Gets whether a value is the start of the main range. */
    _isRangeStart(value) {
      return isStart(value, this.startValue, this.endValue);
    }
    /** Gets whether a value is the end of the main range. */
    _isRangeEnd(value) {
      return isEnd(value, this.startValue, this.endValue);
    }
    /** Gets whether a value is within the currently-selected range. */
    _isInRange(value) {
      return isInRange(value, this.startValue, this.endValue, this.isRange);
    }
    /** Gets whether a value is the start of the comparison range. */
    _isComparisonStart(value) {
      return isStart(value, this.comparisonStart, this.comparisonEnd);
    }
    /** Whether the cell is a start bridge cell between the main and comparison ranges. */
    _isComparisonBridgeStart(value, rowIndex, colIndex) {
      if (!this._isComparisonStart(value) || this._isRangeStart(value) || !this._isInRange(value)) {
        return false;
      }
      let previousCell = this.rows[rowIndex][colIndex - 1];
      if (!previousCell) {
        const previousRow = this.rows[rowIndex - 1];
        previousCell = previousRow && previousRow[previousRow.length - 1];
      }
      return previousCell && !this._isRangeEnd(previousCell.compareValue);
    }
    /** Whether the cell is an end bridge cell between the main and comparison ranges. */
    _isComparisonBridgeEnd(value, rowIndex, colIndex) {
      if (!this._isComparisonEnd(value) || this._isRangeEnd(value) || !this._isInRange(value)) {
        return false;
      }
      let nextCell = this.rows[rowIndex][colIndex + 1];
      if (!nextCell) {
        const nextRow = this.rows[rowIndex + 1];
        nextCell = nextRow && nextRow[0];
      }
      return nextCell && !this._isRangeStart(nextCell.compareValue);
    }
    /** Gets whether a value is the end of the comparison range. */
    _isComparisonEnd(value) {
      return isEnd(value, this.comparisonStart, this.comparisonEnd);
    }
    /** Gets whether a value is within the current comparison range. */
    _isInComparisonRange(value) {
      return isInRange(value, this.comparisonStart, this.comparisonEnd, this.isRange);
    }
    /**
     * Gets whether a value is the same as the start and end of the comparison range.
     * For context, the functions that we use to determine whether something is the start/end of
     * a range don't allow for the start and end to be on the same day, because we'd have to use
     * much more specific CSS selectors to style them correctly in all scenarios. This is fine for
     * the regular range, because when it happens, the selected styles take over and still show where
     * the range would've been, however we don't have these selected styles for a comparison range.
     * This function is used to apply a class that serves the same purpose as the one for selected
     * dates, but it only applies in the context of a comparison range.
     */
    _isComparisonIdentical(value) {
      // Note that we don't need to null check the start/end
      // here, because the `value` will always be defined.
      return this.comparisonStart === this.comparisonEnd && value === this.comparisonStart;
    }
    /** Gets whether a value is the start of the preview range. */
    _isPreviewStart(value) {
      return isStart(value, this.previewStart, this.previewEnd);
    }
    /** Gets whether a value is the end of the preview range. */
    _isPreviewEnd(value) {
      return isEnd(value, this.previewStart, this.previewEnd);
    }
    /** Gets whether a value is inside the preview range. */
    _isInPreview(value) {
      return isInRange(value, this.previewStart, this.previewEnd, this.isRange);
    }
    /** Gets ids of aria descriptions for the start and end of a date range. */
    _getDescribedby(value) {
      if (!this.isRange) {
        return null;
      }
      if (this.startValue === value && this.endValue === value) {
        return `${this._startDateLabelId} ${this._endDateLabelId}`;
      } else if (this.startValue === value) {
        return this._startDateLabelId;
      } else if (this.endValue === value) {
        return this._endDateLabelId;
      }
      if (this.comparisonStart !== null && this.comparisonEnd !== null) {
        if (value === this.comparisonStart && value === this.comparisonEnd) {
          return `${this._comparisonStartDateLabelId} ${this._comparisonEndDateLabelId}`;
        } else if (value === this.comparisonStart) {
          return this._comparisonStartDateLabelId;
        } else if (value === this.comparisonEnd) {
          return this._comparisonEndDateLabelId;
        }
      }
      return null;
    }
    /**
     * Event handler for when the user enters an element
     * inside the calendar body (e.g. by hovering in or focus).
     */
    _enterHandler = event => {
      if (this._skipNextFocus && event.type === 'focus') {
        this._skipNextFocus = false;
        return;
      }
      // We only need to hit the zone when we're selecting a range.
      if (event.target && this.isRange) {
        const cell = this._getCellFromElement(event.target);
        if (cell) {
          this._ngZone.run(() => this.previewChange.emit({
            value: cell.enabled ? cell : null,
            event
          }));
        }
      }
    };
    _touchmoveHandler = event => {
      if (!this.isRange) return;
      const target = getActualTouchTarget(event);
      const cell = target ? this._getCellFromElement(target) : null;
      if (target !== event.target) {
        this._didDragSinceMouseDown = true;
      }
      // If the initial target of the touch is a date cell, prevent default so
      // that the move is not handled as a scroll.
      if (getCellElement(event.target)) {
        event.preventDefault();
      }
      this._ngZone.run(() => this.previewChange.emit({
        value: cell?.enabled ? cell : null,
        event
      }));
    };
    /**
     * Event handler for when the user's pointer leaves an element
     * inside the calendar body (e.g. by hovering out or blurring).
     */
    _leaveHandler = event => {
      // We only need to hit the zone when we're selecting a range.
      if (this.previewEnd !== null && this.isRange) {
        if (event.type !== 'blur') {
          this._didDragSinceMouseDown = true;
        }
        // Only reset the preview end value when leaving cells. This looks better, because
        // we have a gap between the cells and the rows and we don't want to remove the
        // range just for it to show up again when the user moves a few pixels to the side.
        if (event.target && this._getCellFromElement(event.target) && !(event.relatedTarget && this._getCellFromElement(event.relatedTarget))) {
          this._ngZone.run(() => this.previewChange.emit({
            value: null,
            event
          }));
        }
      }
    };
    /**
     * Triggered on mousedown or touchstart on a date cell.
     * Respsonsible for starting a drag sequence.
     */
    _mousedownHandler = event => {
      if (!this.isRange) return;
      this._didDragSinceMouseDown = false;
      // Begin a drag if a cell within the current range was targeted.
      const cell = event.target && this._getCellFromElement(event.target);
      if (!cell || !this._isInRange(cell.compareValue)) {
        return;
      }
      this._ngZone.run(() => {
        this.dragStarted.emit({
          value: cell.rawValue,
          event
        });
      });
    };
    /** Triggered on mouseup anywhere. Respsonsible for ending a drag sequence. */
    _mouseupHandler = event => {
      if (!this.isRange) return;
      const cellElement = getCellElement(event.target);
      if (!cellElement) {
        // Mouseup happened outside of datepicker. Cancel drag.
        this._ngZone.run(() => {
          this.dragEnded.emit({
            value: null,
            event
          });
        });
        return;
      }
      if (cellElement.closest('.mat-calendar-body') !== this._elementRef.nativeElement) {
        // Mouseup happened inside a different month instance.
        // Allow it to handle the event.
        return;
      }
      this._ngZone.run(() => {
        const cell = this._getCellFromElement(cellElement);
        this.dragEnded.emit({
          value: cell?.rawValue ?? null,
          event
        });
      });
    };
    /** Triggered on touchend anywhere. Respsonsible for ending a drag sequence. */
    _touchendHandler = event => {
      const target = getActualTouchTarget(event);
      if (target) {
        this._mouseupHandler({
          target
        });
      }
    };
    /** Finds the MatCalendarCell that corresponds to a DOM node. */
    _getCellFromElement(element) {
      const cell = getCellElement(element);
      if (cell) {
        const row = cell.getAttribute('data-mat-row');
        const col = cell.getAttribute('data-mat-col');
        if (row && col) {
          return this.rows[parseInt(row)][parseInt(col)];
        }
      }
      return null;
    }
    static ɵfac = function MatCalendarBody_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCalendarBody)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatCalendarBody,
      selectors: [["", "mat-calendar-body", ""]],
      hostAttrs: [1, "mat-calendar-body"],
      inputs: {
        label: "label",
        rows: "rows",
        todayValue: "todayValue",
        startValue: "startValue",
        endValue: "endValue",
        labelMinRequiredCells: "labelMinRequiredCells",
        numCols: "numCols",
        activeCell: "activeCell",
        isRange: "isRange",
        cellAspectRatio: "cellAspectRatio",
        comparisonStart: "comparisonStart",
        comparisonEnd: "comparisonEnd",
        previewStart: "previewStart",
        previewEnd: "previewEnd",
        startDateAccessibleName: "startDateAccessibleName",
        endDateAccessibleName: "endDateAccessibleName"
      },
      outputs: {
        selectedValueChange: "selectedValueChange",
        previewChange: "previewChange",
        activeDateChange: "activeDateChange",
        dragStarted: "dragStarted",
        dragEnded: "dragEnded"
      },
      exportAs: ["matCalendarBody"],
      features: [i0.ɵɵNgOnChangesFeature],
      attrs: _c0,
      decls: 11,
      vars: 11,
      consts: [["aria-hidden", "true"], ["role", "row"], [1, "mat-calendar-body-hidden-label", 3, "id"], [1, "mat-calendar-body-label"], [1, "mat-calendar-body-label", 3, "paddingTop", "paddingBottom"], ["role", "gridcell", 1, "mat-calendar-body-cell-container", 3, "width", "paddingTop", "paddingBottom"], ["role", "gridcell", 1, "mat-calendar-body-cell-container"], ["type", "button", 1, "mat-calendar-body-cell", 3, "click", "focus", "ngClass", "tabindex"], [1, "mat-calendar-body-cell-content", "mat-focus-indicator"], ["aria-hidden", "true", 1, "mat-calendar-body-cell-preview"]],
      template: function MatCalendarBody_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵconditionalCreate(0, MatCalendarBody_Conditional_0_Template, 3, 6, "tr", 0);
          i0.ɵɵrepeaterCreate(1, MatCalendarBody_For_2_Template, 4, 1, "tr", 1, _forTrack0, true);
          i0.ɵɵelementStart(3, "span", 2);
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "span", 2);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "span", 2);
          i0.ɵɵtext(8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(9, "span", 2);
          i0.ɵɵtext(10);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx._firstRowOffset < ctx.labelMinRequiredCells ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵrepeater(ctx.rows);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("id", ctx._startDateLabelId);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.startDateAccessibleName, "\n");
          i0.ɵɵadvance();
          i0.ɵɵproperty("id", ctx._endDateLabelId);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate1(" ", ctx.endDateAccessibleName, "\n");
          i0.ɵɵadvance();
          i0.ɵɵproperty("id", ctx._comparisonStartDateLabelId);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate2(" ", ctx.comparisonDateAccessibleName, " ", ctx.startDateAccessibleName, "\n");
          i0.ɵɵadvance();
          i0.ɵɵproperty("id", ctx._comparisonEndDateLabelId);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate2(" ", ctx.comparisonDateAccessibleName, " ", ctx.endDateAccessibleName, "\n");
        }
      },
      dependencies: [NgClass],
      styles: [".mat-calendar-body{min-width:224px}.mat-calendar-body-today:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){border-color:var(--mat-datepicker-calendar-date-today-outline-color, var(--mat-sys-primary))}.mat-calendar-body-label{height:0;line-height:0;text-align:start;padding-left:4.7142857143%;padding-right:4.7142857143%;font-size:var(--mat-datepicker-calendar-body-label-text-size, var(--mat-sys-title-small-size));font-weight:var(--mat-datepicker-calendar-body-label-text-weight, var(--mat-sys-title-small-weight));color:var(--mat-datepicker-calendar-body-label-text-color, var(--mat-sys-on-surface))}.mat-calendar-body-hidden-label{display:none}.mat-calendar-body-cell-container{position:relative;height:0;line-height:0}.mat-calendar-body-cell{position:absolute;top:0;left:0;width:100%;height:100%;background:none;text-align:center;outline:none;margin:0;font-family:var(--mat-datepicker-calendar-text-font, var(--mat-sys-body-medium-font));font-size:var(--mat-datepicker-calendar-text-size, var(--mat-sys-body-medium-size));-webkit-user-select:none;user-select:none;cursor:pointer;outline:none;border:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.mat-calendar-body-cell::-moz-focus-inner{border:0}.mat-calendar-body-cell::before,.mat-calendar-body-cell::after,.mat-calendar-body-cell-preview{content:\"\";position:absolute;top:5%;left:0;z-index:0;box-sizing:border-box;display:block;height:90%;width:100%}.mat-calendar-body-range-start:not(.mat-calendar-body-in-comparison-range)::before,.mat-calendar-body-range-start::after,.mat-calendar-body-comparison-start:not(.mat-calendar-body-comparison-bridge-start)::before,.mat-calendar-body-comparison-start::after,.mat-calendar-body-preview-start .mat-calendar-body-cell-preview{left:5%;width:95%;border-top-left-radius:999px;border-bottom-left-radius:999px}[dir=rtl] .mat-calendar-body-range-start:not(.mat-calendar-body-in-comparison-range)::before,[dir=rtl] .mat-calendar-body-range-start::after,[dir=rtl] .mat-calendar-body-comparison-start:not(.mat-calendar-body-comparison-bridge-start)::before,[dir=rtl] .mat-calendar-body-comparison-start::after,[dir=rtl] .mat-calendar-body-preview-start .mat-calendar-body-cell-preview{left:0;border-radius:0;border-top-right-radius:999px;border-bottom-right-radius:999px}.mat-calendar-body-range-end:not(.mat-calendar-body-in-comparison-range)::before,.mat-calendar-body-range-end::after,.mat-calendar-body-comparison-end:not(.mat-calendar-body-comparison-bridge-end)::before,.mat-calendar-body-comparison-end::after,.mat-calendar-body-preview-end .mat-calendar-body-cell-preview{width:95%;border-top-right-radius:999px;border-bottom-right-radius:999px}[dir=rtl] .mat-calendar-body-range-end:not(.mat-calendar-body-in-comparison-range)::before,[dir=rtl] .mat-calendar-body-range-end::after,[dir=rtl] .mat-calendar-body-comparison-end:not(.mat-calendar-body-comparison-bridge-end)::before,[dir=rtl] .mat-calendar-body-comparison-end::after,[dir=rtl] .mat-calendar-body-preview-end .mat-calendar-body-cell-preview{left:5%;border-radius:0;border-top-left-radius:999px;border-bottom-left-radius:999px}[dir=rtl] .mat-calendar-body-comparison-bridge-start.mat-calendar-body-range-end::after,[dir=rtl] .mat-calendar-body-comparison-bridge-end.mat-calendar-body-range-start::after{width:95%;border-top-right-radius:999px;border-bottom-right-radius:999px}.mat-calendar-body-comparison-start.mat-calendar-body-range-end::after,[dir=rtl] .mat-calendar-body-comparison-start.mat-calendar-body-range-end::after,.mat-calendar-body-comparison-end.mat-calendar-body-range-start::after,[dir=rtl] .mat-calendar-body-comparison-end.mat-calendar-body-range-start::after{width:90%}.mat-calendar-body-in-preview{color:var(--mat-datepicker-calendar-date-preview-state-outline-color, var(--mat-sys-primary))}.mat-calendar-body-in-preview .mat-calendar-body-cell-preview{border-top:dashed 1px;border-bottom:dashed 1px}.mat-calendar-body-preview-start .mat-calendar-body-cell-preview{border-left:dashed 1px}[dir=rtl] .mat-calendar-body-preview-start .mat-calendar-body-cell-preview{border-left:0;border-right:dashed 1px}.mat-calendar-body-preview-end .mat-calendar-body-cell-preview{border-right:dashed 1px}[dir=rtl] .mat-calendar-body-preview-end .mat-calendar-body-cell-preview{border-right:0;border-left:dashed 1px}.mat-calendar-body-disabled{cursor:default}.mat-calendar-body-disabled>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){color:var(--mat-datepicker-calendar-date-disabled-state-text-color, color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent))}.mat-calendar-body-disabled>.mat-calendar-body-today:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){border-color:var(--mat-datepicker-calendar-date-today-disabled-state-outline-color, color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent))}@media(forced-colors: active){.mat-calendar-body-disabled{opacity:.5}}.mat-calendar-body-cell-content{top:5%;left:5%;z-index:1;display:flex;align-items:center;justify-content:center;box-sizing:border-box;width:90%;height:90%;line-height:1;border-width:1px;border-style:solid;border-radius:999px;color:var(--mat-datepicker-calendar-date-text-color, var(--mat-sys-on-surface));border-color:var(--mat-datepicker-calendar-date-outline-color, transparent)}.mat-calendar-body-cell-content.mat-focus-indicator{position:absolute}@media(forced-colors: active){.mat-calendar-body-cell-content{border:none}}.cdk-keyboard-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical),.cdk-program-focused .mat-calendar-body-active>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:var(--mat-datepicker-calendar-date-focus-state-background-color, color-mix(in srgb, var(--mat-sys-on-surface) calc(var(--mat-sys-focus-state-layer-opacity) * 100%), transparent))}@media(hover: hover){.mat-calendar-body-cell:not(.mat-calendar-body-disabled):hover>.mat-calendar-body-cell-content:not(.mat-calendar-body-selected):not(.mat-calendar-body-comparison-identical){background-color:var(--mat-datepicker-calendar-date-hover-state-background-color, color-mix(in srgb, var(--mat-sys-on-surface) calc(var(--mat-sys-hover-state-layer-opacity) * 100%), transparent))}}.mat-calendar-body-selected{background-color:var(--mat-datepicker-calendar-date-selected-state-background-color, var(--mat-sys-primary));color:var(--mat-datepicker-calendar-date-selected-state-text-color, var(--mat-sys-on-primary))}.mat-calendar-body-disabled>.mat-calendar-body-selected{background-color:var(--mat-datepicker-calendar-date-selected-disabled-state-background-color, color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent))}.mat-calendar-body-selected.mat-calendar-body-today{box-shadow:inset 0 0 0 1px var(--mat-datepicker-calendar-date-today-selected-state-outline-color, var(--mat-sys-primary))}.mat-calendar-body-in-range::before{background:var(--mat-datepicker-calendar-date-in-range-state-background-color, var(--mat-sys-primary-container))}.mat-calendar-body-comparison-identical,.mat-calendar-body-in-comparison-range::before{background:var(--mat-datepicker-calendar-date-in-comparison-range-state-background-color, var(--mat-sys-tertiary-container))}.mat-calendar-body-comparison-identical,.mat-calendar-body-in-comparison-range::before{background:var(--mat-datepicker-calendar-date-in-comparison-range-state-background-color, var(--mat-sys-tertiary-container))}.mat-calendar-body-comparison-bridge-start::before,[dir=rtl] .mat-calendar-body-comparison-bridge-end::before{background:linear-gradient(to right, var(--mat-datepicker-calendar-date-in-range-state-background-color, var(--mat-sys-primary-container)) 50%, var(--mat-datepicker-calendar-date-in-comparison-range-state-background-color, var(--mat-sys-tertiary-container)) 50%)}.mat-calendar-body-comparison-bridge-end::before,[dir=rtl] .mat-calendar-body-comparison-bridge-start::before{background:linear-gradient(to left, var(--mat-datepicker-calendar-date-in-range-state-background-color, var(--mat-sys-primary-container)) 50%, var(--mat-datepicker-calendar-date-in-comparison-range-state-background-color, var(--mat-sys-tertiary-container)) 50%)}.mat-calendar-body-in-range>.mat-calendar-body-comparison-identical,.mat-calendar-body-in-comparison-range.mat-calendar-body-in-range::after{background:var(--mat-datepicker-calendar-date-in-overlap-range-state-background-color, var(--mat-sys-secondary-container))}.mat-calendar-body-comparison-identical.mat-calendar-body-selected,.mat-calendar-body-in-comparison-range>.mat-calendar-body-selected{background:var(--mat-datepicker-calendar-date-in-overlap-range-selected-state-background-color, var(--mat-sys-secondary))}@media(forced-colors: active){.mat-datepicker-popup:not(:empty),.mat-calendar-body-cell:not(.mat-calendar-body-in-range) .mat-calendar-body-selected{outline:solid 1px}.mat-calendar-body-today{outline:dotted 1px}.mat-calendar-body-cell::before,.mat-calendar-body-cell::after,.mat-calendar-body-selected{background:none}.mat-calendar-body-in-range::before,.mat-calendar-body-comparison-bridge-start::before,.mat-calendar-body-comparison-bridge-end::before{border-top:solid 1px;border-bottom:solid 1px}.mat-calendar-body-range-start::before{border-left:solid 1px}[dir=rtl] .mat-calendar-body-range-start::before{border-left:0;border-right:solid 1px}.mat-calendar-body-range-end::before{border-right:solid 1px}[dir=rtl] .mat-calendar-body-range-end::before{border-right:0;border-left:solid 1px}.mat-calendar-body-in-comparison-range::before{border-top:dashed 1px;border-bottom:dashed 1px}.mat-calendar-body-comparison-start::before{border-left:dashed 1px}[dir=rtl] .mat-calendar-body-comparison-start::before{border-left:0;border-right:dashed 1px}.mat-calendar-body-comparison-end::before{border-right:dashed 1px}[dir=rtl] .mat-calendar-body-comparison-end::before{border-right:0;border-left:dashed 1px}}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatCalendarBody;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** Checks whether a node is a table cell element. */
function isTableCell(node) {
  return node?.nodeName === 'TD';
}
/**
 * Gets the date table cell element that is or contains the specified element.
 * Or returns null if element is not part of a date cell.
 */
function getCellElement(element) {
  let cell;
  if (isTableCell(element)) {
    cell = element;
  } else if (isTableCell(element.parentNode)) {
    cell = element.parentNode;
  } else if (isTableCell(element.parentNode?.parentNode)) {
    cell = element.parentNode.parentNode;
  }
  return cell?.getAttribute('data-mat-row') != null ? cell : null;
}
/** Checks whether a value is the start of a range. */
function isStart(value, start, end) {
  return end !== null && start !== end && value < end && value === start;
}
/** Checks whether a value is the end of a range. */
function isEnd(value, start, end) {
  return start !== null && start !== end && value >= start && value === end;
}
/** Checks whether a value is inside of a range. */
function isInRange(value, start, end, rangeEnabled) {
  return rangeEnabled && start !== null && end !== null && start !== end && value >= start && value <= end;
}
/**
 * Extracts the element that actually corresponds to a touch event's location
 * (rather than the element that initiated the sequence of touch events).
 */
function getActualTouchTarget(event) {
  const touchLocation = event.changedTouches[0];
  return document.elementFromPoint(touchLocation.clientX, touchLocation.clientY);
}

/** A class representing a range of dates. */
class DateRange {
  start;
  end;
  /**
   * Ensures that objects with a `start` and `end` property can't be assigned to a variable that
   * expects a `DateRange`
   */
  // tslint:disable-next-line:no-unused-variable
  _disableStructuralEquivalency;
  constructor(/** The start date of the range. */
  start, /** The end date of the range. */
  end) {
    this.start = start;
    this.end = end;
  }
}
/**
 * A selection model containing a date selection.
 * @docs-private
 */
let MatDateSelectionModel = /*#__PURE__*/(() => {
  class MatDateSelectionModel {
    selection;
    _adapter;
    _selectionChanged = new Subject();
    /** Emits when the selection has changed. */
    selectionChanged = this._selectionChanged;
    constructor(/** The current selection. */
    selection, _adapter) {
      this.selection = selection;
      this._adapter = _adapter;
      this.selection = selection;
    }
    /**
     * Updates the current selection in the model.
     * @param value New selection that should be assigned.
     * @param source Object that triggered the selection change.
     */
    updateSelection(value, source) {
      const oldValue = this.selection;
      this.selection = value;
      this._selectionChanged.next({
        selection: value,
        source,
        oldValue
      });
    }
    ngOnDestroy() {
      this._selectionChanged.complete();
    }
    _isValidDateInstance(date) {
      return this._adapter.isDateInstance(date) && this._adapter.isValid(date);
    }
    static ɵfac = function MatDateSelectionModel_Factory(__ngFactoryType__) {
      i0.ɵɵinvalidFactory();
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MatDateSelectionModel,
      factory: MatDateSelectionModel.ɵfac
    });
  }
  return MatDateSelectionModel;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * A selection model that contains a single date.
 * @docs-private
 */
let MatSingleDateSelectionModel = /*#__PURE__*/(() => {
  class MatSingleDateSelectionModel extends MatDateSelectionModel {
    constructor(adapter) {
      super(null, adapter);
    }
    /**
     * Adds a date to the current selection. In the case of a single date selection, the added date
     * simply overwrites the previous selection
     */
    add(date) {
      super.updateSelection(date, this);
    }
    /** Checks whether the current selection is valid. */
    isValid() {
      return this.selection != null && this._isValidDateInstance(this.selection);
    }
    /**
     * Checks whether the current selection is complete. In the case of a single date selection, this
     * is true if the current selection is not null.
     */
    isComplete() {
      return this.selection != null;
    }
    /** Clones the selection model. */
    clone() {
      const clone = new MatSingleDateSelectionModel(this._adapter);
      clone.updateSelection(this.selection, this);
      return clone;
    }
    static ɵfac = function MatSingleDateSelectionModel_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatSingleDateSelectionModel)(i0.ɵɵinject(DateAdapter));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MatSingleDateSelectionModel,
      factory: MatSingleDateSelectionModel.ɵfac
    });
  }
  return MatSingleDateSelectionModel;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * A selection model that contains a date range.
 * @docs-private
 */
let MatRangeDateSelectionModel = /*#__PURE__*/(() => {
  class MatRangeDateSelectionModel extends MatDateSelectionModel {
    constructor(adapter) {
      super(new DateRange(null, null), adapter);
    }
    /**
     * Adds a date to the current selection. In the case of a date range selection, the added date
     * fills in the next `null` value in the range. If both the start and the end already have a date,
     * the selection is reset so that the given date is the new `start` and the `end` is null.
     */
    add(date) {
      let {
        start,
        end
      } = this.selection;
      if (start == null) {
        start = date;
      } else if (end == null) {
        end = date;
      } else {
        start = date;
        end = null;
      }
      super.updateSelection(new DateRange(start, end), this);
    }
    /** Checks whether the current selection is valid. */
    isValid() {
      const {
        start,
        end
      } = this.selection;
      // Empty ranges are valid.
      if (start == null && end == null) {
        return true;
      }
      // Complete ranges are only valid if both dates are valid and the start is before the end.
      if (start != null && end != null) {
        return this._isValidDateInstance(start) && this._isValidDateInstance(end) && this._adapter.compareDate(start, end) <= 0;
      }
      // Partial ranges are valid if the start/end is valid.
      return (start == null || this._isValidDateInstance(start)) && (end == null || this._isValidDateInstance(end));
    }
    /**
     * Checks whether the current selection is complete. In the case of a date range selection, this
     * is true if the current selection has a non-null `start` and `end`.
     */
    isComplete() {
      return this.selection.start != null && this.selection.end != null;
    }
    /** Clones the selection model. */
    clone() {
      const clone = new MatRangeDateSelectionModel(this._adapter);
      clone.updateSelection(this.selection, this);
      return clone;
    }
    static ɵfac = function MatRangeDateSelectionModel_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatRangeDateSelectionModel)(i0.ɵɵinject(DateAdapter));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: MatRangeDateSelectionModel,
      factory: MatRangeDateSelectionModel.ɵfac
    });
  }
  return MatRangeDateSelectionModel;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @docs-private
 * @deprecated No longer used, will be removed.
 * @breaking-change 21.0.0
 */
function MAT_SINGLE_DATE_SELECTION_MODEL_FACTORY(parent, adapter) {
  return parent || new MatSingleDateSelectionModel(adapter);
}
/**
 * Used to provide a single selection model to a component.
 * @docs-private
 * @deprecated No longer used, will be removed.
 * @breaking-change 21.0.0
 */
const MAT_SINGLE_DATE_SELECTION_MODEL_PROVIDER = {
  provide: MatDateSelectionModel,
  deps: [[/*#__PURE__*/new Optional(), /*#__PURE__*/new SkipSelf(), MatDateSelectionModel], DateAdapter],
  useFactory: MAT_SINGLE_DATE_SELECTION_MODEL_FACTORY
};
/**
 * @docs-private
 * @deprecated No longer used, will be removed.
 * @breaking-change 21.0.0
 */
function MAT_RANGE_DATE_SELECTION_MODEL_FACTORY(parent, adapter) {
  return parent || new MatRangeDateSelectionModel(adapter);
}
/**
 * Used to provide a range selection model to a component.
 * @docs-private
 * @deprecated No longer used, will be removed.
 * @breaking-change 21.0.0
 */
const MAT_RANGE_DATE_SELECTION_MODEL_PROVIDER = {
  provide: MatDateSelectionModel,
  deps: [[/*#__PURE__*/new Optional(), /*#__PURE__*/new SkipSelf(), MatDateSelectionModel], DateAdapter],
  useFactory: MAT_RANGE_DATE_SELECTION_MODEL_FACTORY
};

/** Injection token used to customize the date range selection behavior. */
const MAT_DATE_RANGE_SELECTION_STRATEGY = /*#__PURE__*/new InjectionToken('MAT_DATE_RANGE_SELECTION_STRATEGY');
/** Provides the default date range selection behavior. */
let DefaultMatCalendarRangeStrategy = /*#__PURE__*/(() => {
  class DefaultMatCalendarRangeStrategy {
    _dateAdapter;
    constructor(_dateAdapter) {
      this._dateAdapter = _dateAdapter;
    }
    selectionFinished(date, currentRange) {
      let {
        start,
        end
      } = currentRange;
      if (start == null) {
        start = date;
      } else if (end == null && date && this._dateAdapter.compareDate(date, start) >= 0) {
        end = date;
      } else {
        start = date;
        end = null;
      }
      return new DateRange(start, end);
    }
    createPreview(activeDate, currentRange) {
      let start = null;
      let end = null;
      if (currentRange.start && !currentRange.end && activeDate) {
        start = currentRange.start;
        end = activeDate;
      }
      return new DateRange(start, end);
    }
    createDrag(dragOrigin, originalRange, newDate) {
      let start = originalRange.start;
      let end = originalRange.end;
      if (!start || !end) {
        // Can't drag from an incomplete range.
        return null;
      }
      const adapter = this._dateAdapter;
      const isRange = adapter.compareDate(start, end) !== 0;
      const diffYears = adapter.getYear(newDate) - adapter.getYear(dragOrigin);
      const diffMonths = adapter.getMonth(newDate) - adapter.getMonth(dragOrigin);
      const diffDays = adapter.getDate(newDate) - adapter.getDate(dragOrigin);
      if (isRange && adapter.sameDate(dragOrigin, originalRange.start)) {
        start = newDate;
        if (adapter.compareDate(newDate, end) > 0) {
          end = adapter.addCalendarYears(end, diffYears);
          end = adapter.addCalendarMonths(end, diffMonths);
          end = adapter.addCalendarDays(end, diffDays);
        }
      } else if (isRange && adapter.sameDate(dragOrigin, originalRange.end)) {
        end = newDate;
        if (adapter.compareDate(newDate, start) < 0) {
          start = adapter.addCalendarYears(start, diffYears);
          start = adapter.addCalendarMonths(start, diffMonths);
          start = adapter.addCalendarDays(start, diffDays);
        }
      } else {
        start = adapter.addCalendarYears(start, diffYears);
        start = adapter.addCalendarMonths(start, diffMonths);
        start = adapter.addCalendarDays(start, diffDays);
        end = adapter.addCalendarYears(end, diffYears);
        end = adapter.addCalendarMonths(end, diffMonths);
        end = adapter.addCalendarDays(end, diffDays);
      }
      return new DateRange(start, end);
    }
    static ɵfac = function DefaultMatCalendarRangeStrategy_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DefaultMatCalendarRangeStrategy)(i0.ɵɵinject(DateAdapter));
    };
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: DefaultMatCalendarRangeStrategy,
      factory: DefaultMatCalendarRangeStrategy.ɵfac
    });
  }
  return DefaultMatCalendarRangeStrategy;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * @docs-private
 * @deprecated No longer used, will be removed.
 * @breaking-change 21.0.0
 */
function MAT_CALENDAR_RANGE_STRATEGY_PROVIDER_FACTORY(parent, adapter) {
  return parent || new DefaultMatCalendarRangeStrategy(adapter);
}
/**
 * @docs-private
 * @deprecated No longer used, will be removed.
 * @breaking-change 21.0.0
 */
const MAT_CALENDAR_RANGE_STRATEGY_PROVIDER = {
  provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
  deps: [[/*#__PURE__*/new Optional(), /*#__PURE__*/new SkipSelf(), MAT_DATE_RANGE_SELECTION_STRATEGY], DateAdapter],
  useFactory: MAT_CALENDAR_RANGE_STRATEGY_PROVIDER_FACTORY
};
const DAYS_PER_WEEK = 7;
let uniqueIdCounter = 0;
/**
 * An internal component used to display a single month in the datepicker.
 * @docs-private
 */
let MatMonthView = /*#__PURE__*/(() => {
  class MatMonthView {
    _changeDetectorRef = inject(ChangeDetectorRef);
    _dateFormats = inject(MAT_DATE_FORMATS, {
      optional: true
    });
    _dateAdapter = inject(DateAdapter, {
      optional: true
    });
    _dir = inject(Directionality, {
      optional: true
    });
    _rangeStrategy = inject(MAT_DATE_RANGE_SELECTION_STRATEGY, {
      optional: true
    });
    _rerenderSubscription = Subscription.EMPTY;
    /** Flag used to filter out space/enter keyup events that originated outside of the view. */
    _selectionKeyPressed;
    /**
     * The date to display in this month view (everything other than the month and year is ignored).
     */
    get activeDate() {
      return this._activeDate;
    }
    set activeDate(value) {
      const oldActiveDate = this._activeDate;
      const validDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
      this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
      if (!this._hasSameMonthAndYear(oldActiveDate, this._activeDate)) {
        this._init();
      }
    }
    _activeDate;
    /** The currently selected date. */
    get selected() {
      return this._selected;
    }
    set selected(value) {
      if (value instanceof DateRange) {
        this._selected = value;
      } else {
        this._selected = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
      }
      this._setRanges(this._selected);
    }
    _selected;
    /** The minimum selectable date. */
    get minDate() {
      return this._minDate;
    }
    set minDate(value) {
      this._minDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _minDate;
    /** The maximum selectable date. */
    get maxDate() {
      return this._maxDate;
    }
    set maxDate(value) {
      this._maxDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _maxDate;
    /** Function used to filter which dates are selectable. */
    dateFilter;
    /** Function that can be used to add custom CSS classes to dates. */
    dateClass;
    /** Start of the comparison range. */
    comparisonStart;
    /** End of the comparison range. */
    comparisonEnd;
    /** ARIA Accessible name of the `<input matStartDate/>` */
    startDateAccessibleName;
    /** ARIA Accessible name of the `<input matEndDate/>` */
    endDateAccessibleName;
    /** Origin of active drag, or null when dragging is not active. */
    activeDrag = null;
    /** Emits when a new date is selected. */
    selectedChange = new EventEmitter();
    /** Emits when any date is selected. */
    _userSelection = new EventEmitter();
    /** Emits when the user initiates a date range drag via mouse or touch. */
    dragStarted = new EventEmitter();
    /**
     * Emits when the user completes or cancels a date range drag.
     * Emits null when the drag was canceled or the newly selected date range if completed.
     */
    dragEnded = new EventEmitter();
    /** Emits when any date is activated. */
    activeDateChange = new EventEmitter();
    /** The body of calendar table */
    _matCalendarBody;
    /** The label for this month (e.g. "January 2017"). */
    _monthLabel;
    /** Grid of calendar cells representing the dates of the month. */
    _weeks;
    /** The number of blank cells in the first row before the 1st of the month. */
    _firstWeekOffset;
    /** Start value of the currently-shown date range. */
    _rangeStart;
    /** End value of the currently-shown date range. */
    _rangeEnd;
    /** Start value of the currently-shown comparison date range. */
    _comparisonRangeStart;
    /** End value of the currently-shown comparison date range. */
    _comparisonRangeEnd;
    /** Start of the preview range. */
    _previewStart;
    /** End of the preview range. */
    _previewEnd;
    /** Whether the user is currently selecting a range of dates. */
    _isRange;
    /** The date of the month that today falls on. Null if today is in another month. */
    _todayDate;
    /** The names of the weekdays. */
    _weekdays;
    constructor() {
      inject(_CdkPrivateStyleLoader).load(_VisuallyHiddenLoader);
      if (typeof ngDevMode === 'undefined' || ngDevMode) {
        if (!this._dateAdapter) {
          throw createMissingDateImplError('DateAdapter');
        }
        if (!this._dateFormats) {
          throw createMissingDateImplError('MAT_DATE_FORMATS');
        }
      }
      this._activeDate = this._dateAdapter.today();
    }
    ngAfterContentInit() {
      this._rerenderSubscription = this._dateAdapter.localeChanges.pipe(startWith(null)).subscribe(() => this._init());
    }
    ngOnChanges(changes) {
      const comparisonChange = changes['comparisonStart'] || changes['comparisonEnd'];
      if (comparisonChange && !comparisonChange.firstChange) {
        this._setRanges(this.selected);
      }
      if (changes['activeDrag'] && !this.activeDrag) {
        this._clearPreview();
      }
    }
    ngOnDestroy() {
      this._rerenderSubscription.unsubscribe();
    }
    /** Handles when a new date is selected. */
    _dateSelected(event) {
      const date = event.value;
      const selectedDate = this._getDateFromDayOfMonth(date);
      let rangeStartDate;
      let rangeEndDate;
      if (this._selected instanceof DateRange) {
        rangeStartDate = this._getDateInCurrentMonth(this._selected.start);
        rangeEndDate = this._getDateInCurrentMonth(this._selected.end);
      } else {
        rangeStartDate = rangeEndDate = this._getDateInCurrentMonth(this._selected);
      }
      if (rangeStartDate !== date || rangeEndDate !== date) {
        this.selectedChange.emit(selectedDate);
      }
      this._userSelection.emit({
        value: selectedDate,
        event: event.event
      });
      this._clearPreview();
      this._changeDetectorRef.markForCheck();
    }
    /**
     * Takes the index of a calendar body cell wrapped in an event as argument. For the date that
     * corresponds to the given cell, set `activeDate` to that date and fire `activeDateChange` with
     * that date.
     *
     * This function is used to match each component's model of the active date with the calendar
     * body cell that was focused. It updates its value of `activeDate` synchronously and updates the
     * parent's value asynchronously via the `activeDateChange` event. The child component receives an
     * updated value asynchronously via the `activeCell` Input.
     */
    _updateActiveDate(event) {
      const month = event.value;
      const oldActiveDate = this._activeDate;
      this.activeDate = this._getDateFromDayOfMonth(month);
      if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
        this.activeDateChange.emit(this._activeDate);
      }
    }
    /** Handles keydown events on the calendar body when calendar is in month view. */
    _handleCalendarBodyKeydown(event) {
      // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
      // disabled ones from being selected. This may not be ideal, we should look into whether
      // navigation should skip over disabled dates, and if so, how to implement that efficiently.
      const oldActiveDate = this._activeDate;
      const isRtl = this._isRtl();
      switch (event.keyCode) {
        case LEFT_ARROW:
          this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, isRtl ? 1 : -1);
          break;
        case RIGHT_ARROW:
          this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, isRtl ? -1 : 1);
          break;
        case UP_ARROW:
          this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, -7);
          break;
        case DOWN_ARROW:
          this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 7);
          break;
        case HOME:
          this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, 1 - this._dateAdapter.getDate(this._activeDate));
          break;
        case END:
          this.activeDate = this._dateAdapter.addCalendarDays(this._activeDate, this._dateAdapter.getNumDaysInMonth(this._activeDate) - this._dateAdapter.getDate(this._activeDate));
          break;
        case PAGE_UP:
          this.activeDate = event.altKey ? this._dateAdapter.addCalendarYears(this._activeDate, -1) : this._dateAdapter.addCalendarMonths(this._activeDate, -1);
          break;
        case PAGE_DOWN:
          this.activeDate = event.altKey ? this._dateAdapter.addCalendarYears(this._activeDate, 1) : this._dateAdapter.addCalendarMonths(this._activeDate, 1);
          break;
        case ENTER:
        case SPACE:
          this._selectionKeyPressed = true;
          if (this._canSelect(this._activeDate)) {
            // Prevent unexpected default actions such as form submission.
            // Note that we only prevent the default action here while the selection happens in
            // `keyup` below. We can't do the selection here, because it can cause the calendar to
            // reopen if focus is restored immediately. We also can't call `preventDefault` on `keyup`
            // because it's too late (see #23305).
            event.preventDefault();
          }
          return;
        case ESCAPE:
          // Abort the current range selection if the user presses escape mid-selection.
          if (this._previewEnd != null && !hasModifierKey(event)) {
            this._clearPreview();
            // If a drag is in progress, cancel the drag without changing the
            // current selection.
            if (this.activeDrag) {
              this.dragEnded.emit({
                value: null,
                event
              });
            } else {
              this.selectedChange.emit(null);
              this._userSelection.emit({
                value: null,
                event
              });
            }
            event.preventDefault();
            event.stopPropagation(); // Prevents the overlay from closing.
          }
          return;
        default:
          // Don't prevent default or focus active cell on keys that we don't explicitly handle.
          return;
      }
      if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
        this.activeDateChange.emit(this.activeDate);
        this._focusActiveCellAfterViewChecked();
      }
      // Prevent unexpected default actions such as form submission.
      event.preventDefault();
    }
    /** Handles keyup events on the calendar body when calendar is in month view. */
    _handleCalendarBodyKeyup(event) {
      if (event.keyCode === SPACE || event.keyCode === ENTER) {
        if (this._selectionKeyPressed && this._canSelect(this._activeDate)) {
          this._dateSelected({
            value: this._dateAdapter.getDate(this._activeDate),
            event
          });
        }
        this._selectionKeyPressed = false;
      }
    }
    /** Initializes this month view. */
    _init() {
      this._setRanges(this.selected);
      this._todayDate = this._getCellCompareValue(this._dateAdapter.today());
      this._monthLabel = this._dateFormats.display.monthLabel ? this._dateAdapter.format(this.activeDate, this._dateFormats.display.monthLabel) : this._dateAdapter.getMonthNames('short')[this._dateAdapter.getMonth(this.activeDate)].toLocaleUpperCase();
      let firstOfMonth = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), 1);
      this._firstWeekOffset = (DAYS_PER_WEEK + this._dateAdapter.getDayOfWeek(firstOfMonth) - this._dateAdapter.getFirstDayOfWeek()) % DAYS_PER_WEEK;
      this._initWeekdays();
      this._createWeekCells();
      this._changeDetectorRef.markForCheck();
    }
    /** Focuses the active cell after the microtask queue is empty. */
    _focusActiveCell(movePreview) {
      this._matCalendarBody._focusActiveCell(movePreview);
    }
    /** Focuses the active cell after change detection has run and the microtask queue is empty. */
    _focusActiveCellAfterViewChecked() {
      this._matCalendarBody._scheduleFocusActiveCellAfterViewChecked();
    }
    /** Called when the user has activated a new cell and the preview needs to be updated. */
    _previewChanged({
      event,
      value: cell
    }) {
      if (this._rangeStrategy) {
        // We can assume that this will be a range, because preview
        // events aren't fired for single date selections.
        const value = cell ? cell.rawValue : null;
        const previewRange = this._rangeStrategy.createPreview(value, this.selected, event);
        this._previewStart = this._getCellCompareValue(previewRange.start);
        this._previewEnd = this._getCellCompareValue(previewRange.end);
        if (this.activeDrag && value) {
          const dragRange = this._rangeStrategy.createDrag?.(this.activeDrag.value, this.selected, value, event);
          if (dragRange) {
            this._previewStart = this._getCellCompareValue(dragRange.start);
            this._previewEnd = this._getCellCompareValue(dragRange.end);
          }
        }
        // Note that here we need to use `detectChanges`, rather than `markForCheck`, because
        // the way `_focusActiveCell` is set up at the moment makes it fire at the wrong time
        // when navigating one month back using the keyboard which will cause this handler
        // to throw a "changed after checked" error when updating the preview state.
        this._changeDetectorRef.detectChanges();
      }
    }
    /**
     * Called when the user has ended a drag. If the drag/drop was successful,
     * computes and emits the new range selection.
     */
    _dragEnded(event) {
      if (!this.activeDrag) return;
      if (event.value) {
        // Propagate drag effect
        const dragDropResult = this._rangeStrategy?.createDrag?.(this.activeDrag.value, this.selected, event.value, event.event);
        this.dragEnded.emit({
          value: dragDropResult ?? null,
          event: event.event
        });
      } else {
        this.dragEnded.emit({
          value: null,
          event: event.event
        });
      }
    }
    /**
     * Takes a day of the month and returns a new date in the same month and year as the currently
     *  active date. The returned date will have the same day of the month as the argument date.
     */
    _getDateFromDayOfMonth(dayOfMonth) {
      return this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), dayOfMonth);
    }
    /** Initializes the weekdays. */
    _initWeekdays() {
      const firstDayOfWeek = this._dateAdapter.getFirstDayOfWeek();
      const narrowWeekdays = this._dateAdapter.getDayOfWeekNames('narrow');
      const longWeekdays = this._dateAdapter.getDayOfWeekNames('long');
      // Rotate the labels for days of the week based on the configured first day of the week.
      let weekdays = longWeekdays.map((long, i) => {
        return {
          long,
          narrow: narrowWeekdays[i],
          id: uniqueIdCounter++
        };
      });
      this._weekdays = weekdays.slice(firstDayOfWeek).concat(weekdays.slice(0, firstDayOfWeek));
    }
    /** Creates MatCalendarCells for the dates in this month. */
    _createWeekCells() {
      const daysInMonth = this._dateAdapter.getNumDaysInMonth(this.activeDate);
      const dateNames = this._dateAdapter.getDateNames();
      this._weeks = [[]];
      for (let i = 0, cell = this._firstWeekOffset; i < daysInMonth; i++, cell++) {
        if (cell == DAYS_PER_WEEK) {
          this._weeks.push([]);
          cell = 0;
        }
        const date = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), this._dateAdapter.getMonth(this.activeDate), i + 1);
        const enabled = this._shouldEnableDate(date);
        const ariaLabel = this._dateAdapter.format(date, this._dateFormats.display.dateA11yLabel);
        const cellClasses = this.dateClass ? this.dateClass(date, 'month') : undefined;
        this._weeks[this._weeks.length - 1].push(new MatCalendarCell(i + 1, dateNames[i], ariaLabel, enabled, cellClasses, this._getCellCompareValue(date), date));
      }
    }
    /** Date filter for the month */
    _shouldEnableDate(date) {
      return !!date && (!this.minDate || this._dateAdapter.compareDate(date, this.minDate) >= 0) && (!this.maxDate || this._dateAdapter.compareDate(date, this.maxDate) <= 0) && (!this.dateFilter || this.dateFilter(date));
    }
    /**
     * Gets the date in this month that the given Date falls on.
     * Returns null if the given Date is in another month.
     */
    _getDateInCurrentMonth(date) {
      return date && this._hasSameMonthAndYear(date, this.activeDate) ? this._dateAdapter.getDate(date) : null;
    }
    /** Checks whether the 2 dates are non-null and fall within the same month of the same year. */
    _hasSameMonthAndYear(d1, d2) {
      return !!(d1 && d2 && this._dateAdapter.getMonth(d1) == this._dateAdapter.getMonth(d2) && this._dateAdapter.getYear(d1) == this._dateAdapter.getYear(d2));
    }
    /** Gets the value that will be used to one cell to another. */
    _getCellCompareValue(date) {
      if (date) {
        // We use the time since the Unix epoch to compare dates in this view, rather than the
        // cell values, because we need to support ranges that span across multiple months/years.
        const year = this._dateAdapter.getYear(date);
        const month = this._dateAdapter.getMonth(date);
        const day = this._dateAdapter.getDate(date);
        return new Date(year, month, day).getTime();
      }
      return null;
    }
    /** Determines whether the user has the RTL layout direction. */
    _isRtl() {
      return this._dir && this._dir.value === 'rtl';
    }
    /** Sets the current range based on a model value. */
    _setRanges(selectedValue) {
      if (selectedValue instanceof DateRange) {
        this._rangeStart = this._getCellCompareValue(selectedValue.start);
        this._rangeEnd = this._getCellCompareValue(selectedValue.end);
        this._isRange = true;
      } else {
        this._rangeStart = this._rangeEnd = this._getCellCompareValue(selectedValue);
        this._isRange = false;
      }
      this._comparisonRangeStart = this._getCellCompareValue(this.comparisonStart);
      this._comparisonRangeEnd = this._getCellCompareValue(this.comparisonEnd);
    }
    /** Gets whether a date can be selected in the month view. */
    _canSelect(date) {
      return !this.dateFilter || this.dateFilter(date);
    }
    /** Clears out preview state. */
    _clearPreview() {
      this._previewStart = this._previewEnd = null;
    }
    static ɵfac = function MatMonthView_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatMonthView)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatMonthView,
      selectors: [["mat-month-view"]],
      viewQuery: function MatMonthView_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatCalendarBody, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._matCalendarBody = _t.first);
        }
      },
      inputs: {
        activeDate: "activeDate",
        selected: "selected",
        minDate: "minDate",
        maxDate: "maxDate",
        dateFilter: "dateFilter",
        dateClass: "dateClass",
        comparisonStart: "comparisonStart",
        comparisonEnd: "comparisonEnd",
        startDateAccessibleName: "startDateAccessibleName",
        endDateAccessibleName: "endDateAccessibleName",
        activeDrag: "activeDrag"
      },
      outputs: {
        selectedChange: "selectedChange",
        _userSelection: "_userSelection",
        dragStarted: "dragStarted",
        dragEnded: "dragEnded",
        activeDateChange: "activeDateChange"
      },
      exportAs: ["matMonthView"],
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 8,
      vars: 14,
      consts: [["role", "grid", 1, "mat-calendar-table"], [1, "mat-calendar-table-header"], ["scope", "col"], ["aria-hidden", "true"], ["colspan", "7", 1, "mat-calendar-table-header-divider"], ["mat-calendar-body", "", 3, "selectedValueChange", "activeDateChange", "previewChange", "dragStarted", "dragEnded", "keyup", "keydown", "label", "rows", "todayValue", "startValue", "endValue", "comparisonStart", "comparisonEnd", "previewStart", "previewEnd", "isRange", "labelMinRequiredCells", "activeCell", "startDateAccessibleName", "endDateAccessibleName"], [1, "cdk-visually-hidden"]],
      template: function MatMonthView_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "table", 0)(1, "thead", 1)(2, "tr");
          i0.ɵɵrepeaterCreate(3, MatMonthView_For_4_Template, 5, 2, "th", 2, _forTrack1);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "tr", 3);
          i0.ɵɵelement(6, "th", 4);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(7, "tbody", 5);
          i0.ɵɵlistener("selectedValueChange", function MatMonthView_Template_tbody_selectedValueChange_7_listener($event) {
            return ctx._dateSelected($event);
          })("activeDateChange", function MatMonthView_Template_tbody_activeDateChange_7_listener($event) {
            return ctx._updateActiveDate($event);
          })("previewChange", function MatMonthView_Template_tbody_previewChange_7_listener($event) {
            return ctx._previewChanged($event);
          })("dragStarted", function MatMonthView_Template_tbody_dragStarted_7_listener($event) {
            return ctx.dragStarted.emit($event);
          })("dragEnded", function MatMonthView_Template_tbody_dragEnded_7_listener($event) {
            return ctx._dragEnded($event);
          })("keyup", function MatMonthView_Template_tbody_keyup_7_listener($event) {
            return ctx._handleCalendarBodyKeyup($event);
          })("keydown", function MatMonthView_Template_tbody_keydown_7_listener($event) {
            return ctx._handleCalendarBodyKeydown($event);
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(3);
          i0.ɵɵrepeater(ctx._weekdays);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("label", ctx._monthLabel)("rows", ctx._weeks)("todayValue", ctx._todayDate)("startValue", ctx._rangeStart)("endValue", ctx._rangeEnd)("comparisonStart", ctx._comparisonRangeStart)("comparisonEnd", ctx._comparisonRangeEnd)("previewStart", ctx._previewStart)("previewEnd", ctx._previewEnd)("isRange", ctx._isRange)("labelMinRequiredCells", 3)("activeCell", ctx._dateAdapter.getDate(ctx.activeDate) - 1)("startDateAccessibleName", ctx.startDateAccessibleName)("endDateAccessibleName", ctx.endDateAccessibleName);
        }
      },
      dependencies: [MatCalendarBody],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatMonthView;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const yearsPerPage = 24;
const yearsPerRow = 4;
/**
 * An internal component used to display a year selector in the datepicker.
 * @docs-private
 */
let MatMultiYearView = /*#__PURE__*/(() => {
  class MatMultiYearView {
    _changeDetectorRef = inject(ChangeDetectorRef);
    _dateAdapter = inject(DateAdapter, {
      optional: true
    });
    _dir = inject(Directionality, {
      optional: true
    });
    _rerenderSubscription = Subscription.EMPTY;
    /** Flag used to filter out space/enter keyup events that originated outside of the view. */
    _selectionKeyPressed;
    /** The date to display in this multi-year view (everything other than the year is ignored). */
    get activeDate() {
      return this._activeDate;
    }
    set activeDate(value) {
      let oldActiveDate = this._activeDate;
      const validDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
      this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
      if (!isSameMultiYearView(this._dateAdapter, oldActiveDate, this._activeDate, this.minDate, this.maxDate)) {
        this._init();
      }
    }
    _activeDate;
    /** The currently selected date. */
    get selected() {
      return this._selected;
    }
    set selected(value) {
      if (value instanceof DateRange) {
        this._selected = value;
      } else {
        this._selected = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
      }
      this._setSelectedYear(value);
    }
    _selected;
    /** The minimum selectable date. */
    get minDate() {
      return this._minDate;
    }
    set minDate(value) {
      this._minDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _minDate;
    /** The maximum selectable date. */
    get maxDate() {
      return this._maxDate;
    }
    set maxDate(value) {
      this._maxDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _maxDate;
    /** A function used to filter which dates are selectable. */
    dateFilter;
    /** Function that can be used to add custom CSS classes to date cells. */
    dateClass;
    /** Emits when a new year is selected. */
    selectedChange = new EventEmitter();
    /** Emits the selected year. This doesn't imply a change on the selected date */
    yearSelected = new EventEmitter();
    /** Emits when any date is activated. */
    activeDateChange = new EventEmitter();
    /** The body of calendar table */
    _matCalendarBody;
    /** Grid of calendar cells representing the currently displayed years. */
    _years;
    /** The year that today falls on. */
    _todayYear;
    /** The year of the selected date. Null if the selected date is null. */
    _selectedYear;
    constructor() {
      if (!this._dateAdapter && (typeof ngDevMode === 'undefined' || ngDevMode)) {
        throw createMissingDateImplError('DateAdapter');
      }
      this._activeDate = this._dateAdapter.today();
    }
    ngAfterContentInit() {
      this._rerenderSubscription = this._dateAdapter.localeChanges.pipe(startWith(null)).subscribe(() => this._init());
    }
    ngOnDestroy() {
      this._rerenderSubscription.unsubscribe();
    }
    /** Initializes this multi-year view. */
    _init() {
      this._todayYear = this._dateAdapter.getYear(this._dateAdapter.today());
      // We want a range years such that we maximize the number of
      // enabled dates visible at once. This prevents issues where the minimum year
      // is the last item of a page OR the maximum year is the first item of a page.
      // The offset from the active year to the "slot" for the starting year is the
      // *actual* first rendered year in the multi-year view.
      const activeYear = this._dateAdapter.getYear(this._activeDate);
      const minYearOfPage = activeYear - getActiveOffset(this._dateAdapter, this.activeDate, this.minDate, this.maxDate);
      this._years = [];
      for (let i = 0, row = []; i < yearsPerPage; i++) {
        row.push(minYearOfPage + i);
        if (row.length == yearsPerRow) {
          this._years.push(row.map(year => this._createCellForYear(year)));
          row = [];
        }
      }
      this._changeDetectorRef.markForCheck();
    }
    /** Handles when a new year is selected. */
    _yearSelected(event) {
      const year = event.value;
      const selectedYear = this._dateAdapter.createDate(year, 0, 1);
      const selectedDate = this._getDateFromYear(year);
      this.yearSelected.emit(selectedYear);
      this.selectedChange.emit(selectedDate);
    }
    /**
     * Takes the index of a calendar body cell wrapped in an event as argument. For the date that
     * corresponds to the given cell, set `activeDate` to that date and fire `activeDateChange` with
     * that date.
     *
     * This function is used to match each component's model of the active date with the calendar
     * body cell that was focused. It updates its value of `activeDate` synchronously and updates the
     * parent's value asynchronously via the `activeDateChange` event. The child component receives an
     * updated value asynchronously via the `activeCell` Input.
     */
    _updateActiveDate(event) {
      const year = event.value;
      const oldActiveDate = this._activeDate;
      this.activeDate = this._getDateFromYear(year);
      if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
        this.activeDateChange.emit(this.activeDate);
      }
    }
    /** Handles keydown events on the calendar body when calendar is in multi-year view. */
    _handleCalendarBodyKeydown(event) {
      const oldActiveDate = this._activeDate;
      const isRtl = this._isRtl();
      switch (event.keyCode) {
        case LEFT_ARROW:
          this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, isRtl ? 1 : -1);
          break;
        case RIGHT_ARROW:
          this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, isRtl ? -1 : 1);
          break;
        case UP_ARROW:
          this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -yearsPerRow);
          break;
        case DOWN_ARROW:
          this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, yearsPerRow);
          break;
        case HOME:
          this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, -getActiveOffset(this._dateAdapter, this.activeDate, this.minDate, this.maxDate));
          break;
        case END:
          this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, yearsPerPage - getActiveOffset(this._dateAdapter, this.activeDate, this.minDate, this.maxDate) - 1);
          break;
        case PAGE_UP:
          this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? -yearsPerPage * 10 : -yearsPerPage);
          break;
        case PAGE_DOWN:
          this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? yearsPerPage * 10 : yearsPerPage);
          break;
        case ENTER:
        case SPACE:
          // Note that we only prevent the default action here while the selection happens in
          // `keyup` below. We can't do the selection here, because it can cause the calendar to
          // reopen if focus is restored immediately. We also can't call `preventDefault` on `keyup`
          // because it's too late (see #23305).
          this._selectionKeyPressed = true;
          break;
        default:
          // Don't prevent default or focus active cell on keys that we don't explicitly handle.
          return;
      }
      if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
        this.activeDateChange.emit(this.activeDate);
      }
      this._focusActiveCellAfterViewChecked();
      // Prevent unexpected default actions such as form submission.
      event.preventDefault();
    }
    /** Handles keyup events on the calendar body when calendar is in multi-year view. */
    _handleCalendarBodyKeyup(event) {
      if (event.keyCode === SPACE || event.keyCode === ENTER) {
        if (this._selectionKeyPressed) {
          this._yearSelected({
            value: this._dateAdapter.getYear(this._activeDate),
            event
          });
        }
        this._selectionKeyPressed = false;
      }
    }
    _getActiveCell() {
      return getActiveOffset(this._dateAdapter, this.activeDate, this.minDate, this.maxDate);
    }
    /** Focuses the active cell after the microtask queue is empty. */
    _focusActiveCell() {
      this._matCalendarBody._focusActiveCell();
    }
    /** Focuses the active cell after change detection has run and the microtask queue is empty. */
    _focusActiveCellAfterViewChecked() {
      this._matCalendarBody._scheduleFocusActiveCellAfterViewChecked();
    }
    /**
     * Takes a year and returns a new date on the same day and month as the currently active date
     *  The returned date will have the same year as the argument date.
     */
    _getDateFromYear(year) {
      const activeMonth = this._dateAdapter.getMonth(this.activeDate);
      const daysInMonth = this._dateAdapter.getNumDaysInMonth(this._dateAdapter.createDate(year, activeMonth, 1));
      const normalizedDate = this._dateAdapter.createDate(year, activeMonth, Math.min(this._dateAdapter.getDate(this.activeDate), daysInMonth));
      return normalizedDate;
    }
    /** Creates an MatCalendarCell for the given year. */
    _createCellForYear(year) {
      const date = this._dateAdapter.createDate(year, 0, 1);
      const yearName = this._dateAdapter.getYearName(date);
      const cellClasses = this.dateClass ? this.dateClass(date, 'multi-year') : undefined;
      return new MatCalendarCell(year, yearName, yearName, this._shouldEnableYear(year), cellClasses);
    }
    /** Whether the given year is enabled. */
    _shouldEnableYear(year) {
      // disable if the year is greater than maxDate lower than minDate
      if (year === undefined || year === null || this.maxDate && year > this._dateAdapter.getYear(this.maxDate) || this.minDate && year < this._dateAdapter.getYear(this.minDate)) {
        return false;
      }
      // enable if it reaches here and there's no filter defined
      if (!this.dateFilter) {
        return true;
      }
      const firstOfYear = this._dateAdapter.createDate(year, 0, 1);
      // If any date in the year is enabled count the year as enabled.
      for (let date = firstOfYear; this._dateAdapter.getYear(date) == year; date = this._dateAdapter.addCalendarDays(date, 1)) {
        if (this.dateFilter(date)) {
          return true;
        }
      }
      return false;
    }
    /** Determines whether the user has the RTL layout direction. */
    _isRtl() {
      return this._dir && this._dir.value === 'rtl';
    }
    /** Sets the currently-highlighted year based on a model value. */
    _setSelectedYear(value) {
      this._selectedYear = null;
      if (value instanceof DateRange) {
        const displayValue = value.start || value.end;
        if (displayValue) {
          this._selectedYear = this._dateAdapter.getYear(displayValue);
        }
      } else if (value) {
        this._selectedYear = this._dateAdapter.getYear(value);
      }
    }
    static ɵfac = function MatMultiYearView_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatMultiYearView)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatMultiYearView,
      selectors: [["mat-multi-year-view"]],
      viewQuery: function MatMultiYearView_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatCalendarBody, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._matCalendarBody = _t.first);
        }
      },
      inputs: {
        activeDate: "activeDate",
        selected: "selected",
        minDate: "minDate",
        maxDate: "maxDate",
        dateFilter: "dateFilter",
        dateClass: "dateClass"
      },
      outputs: {
        selectedChange: "selectedChange",
        yearSelected: "yearSelected",
        activeDateChange: "activeDateChange"
      },
      exportAs: ["matMultiYearView"],
      decls: 5,
      vars: 7,
      consts: [["role", "grid", 1, "mat-calendar-table"], ["aria-hidden", "true", 1, "mat-calendar-table-header"], ["colspan", "4", 1, "mat-calendar-table-header-divider"], ["mat-calendar-body", "", 3, "selectedValueChange", "activeDateChange", "keyup", "keydown", "rows", "todayValue", "startValue", "endValue", "numCols", "cellAspectRatio", "activeCell"]],
      template: function MatMultiYearView_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "table", 0)(1, "thead", 1)(2, "tr");
          i0.ɵɵelement(3, "th", 2);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "tbody", 3);
          i0.ɵɵlistener("selectedValueChange", function MatMultiYearView_Template_tbody_selectedValueChange_4_listener($event) {
            return ctx._yearSelected($event);
          })("activeDateChange", function MatMultiYearView_Template_tbody_activeDateChange_4_listener($event) {
            return ctx._updateActiveDate($event);
          })("keyup", function MatMultiYearView_Template_tbody_keyup_4_listener($event) {
            return ctx._handleCalendarBodyKeyup($event);
          })("keydown", function MatMultiYearView_Template_tbody_keydown_4_listener($event) {
            return ctx._handleCalendarBodyKeydown($event);
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("rows", ctx._years)("todayValue", ctx._todayYear)("startValue", ctx._selectedYear)("endValue", ctx._selectedYear)("numCols", 4)("cellAspectRatio", 4 / 7)("activeCell", ctx._getActiveCell());
        }
      },
      dependencies: [MatCalendarBody],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatMultiYearView;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function isSameMultiYearView(dateAdapter, date1, date2, minDate, maxDate) {
  const year1 = dateAdapter.getYear(date1);
  const year2 = dateAdapter.getYear(date2);
  const startingYear = getStartingYear(dateAdapter, minDate, maxDate);
  return Math.floor((year1 - startingYear) / yearsPerPage) === Math.floor((year2 - startingYear) / yearsPerPage);
}
/**
 * When the multi-year view is first opened, the active year will be in view.
 * So we compute how many years are between the active year and the *slot* where our
 * "startingYear" will render when paged into view.
 */
function getActiveOffset(dateAdapter, activeDate, minDate, maxDate) {
  const activeYear = dateAdapter.getYear(activeDate);
  return euclideanModulo(activeYear - getStartingYear(dateAdapter, minDate, maxDate), yearsPerPage);
}
/**
 * We pick a "starting" year such that either the maximum year would be at the end
 * or the minimum year would be at the beginning of a page.
 */
function getStartingYear(dateAdapter, minDate, maxDate) {
  let startingYear = 0;
  if (maxDate) {
    const maxYear = dateAdapter.getYear(maxDate);
    startingYear = maxYear - yearsPerPage + 1;
  } else if (minDate) {
    startingYear = dateAdapter.getYear(minDate);
  }
  return startingYear;
}
/** Gets remainder that is non-negative, even if first number is negative */
function euclideanModulo(a, b) {
  return (a % b + b) % b;
}

/**
 * An internal component used to display a single year in the datepicker.
 * @docs-private
 */
let MatYearView = /*#__PURE__*/(() => {
  class MatYearView {
    _changeDetectorRef = inject(ChangeDetectorRef);
    _dateFormats = inject(MAT_DATE_FORMATS, {
      optional: true
    });
    _dateAdapter = inject(DateAdapter, {
      optional: true
    });
    _dir = inject(Directionality, {
      optional: true
    });
    _rerenderSubscription = Subscription.EMPTY;
    /** Flag used to filter out space/enter keyup events that originated outside of the view. */
    _selectionKeyPressed;
    /** The date to display in this year view (everything other than the year is ignored). */
    get activeDate() {
      return this._activeDate;
    }
    set activeDate(value) {
      let oldActiveDate = this._activeDate;
      const validDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value)) || this._dateAdapter.today();
      this._activeDate = this._dateAdapter.clampDate(validDate, this.minDate, this.maxDate);
      if (this._dateAdapter.getYear(oldActiveDate) !== this._dateAdapter.getYear(this._activeDate)) {
        this._init();
      }
    }
    _activeDate;
    /** The currently selected date. */
    get selected() {
      return this._selected;
    }
    set selected(value) {
      if (value instanceof DateRange) {
        this._selected = value;
      } else {
        this._selected = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
      }
      this._setSelectedMonth(value);
    }
    _selected;
    /** The minimum selectable date. */
    get minDate() {
      return this._minDate;
    }
    set minDate(value) {
      this._minDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _minDate;
    /** The maximum selectable date. */
    get maxDate() {
      return this._maxDate;
    }
    set maxDate(value) {
      this._maxDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _maxDate;
    /** A function used to filter which dates are selectable. */
    dateFilter;
    /** Function that can be used to add custom CSS classes to date cells. */
    dateClass;
    /** Emits when a new month is selected. */
    selectedChange = new EventEmitter();
    /** Emits the selected month. This doesn't imply a change on the selected date */
    monthSelected = new EventEmitter();
    /** Emits when any date is activated. */
    activeDateChange = new EventEmitter();
    /** The body of calendar table */
    _matCalendarBody;
    /** Grid of calendar cells representing the months of the year. */
    _months;
    /** The label for this year (e.g. "2017"). */
    _yearLabel;
    /** The month in this year that today falls on. Null if today is in a different year. */
    _todayMonth;
    /**
     * The month in this year that the selected Date falls on.
     * Null if the selected Date is in a different year.
     */
    _selectedMonth;
    constructor() {
      if (typeof ngDevMode === 'undefined' || ngDevMode) {
        if (!this._dateAdapter) {
          throw createMissingDateImplError('DateAdapter');
        }
        if (!this._dateFormats) {
          throw createMissingDateImplError('MAT_DATE_FORMATS');
        }
      }
      this._activeDate = this._dateAdapter.today();
    }
    ngAfterContentInit() {
      this._rerenderSubscription = this._dateAdapter.localeChanges.pipe(startWith(null)).subscribe(() => this._init());
    }
    ngOnDestroy() {
      this._rerenderSubscription.unsubscribe();
    }
    /** Handles when a new month is selected. */
    _monthSelected(event) {
      const month = event.value;
      const selectedMonth = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1);
      this.monthSelected.emit(selectedMonth);
      const selectedDate = this._getDateFromMonth(month);
      this.selectedChange.emit(selectedDate);
    }
    /**
     * Takes the index of a calendar body cell wrapped in an event as argument. For the date that
     * corresponds to the given cell, set `activeDate` to that date and fire `activeDateChange` with
     * that date.
     *
     * This function is used to match each component's model of the active date with the calendar
     * body cell that was focused. It updates its value of `activeDate` synchronously and updates the
     * parent's value asynchronously via the `activeDateChange` event. The child component receives an
     * updated value asynchronously via the `activeCell` Input.
     */
    _updateActiveDate(event) {
      const month = event.value;
      const oldActiveDate = this._activeDate;
      this.activeDate = this._getDateFromMonth(month);
      if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
        this.activeDateChange.emit(this.activeDate);
      }
    }
    /** Handles keydown events on the calendar body when calendar is in year view. */
    _handleCalendarBodyKeydown(event) {
      // TODO(mmalerba): We currently allow keyboard navigation to disabled dates, but just prevent
      // disabled ones from being selected. This may not be ideal, we should look into whether
      // navigation should skip over disabled dates, and if so, how to implement that efficiently.
      const oldActiveDate = this._activeDate;
      const isRtl = this._isRtl();
      switch (event.keyCode) {
        case LEFT_ARROW:
          this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, isRtl ? 1 : -1);
          break;
        case RIGHT_ARROW:
          this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, isRtl ? -1 : 1);
          break;
        case UP_ARROW:
          this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -4);
          break;
        case DOWN_ARROW:
          this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 4);
          break;
        case HOME:
          this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, -this._dateAdapter.getMonth(this._activeDate));
          break;
        case END:
          this.activeDate = this._dateAdapter.addCalendarMonths(this._activeDate, 11 - this._dateAdapter.getMonth(this._activeDate));
          break;
        case PAGE_UP:
          this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? -10 : -1);
          break;
        case PAGE_DOWN:
          this.activeDate = this._dateAdapter.addCalendarYears(this._activeDate, event.altKey ? 10 : 1);
          break;
        case ENTER:
        case SPACE:
          // Note that we only prevent the default action here while the selection happens in
          // `keyup` below. We can't do the selection here, because it can cause the calendar to
          // reopen if focus is restored immediately. We also can't call `preventDefault` on `keyup`
          // because it's too late (see #23305).
          this._selectionKeyPressed = true;
          break;
        default:
          // Don't prevent default or focus active cell on keys that we don't explicitly handle.
          return;
      }
      if (this._dateAdapter.compareDate(oldActiveDate, this.activeDate)) {
        this.activeDateChange.emit(this.activeDate);
        this._focusActiveCellAfterViewChecked();
      }
      // Prevent unexpected default actions such as form submission.
      event.preventDefault();
    }
    /** Handles keyup events on the calendar body when calendar is in year view. */
    _handleCalendarBodyKeyup(event) {
      if (event.keyCode === SPACE || event.keyCode === ENTER) {
        if (this._selectionKeyPressed) {
          this._monthSelected({
            value: this._dateAdapter.getMonth(this._activeDate),
            event
          });
        }
        this._selectionKeyPressed = false;
      }
    }
    /** Initializes this year view. */
    _init() {
      this._setSelectedMonth(this.selected);
      this._todayMonth = this._getMonthInCurrentYear(this._dateAdapter.today());
      this._yearLabel = this._dateAdapter.getYearName(this.activeDate);
      let monthNames = this._dateAdapter.getMonthNames('short');
      // First row of months only contains 5 elements so we can fit the year label on the same row.
      this._months = [[0, 1, 2, 3], [4, 5, 6, 7], [8, 9, 10, 11]].map(row => row.map(month => this._createCellForMonth(month, monthNames[month])));
      this._changeDetectorRef.markForCheck();
    }
    /** Focuses the active cell after the microtask queue is empty. */
    _focusActiveCell() {
      this._matCalendarBody._focusActiveCell();
    }
    /** Schedules the matCalendarBody to focus the active cell after change detection has run */
    _focusActiveCellAfterViewChecked() {
      this._matCalendarBody._scheduleFocusActiveCellAfterViewChecked();
    }
    /**
     * Gets the month in this year that the given Date falls on.
     * Returns null if the given Date is in another year.
     */
    _getMonthInCurrentYear(date) {
      return date && this._dateAdapter.getYear(date) == this._dateAdapter.getYear(this.activeDate) ? this._dateAdapter.getMonth(date) : null;
    }
    /**
     * Takes a month and returns a new date in the same day and year as the currently active date.
     *  The returned date will have the same month as the argument date.
     */
    _getDateFromMonth(month) {
      const normalizedDate = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1);
      const daysInMonth = this._dateAdapter.getNumDaysInMonth(normalizedDate);
      return this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, Math.min(this._dateAdapter.getDate(this.activeDate), daysInMonth));
    }
    /** Creates an MatCalendarCell for the given month. */
    _createCellForMonth(month, monthName) {
      const date = this._dateAdapter.createDate(this._dateAdapter.getYear(this.activeDate), month, 1);
      const ariaLabel = this._dateAdapter.format(date, this._dateFormats.display.monthYearA11yLabel);
      const cellClasses = this.dateClass ? this.dateClass(date, 'year') : undefined;
      return new MatCalendarCell(month, monthName.toLocaleUpperCase(), ariaLabel, this._shouldEnableMonth(month), cellClasses);
    }
    /** Whether the given month is enabled. */
    _shouldEnableMonth(month) {
      const activeYear = this._dateAdapter.getYear(this.activeDate);
      if (month === undefined || month === null || this._isYearAndMonthAfterMaxDate(activeYear, month) || this._isYearAndMonthBeforeMinDate(activeYear, month)) {
        return false;
      }
      if (!this.dateFilter) {
        return true;
      }
      const firstOfMonth = this._dateAdapter.createDate(activeYear, month, 1);
      // If any date in the month is enabled count the month as enabled.
      for (let date = firstOfMonth; this._dateAdapter.getMonth(date) == month; date = this._dateAdapter.addCalendarDays(date, 1)) {
        if (this.dateFilter(date)) {
          return true;
        }
      }
      return false;
    }
    /**
     * Tests whether the combination month/year is after this.maxDate, considering
     * just the month and year of this.maxDate
     */
    _isYearAndMonthAfterMaxDate(year, month) {
      if (this.maxDate) {
        const maxYear = this._dateAdapter.getYear(this.maxDate);
        const maxMonth = this._dateAdapter.getMonth(this.maxDate);
        return year > maxYear || year === maxYear && month > maxMonth;
      }
      return false;
    }
    /**
     * Tests whether the combination month/year is before this.minDate, considering
     * just the month and year of this.minDate
     */
    _isYearAndMonthBeforeMinDate(year, month) {
      if (this.minDate) {
        const minYear = this._dateAdapter.getYear(this.minDate);
        const minMonth = this._dateAdapter.getMonth(this.minDate);
        return year < minYear || year === minYear && month < minMonth;
      }
      return false;
    }
    /** Determines whether the user has the RTL layout direction. */
    _isRtl() {
      return this._dir && this._dir.value === 'rtl';
    }
    /** Sets the currently-selected month based on a model value. */
    _setSelectedMonth(value) {
      if (value instanceof DateRange) {
        this._selectedMonth = this._getMonthInCurrentYear(value.start) || this._getMonthInCurrentYear(value.end);
      } else {
        this._selectedMonth = this._getMonthInCurrentYear(value);
      }
    }
    static ɵfac = function MatYearView_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatYearView)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatYearView,
      selectors: [["mat-year-view"]],
      viewQuery: function MatYearView_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatCalendarBody, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._matCalendarBody = _t.first);
        }
      },
      inputs: {
        activeDate: "activeDate",
        selected: "selected",
        minDate: "minDate",
        maxDate: "maxDate",
        dateFilter: "dateFilter",
        dateClass: "dateClass"
      },
      outputs: {
        selectedChange: "selectedChange",
        monthSelected: "monthSelected",
        activeDateChange: "activeDateChange"
      },
      exportAs: ["matYearView"],
      decls: 5,
      vars: 9,
      consts: [["role", "grid", 1, "mat-calendar-table"], ["aria-hidden", "true", 1, "mat-calendar-table-header"], ["colspan", "4", 1, "mat-calendar-table-header-divider"], ["mat-calendar-body", "", 3, "selectedValueChange", "activeDateChange", "keyup", "keydown", "label", "rows", "todayValue", "startValue", "endValue", "labelMinRequiredCells", "numCols", "cellAspectRatio", "activeCell"]],
      template: function MatYearView_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "table", 0)(1, "thead", 1)(2, "tr");
          i0.ɵɵelement(3, "th", 2);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(4, "tbody", 3);
          i0.ɵɵlistener("selectedValueChange", function MatYearView_Template_tbody_selectedValueChange_4_listener($event) {
            return ctx._monthSelected($event);
          })("activeDateChange", function MatYearView_Template_tbody_activeDateChange_4_listener($event) {
            return ctx._updateActiveDate($event);
          })("keyup", function MatYearView_Template_tbody_keyup_4_listener($event) {
            return ctx._handleCalendarBodyKeyup($event);
          })("keydown", function MatYearView_Template_tbody_keydown_4_listener($event) {
            return ctx._handleCalendarBodyKeydown($event);
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("label", ctx._yearLabel)("rows", ctx._months)("todayValue", ctx._todayMonth)("startValue", ctx._selectedMonth)("endValue", ctx._selectedMonth)("labelMinRequiredCells", 2)("numCols", 4)("cellAspectRatio", 4 / 7)("activeCell", ctx._dateAdapter.getMonth(ctx.activeDate));
        }
      },
      dependencies: [MatCalendarBody],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatYearView;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Default header for MatCalendar */
let MatCalendarHeader = /*#__PURE__*/(() => {
  class MatCalendarHeader {
    _intl = inject(MatDatepickerIntl);
    calendar = inject(MatCalendar);
    _dateAdapter = inject(DateAdapter, {
      optional: true
    });
    _dateFormats = inject(MAT_DATE_FORMATS, {
      optional: true
    });
    _periodButtonText;
    _periodButtonDescription;
    _periodButtonLabel;
    _prevButtonLabel;
    _nextButtonLabel;
    constructor() {
      inject(_CdkPrivateStyleLoader).load(_VisuallyHiddenLoader);
      const changeDetectorRef = inject(ChangeDetectorRef);
      this._updateLabels();
      this.calendar.stateChanges.subscribe(() => {
        this._updateLabels();
        changeDetectorRef.markForCheck();
      });
    }
    /** The display text for the current calendar view. */
    get periodButtonText() {
      return this._periodButtonText;
    }
    /** The aria description for the current calendar view. */
    get periodButtonDescription() {
      return this._periodButtonDescription;
    }
    /** The `aria-label` for changing the calendar view. */
    get periodButtonLabel() {
      return this._periodButtonLabel;
    }
    /** The label for the previous button. */
    get prevButtonLabel() {
      return this._prevButtonLabel;
    }
    /** The label for the next button. */
    get nextButtonLabel() {
      return this._nextButtonLabel;
    }
    /** Handles user clicks on the period label. */
    currentPeriodClicked() {
      this.calendar.currentView = this.calendar.currentView == 'month' ? 'multi-year' : 'month';
    }
    /** Handles user clicks on the previous button. */
    previousClicked() {
      if (this.previousEnabled()) {
        this.calendar.activeDate = this.calendar.currentView == 'month' ? this._dateAdapter.addCalendarMonths(this.calendar.activeDate, -1) : this._dateAdapter.addCalendarYears(this.calendar.activeDate, this.calendar.currentView == 'year' ? -1 : -yearsPerPage);
      }
    }
    /** Handles user clicks on the next button. */
    nextClicked() {
      if (this.nextEnabled()) {
        this.calendar.activeDate = this.calendar.currentView == 'month' ? this._dateAdapter.addCalendarMonths(this.calendar.activeDate, 1) : this._dateAdapter.addCalendarYears(this.calendar.activeDate, this.calendar.currentView == 'year' ? 1 : yearsPerPage);
      }
    }
    /** Whether the previous period button is enabled. */
    previousEnabled() {
      if (!this.calendar.minDate) {
        return true;
      }
      return !this.calendar.minDate || !this._isSameView(this.calendar.activeDate, this.calendar.minDate);
    }
    /** Whether the next period button is enabled. */
    nextEnabled() {
      return !this.calendar.maxDate || !this._isSameView(this.calendar.activeDate, this.calendar.maxDate);
    }
    /** Updates the labels for the various sections of the header. */
    _updateLabels() {
      const calendar = this.calendar;
      const intl = this._intl;
      const adapter = this._dateAdapter;
      if (calendar.currentView === 'month') {
        this._periodButtonText = adapter.format(calendar.activeDate, this._dateFormats.display.monthYearLabel).toLocaleUpperCase();
        this._periodButtonDescription = adapter.format(calendar.activeDate, this._dateFormats.display.monthYearLabel).toLocaleUpperCase();
        this._periodButtonLabel = intl.switchToMultiYearViewLabel;
        this._prevButtonLabel = intl.prevMonthLabel;
        this._nextButtonLabel = intl.nextMonthLabel;
      } else if (calendar.currentView === 'year') {
        this._periodButtonText = adapter.getYearName(calendar.activeDate);
        this._periodButtonDescription = adapter.getYearName(calendar.activeDate);
        this._periodButtonLabel = intl.switchToMonthViewLabel;
        this._prevButtonLabel = intl.prevYearLabel;
        this._nextButtonLabel = intl.nextYearLabel;
      } else {
        this._periodButtonText = intl.formatYearRange(...this._formatMinAndMaxYearLabels());
        // Format a label for the window of years displayed in the multi-year calendar view. Use
        // `formatYearRangeLabel` because it is TTS friendly.
        this._periodButtonDescription = intl.formatYearRangeLabel(...this._formatMinAndMaxYearLabels());
        this._periodButtonLabel = intl.switchToMonthViewLabel;
        this._prevButtonLabel = intl.prevMultiYearLabel;
        this._nextButtonLabel = intl.nextMultiYearLabel;
      }
    }
    /** Whether the two dates represent the same view in the current view mode (month or year). */
    _isSameView(date1, date2) {
      if (this.calendar.currentView == 'month') {
        return this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2) && this._dateAdapter.getMonth(date1) == this._dateAdapter.getMonth(date2);
      }
      if (this.calendar.currentView == 'year') {
        return this._dateAdapter.getYear(date1) == this._dateAdapter.getYear(date2);
      }
      // Otherwise we are in 'multi-year' view.
      return isSameMultiYearView(this._dateAdapter, date1, date2, this.calendar.minDate, this.calendar.maxDate);
    }
    /**
     * Format two individual labels for the minimum year and maximum year available in the multi-year
     * calendar view. Returns an array of two strings where the first string is the formatted label
     * for the minimum year, and the second string is the formatted label for the maximum year.
     */
    _formatMinAndMaxYearLabels() {
      // The offset from the active year to the "slot" for the starting year is the
      // *actual* first rendered year in the multi-year view, and the last year is
      // just yearsPerPage - 1 away.
      const activeYear = this._dateAdapter.getYear(this.calendar.activeDate);
      const minYearOfPage = activeYear - getActiveOffset(this._dateAdapter, this.calendar.activeDate, this.calendar.minDate, this.calendar.maxDate);
      const maxYearOfPage = minYearOfPage + yearsPerPage - 1;
      const minYearLabel = this._dateAdapter.getYearName(this._dateAdapter.createDate(minYearOfPage, 0, 1));
      const maxYearLabel = this._dateAdapter.getYearName(this._dateAdapter.createDate(maxYearOfPage, 0, 1));
      return [minYearLabel, maxYearLabel];
    }
    _periodButtonLabelId = inject(_IdGenerator).getId('mat-calendar-period-label-');
    static ɵfac = function MatCalendarHeader_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCalendarHeader)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatCalendarHeader,
      selectors: [["mat-calendar-header"]],
      exportAs: ["matCalendarHeader"],
      ngContentSelectors: _c1,
      decls: 17,
      vars: 13,
      consts: [[1, "mat-calendar-header"], [1, "mat-calendar-controls"], ["aria-live", "polite", 1, "cdk-visually-hidden", 3, "id"], ["matButton", "", "type", "button", 1, "mat-calendar-period-button", 3, "click"], ["aria-hidden", "true"], ["viewBox", "0 0 10 5", "focusable", "false", "aria-hidden", "true", 1, "mat-calendar-arrow"], ["points", "0,0 5,5 10,0"], [1, "mat-calendar-spacer"], ["matIconButton", "", "type", "button", "disabledInteractive", "", 1, "mat-calendar-previous-button", 3, "click", "disabled", "matTooltip"], ["viewBox", "0 0 24 24", "focusable", "false", "aria-hidden", "true"], ["d", "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"], ["matIconButton", "", "type", "button", "disabledInteractive", "", 1, "mat-calendar-next-button", 3, "click", "disabled", "matTooltip"], ["d", "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"]],
      template: function MatCalendarHeader_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "span", 2);
          i0.ɵɵtext(3);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(4, "button", 3);
          i0.ɵɵlistener("click", function MatCalendarHeader_Template_button_click_4_listener() {
            return ctx.currentPeriodClicked();
          });
          i0.ɵɵelementStart(5, "span", 4);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(7, "svg", 5);
          i0.ɵɵelement(8, "polygon", 6);
          i0.ɵɵelementEnd()();
          i0.ɵɵnamespaceHTML();
          i0.ɵɵelement(9, "div", 7);
          i0.ɵɵprojection(10);
          i0.ɵɵelementStart(11, "button", 8);
          i0.ɵɵlistener("click", function MatCalendarHeader_Template_button_click_11_listener() {
            return ctx.previousClicked();
          });
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(12, "svg", 9);
          i0.ɵɵelement(13, "path", 10);
          i0.ɵɵelementEnd()();
          i0.ɵɵnamespaceHTML();
          i0.ɵɵelementStart(14, "button", 11);
          i0.ɵɵlistener("click", function MatCalendarHeader_Template_button_click_14_listener() {
            return ctx.nextClicked();
          });
          i0.ɵɵnamespaceSVG();
          i0.ɵɵelementStart(15, "svg", 9);
          i0.ɵɵelement(16, "path", 12);
          i0.ɵɵelementEnd()()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("id", ctx._periodButtonLabelId);
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.periodButtonDescription);
          i0.ɵɵadvance();
          i0.ɵɵattribute("aria-label", ctx.periodButtonLabel)("aria-describedby", ctx._periodButtonLabelId);
          i0.ɵɵadvance(2);
          i0.ɵɵtextInterpolate(ctx.periodButtonText);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("mat-calendar-invert", ctx.calendar.currentView !== "month");
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("disabled", !ctx.previousEnabled())("matTooltip", ctx.prevButtonLabel);
          i0.ɵɵattribute("aria-label", ctx.prevButtonLabel);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("disabled", !ctx.nextEnabled())("matTooltip", ctx.nextButtonLabel);
          i0.ɵɵattribute("aria-label", ctx.nextButtonLabel);
        }
      },
      dependencies: [MatButton, MatIconButton, MatTooltip],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatCalendarHeader;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** A calendar that is used as part of the datepicker. */
let MatCalendar = /*#__PURE__*/(() => {
  class MatCalendar {
    _dateAdapter = inject(DateAdapter, {
      optional: true
    });
    _dateFormats = inject(MAT_DATE_FORMATS, {
      optional: true
    });
    _changeDetectorRef = inject(ChangeDetectorRef);
    _elementRef = inject(ElementRef);
    /** An input indicating the type of the header component, if set. */
    headerComponent;
    /** A portal containing the header component type for this calendar. */
    _calendarHeaderPortal;
    _intlChanges;
    /**
     * Used for scheduling that focus should be moved to the active cell on the next tick.
     * We need to schedule it, rather than do it immediately, because we have to wait
     * for Angular to re-evaluate the view children.
     */
    _moveFocusOnNextTick = false;
    /** A date representing the period (month or year) to start the calendar in. */
    get startAt() {
      return this._startAt;
    }
    set startAt(value) {
      this._startAt = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _startAt;
    /** Whether the calendar should be started in month or year view. */
    startView = 'month';
    /** The currently selected date. */
    get selected() {
      return this._selected;
    }
    set selected(value) {
      if (value instanceof DateRange) {
        this._selected = value;
      } else {
        this._selected = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
      }
    }
    _selected;
    /** The minimum selectable date. */
    get minDate() {
      return this._minDate;
    }
    set minDate(value) {
      this._minDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _minDate;
    /** The maximum selectable date. */
    get maxDate() {
      return this._maxDate;
    }
    set maxDate(value) {
      this._maxDate = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _maxDate;
    /** Function used to filter which dates are selectable. */
    dateFilter;
    /** Function that can be used to add custom CSS classes to dates. */
    dateClass;
    /** Start of the comparison range. */
    comparisonStart;
    /** End of the comparison range. */
    comparisonEnd;
    /** ARIA Accessible name of the `<input matStartDate/>` */
    startDateAccessibleName;
    /** ARIA Accessible name of the `<input matEndDate/>` */
    endDateAccessibleName;
    /** Emits when the currently selected date changes. */
    selectedChange = new EventEmitter();
    /**
     * Emits the year chosen in multiyear view.
     * This doesn't imply a change on the selected date.
     */
    yearSelected = new EventEmitter();
    /**
     * Emits the month chosen in year view.
     * This doesn't imply a change on the selected date.
     */
    monthSelected = new EventEmitter();
    /**
     * Emits when the current view changes.
     */
    viewChanged = new EventEmitter(true);
    /** Emits when any date is selected. */
    _userSelection = new EventEmitter();
    /** Emits a new date range value when the user completes a drag drop operation. */
    _userDragDrop = new EventEmitter();
    /** Reference to the current month view component. */
    monthView;
    /** Reference to the current year view component. */
    yearView;
    /** Reference to the current multi-year view component. */
    multiYearView;
    /**
     * The current active date. This determines which time period is shown and which date is
     * highlighted when using keyboard navigation.
     */
    get activeDate() {
      return this._clampedActiveDate;
    }
    set activeDate(value) {
      this._clampedActiveDate = this._dateAdapter.clampDate(value, this.minDate, this.maxDate);
      this.stateChanges.next();
      this._changeDetectorRef.markForCheck();
    }
    _clampedActiveDate;
    /** Whether the calendar is in month view. */
    get currentView() {
      return this._currentView;
    }
    set currentView(value) {
      const viewChangedResult = this._currentView !== value ? value : null;
      this._currentView = value;
      this._moveFocusOnNextTick = true;
      this._changeDetectorRef.markForCheck();
      if (viewChangedResult) {
        this.stateChanges.next();
        this.viewChanged.emit(viewChangedResult);
      }
    }
    _currentView;
    /** Origin of active drag, or null when dragging is not active. */
    _activeDrag = null;
    /**
     * Emits whenever there is a state change that the header may need to respond to.
     */
    stateChanges = new Subject();
    constructor() {
      if (typeof ngDevMode === 'undefined' || ngDevMode) {
        if (!this._dateAdapter) {
          throw createMissingDateImplError('DateAdapter');
        }
        if (!this._dateFormats) {
          throw createMissingDateImplError('MAT_DATE_FORMATS');
        }
      }
      this._intlChanges = inject(MatDatepickerIntl).changes.subscribe(() => {
        this._changeDetectorRef.markForCheck();
        this.stateChanges.next();
      });
    }
    ngAfterContentInit() {
      this._calendarHeaderPortal = new ComponentPortal(this.headerComponent || MatCalendarHeader);
      this.activeDate = this.startAt || this._dateAdapter.today();
      // Assign to the private property since we don't want to move focus on init.
      this._currentView = this.startView;
    }
    ngAfterViewChecked() {
      if (this._moveFocusOnNextTick) {
        this._moveFocusOnNextTick = false;
        this.focusActiveCell();
      }
    }
    ngOnDestroy() {
      this._intlChanges.unsubscribe();
      this.stateChanges.complete();
    }
    ngOnChanges(changes) {
      // Ignore date changes that are at a different time on the same day. This fixes issues where
      // the calendar re-renders when there is no meaningful change to [minDate] or [maxDate]
      // (#24435).
      const minDateChange = changes['minDate'] && !this._dateAdapter.sameDate(changes['minDate'].previousValue, changes['minDate'].currentValue) ? changes['minDate'] : undefined;
      const maxDateChange = changes['maxDate'] && !this._dateAdapter.sameDate(changes['maxDate'].previousValue, changes['maxDate'].currentValue) ? changes['maxDate'] : undefined;
      const changeRequiringRerender = minDateChange || maxDateChange || changes['dateFilter'];
      if (changeRequiringRerender && !changeRequiringRerender.firstChange) {
        const view = this._getCurrentViewComponent();
        if (view) {
          // Schedule focus to be moved to the active date since re-rendering can blur the active
          // cell (see #29265), however don't do so if focus is outside of the calendar, because it
          // can steal away the user's attention (see #30635).
          if (this._elementRef.nativeElement.contains(_getFocusedElementPierceShadowDom())) {
            this._moveFocusOnNextTick = true;
          }
          // We need to `detectChanges` manually here, because the `minDate`, `maxDate` etc. are
          // passed down to the view via data bindings which won't be up-to-date when we call `_init`.
          this._changeDetectorRef.detectChanges();
          view._init();
        }
      }
      this.stateChanges.next();
    }
    /** Focuses the active date. */
    focusActiveCell() {
      this._getCurrentViewComponent()._focusActiveCell(false);
    }
    /** Updates today's date after an update of the active date */
    updateTodaysDate() {
      this._getCurrentViewComponent()._init();
    }
    /** Handles date selection in the month view. */
    _dateSelected(event) {
      const date = event.value;
      if (this.selected instanceof DateRange || date && !this._dateAdapter.sameDate(date, this.selected)) {
        this.selectedChange.emit(date);
      }
      this._userSelection.emit(event);
    }
    /** Handles year selection in the multiyear view. */
    _yearSelectedInMultiYearView(normalizedYear) {
      this.yearSelected.emit(normalizedYear);
    }
    /** Handles month selection in the year view. */
    _monthSelectedInYearView(normalizedMonth) {
      this.monthSelected.emit(normalizedMonth);
    }
    /** Handles year/month selection in the multi-year/year views. */
    _goToDateInView(date, view) {
      this.activeDate = date;
      this.currentView = view;
    }
    /** Called when the user starts dragging to change a date range. */
    _dragStarted(event) {
      this._activeDrag = event;
    }
    /**
     * Called when a drag completes. It may end in cancelation or in the selection
     * of a new range.
     */
    _dragEnded(event) {
      if (!this._activeDrag) return;
      if (event.value) {
        this._userDragDrop.emit(event);
      }
      this._activeDrag = null;
    }
    /** Returns the component instance that corresponds to the current calendar view. */
    _getCurrentViewComponent() {
      // The return type is explicitly written as a union to ensure that the Closure compiler does
      // not optimize calls to _init(). Without the explicit return type, TypeScript narrows it to
      // only the first component type. See https://github.com/angular/components/issues/22996.
      return this.monthView || this.yearView || this.multiYearView;
    }
    static ɵfac = function MatCalendar_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatCalendar)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatCalendar,
      selectors: [["mat-calendar"]],
      viewQuery: function MatCalendar_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatMonthView, 5);
          i0.ɵɵviewQuery(MatYearView, 5);
          i0.ɵɵviewQuery(MatMultiYearView, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.monthView = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.yearView = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.multiYearView = _t.first);
        }
      },
      hostAttrs: [1, "mat-calendar"],
      inputs: {
        headerComponent: "headerComponent",
        startAt: "startAt",
        startView: "startView",
        selected: "selected",
        minDate: "minDate",
        maxDate: "maxDate",
        dateFilter: "dateFilter",
        dateClass: "dateClass",
        comparisonStart: "comparisonStart",
        comparisonEnd: "comparisonEnd",
        startDateAccessibleName: "startDateAccessibleName",
        endDateAccessibleName: "endDateAccessibleName"
      },
      outputs: {
        selectedChange: "selectedChange",
        yearSelected: "yearSelected",
        monthSelected: "monthSelected",
        viewChanged: "viewChanged",
        _userSelection: "_userSelection",
        _userDragDrop: "_userDragDrop"
      },
      exportAs: ["matCalendar"],
      features: [i0.ɵɵProvidersFeature([MAT_SINGLE_DATE_SELECTION_MODEL_PROVIDER]), i0.ɵɵNgOnChangesFeature],
      decls: 5,
      vars: 2,
      consts: [[3, "cdkPortalOutlet"], ["cdkMonitorSubtreeFocus", "", "tabindex", "-1", 1, "mat-calendar-content"], [3, "activeDate", "selected", "dateFilter", "maxDate", "minDate", "dateClass", "comparisonStart", "comparisonEnd", "startDateAccessibleName", "endDateAccessibleName", "activeDrag"], [3, "activeDate", "selected", "dateFilter", "maxDate", "minDate", "dateClass"], [3, "activeDateChange", "_userSelection", "dragStarted", "dragEnded", "activeDate", "selected", "dateFilter", "maxDate", "minDate", "dateClass", "comparisonStart", "comparisonEnd", "startDateAccessibleName", "endDateAccessibleName", "activeDrag"], [3, "activeDateChange", "monthSelected", "selectedChange", "activeDate", "selected", "dateFilter", "maxDate", "minDate", "dateClass"], [3, "activeDateChange", "yearSelected", "selectedChange", "activeDate", "selected", "dateFilter", "maxDate", "minDate", "dateClass"]],
      template: function MatCalendar_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, MatCalendar_ng_template_0_Template, 0, 0, "ng-template", 0);
          i0.ɵɵelementStart(1, "div", 1);
          i0.ɵɵconditionalCreate(2, MatCalendar_Case_2_Template, 1, 11, "mat-month-view", 2)(3, MatCalendar_Case_3_Template, 1, 6, "mat-year-view", 3)(4, MatCalendar_Case_4_Template, 1, 6, "mat-multi-year-view", 3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          let tmp_1_0;
          i0.ɵɵproperty("cdkPortalOutlet", ctx._calendarHeaderPortal);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional((tmp_1_0 = ctx.currentView) === "month" ? 2 : tmp_1_0 === "year" ? 3 : tmp_1_0 === "multi-year" ? 4 : -1);
        }
      },
      dependencies: [CdkPortalOutlet, CdkMonitorFocus, MatMonthView, MatYearView, MatMultiYearView],
      styles: [".mat-calendar{display:block;line-height:normal;font-family:var(--mat-datepicker-calendar-text-font, var(--mat-sys-body-medium-font));font-size:var(--mat-datepicker-calendar-text-size, var(--mat-sys-body-medium-size))}.mat-calendar-header{padding:8px 8px 0 8px}.mat-calendar-content{padding:0 8px 8px 8px;outline:none}.mat-calendar-controls{display:flex;align-items:center;margin:5% calc(4.7142857143% - 16px)}.mat-calendar-spacer{flex:1 1 auto}.mat-calendar-period-button{min-width:0;margin:0 8px;font-size:var(--mat-datepicker-calendar-period-button-text-size, var(--mat-sys-title-small-size));font-weight:var(--mat-datepicker-calendar-period-button-text-weight, var(--mat-sys-title-small-weight));--mat-button-text-label-text-color: var(--mat-datepicker-calendar-period-button-text-color, var(--mat-sys-on-surface-variant))}.mat-calendar-arrow{display:inline-block;width:10px;height:5px;margin:0 0 0 5px;vertical-align:middle;fill:var(--mat-datepicker-calendar-period-button-icon-color, var(--mat-sys-on-surface-variant))}.mat-calendar-arrow.mat-calendar-invert{transform:rotate(180deg)}[dir=rtl] .mat-calendar-arrow{margin:0 5px 0 0}@media(forced-colors: active){.mat-calendar-arrow{fill:CanvasText}}.mat-datepicker-content .mat-calendar-previous-button:not(.mat-mdc-button-disabled),.mat-datepicker-content .mat-calendar-next-button:not(.mat-mdc-button-disabled){color:var(--mat-datepicker-calendar-navigation-button-icon-color, var(--mat-sys-on-surface-variant))}[dir=rtl] .mat-calendar-previous-button,[dir=rtl] .mat-calendar-next-button{transform:rotate(180deg)}.mat-calendar-table{border-spacing:0;border-collapse:collapse;width:100%}.mat-calendar-table-header th{text-align:center;padding:0 0 8px 0;color:var(--mat-datepicker-calendar-header-text-color, var(--mat-sys-on-surface-variant));font-size:var(--mat-datepicker-calendar-header-text-size, var(--mat-sys-title-small-size));font-weight:var(--mat-datepicker-calendar-header-text-weight, var(--mat-sys-title-small-weight))}.mat-calendar-table-header-divider{position:relative;height:1px}.mat-calendar-table-header-divider::after{content:\"\";position:absolute;top:0;left:-8px;right:-8px;height:1px;background:var(--mat-datepicker-calendar-header-divider-color, transparent)}.mat-calendar-body-cell-content::before{margin:calc(calc(var(--mat-focus-indicator-border-width, 3px) + 3px)*-1)}.mat-calendar-body-cell:focus .mat-focus-indicator::before{content:\"\"}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatCalendar;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Injection token that determines the scroll handling while the calendar is open. */
const MAT_DATEPICKER_SCROLL_STRATEGY = /*#__PURE__*/new InjectionToken('mat-datepicker-scroll-strategy', {
  providedIn: 'root',
  factory: () => {
    const injector = inject(Injector);
    return () => createRepositionScrollStrategy(injector);
  }
});
/**
 * @docs-private
 * @deprecated No longer used, will be removed.
 * @breaking-change 21.0.0
 */
function MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY(_overlay) {
  const injector = inject(Injector);
  return () => createRepositionScrollStrategy(injector);
}
/**
 * @docs-private
 * @deprecated No longer used, will be removed.
 * @breaking-change 21.0.0
 */
const MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER = {
  provide: MAT_DATEPICKER_SCROLL_STRATEGY,
  deps: [],
  useFactory: MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY
};
/**
 * Component used as the content for the datepicker overlay. We use this instead of using
 * MatCalendar directly as the content so we can control the initial focus. This also gives us a
 * place to put additional features of the overlay that are not part of the calendar itself in the
 * future. (e.g. confirmation buttons).
 * @docs-private
 */
let MatDatepickerContent = /*#__PURE__*/(() => {
  class MatDatepickerContent {
    _elementRef = inject(ElementRef);
    _animationsDisabled = _animationsDisabled();
    _changeDetectorRef = inject(ChangeDetectorRef);
    _globalModel = inject(MatDateSelectionModel);
    _dateAdapter = inject(DateAdapter);
    _ngZone = inject(NgZone);
    _rangeSelectionStrategy = inject(MAT_DATE_RANGE_SELECTION_STRATEGY, {
      optional: true
    });
    _stateChanges;
    _model;
    _eventCleanups;
    _animationFallback;
    /** Reference to the internal calendar component. */
    _calendar;
    /**
     * Theme color of the internal calendar. This API is supported in M2 themes
     * only, it has no effect in M3 themes. For color customization in M3, see https://material.angular.dev/components/datepicker/styling.
     *
     * For information on applying color variants in M3, see
     * https://material.angular.dev/guide/material-2-theming#optional-add-backwards-compatibility-styles-for-color-variants
     */
    color;
    /** Reference to the datepicker that created the overlay. */
    datepicker;
    /** Start of the comparison range. */
    comparisonStart;
    /** End of the comparison range. */
    comparisonEnd;
    /** ARIA Accessible name of the `<input matStartDate/>` */
    startDateAccessibleName;
    /** ARIA Accessible name of the `<input matEndDate/>` */
    endDateAccessibleName;
    /** Whether the datepicker is above or below the input. */
    _isAbove;
    /** Emits when an animation has finished. */
    _animationDone = new Subject();
    /** Whether there is an in-progress animation. */
    _isAnimating = false;
    /** Text for the close button. */
    _closeButtonText;
    /** Whether the close button currently has focus. */
    _closeButtonFocused;
    /** Portal with projected action buttons. */
    _actionsPortal = null;
    /** Id of the label for the `role="dialog"` element. */
    _dialogLabelId;
    constructor() {
      inject(_CdkPrivateStyleLoader).load(_VisuallyHiddenLoader);
      this._closeButtonText = inject(MatDatepickerIntl).closeCalendarLabel;
      if (!this._animationsDisabled) {
        const element = this._elementRef.nativeElement;
        const renderer = inject(Renderer2);
        this._eventCleanups = this._ngZone.runOutsideAngular(() => [renderer.listen(element, 'animationstart', this._handleAnimationEvent), renderer.listen(element, 'animationend', this._handleAnimationEvent), renderer.listen(element, 'animationcancel', this._handleAnimationEvent)]);
      }
    }
    ngAfterViewInit() {
      this._stateChanges = this.datepicker.stateChanges.subscribe(() => {
        this._changeDetectorRef.markForCheck();
      });
      this._calendar.focusActiveCell();
    }
    ngOnDestroy() {
      clearTimeout(this._animationFallback);
      this._eventCleanups?.forEach(cleanup => cleanup());
      this._stateChanges?.unsubscribe();
      this._animationDone.complete();
    }
    _handleUserSelection(event) {
      const selection = this._model.selection;
      const value = event.value;
      const isRange = selection instanceof DateRange;
      // If we're selecting a range and we have a selection strategy, always pass the value through
      // there. Otherwise don't assign null values to the model, unless we're selecting a range.
      // A null value when picking a range means that the user cancelled the selection (e.g. by
      // pressing escape), whereas when selecting a single value it means that the value didn't
      // change. This isn't very intuitive, but it's here for backwards-compatibility.
      if (isRange && this._rangeSelectionStrategy) {
        const newSelection = this._rangeSelectionStrategy.selectionFinished(value, selection, event.event);
        this._model.updateSelection(newSelection, this);
      } else if (value && (isRange || !this._dateAdapter.sameDate(value, selection))) {
        this._model.add(value);
      }
      // Delegate closing the overlay to the actions.
      if ((!this._model || this._model.isComplete()) && !this._actionsPortal) {
        this.datepicker.close();
      }
    }
    _handleUserDragDrop(event) {
      this._model.updateSelection(event.value, this);
    }
    _startExitAnimation() {
      this._elementRef.nativeElement.classList.add('mat-datepicker-content-exit');
      if (this._animationsDisabled) {
        this._animationDone.next();
      } else {
        // Some internal apps disable animations in tests using `* {animation: none !important}`.
        // If that happens, the animation events won't fire and we'll never clean up the overlay.
        // Add a fallback that will fire if the animation doesn't run in a certain amount of time.
        clearTimeout(this._animationFallback);
        this._animationFallback = setTimeout(() => {
          if (!this._isAnimating) {
            this._animationDone.next();
          }
        }, 200);
      }
    }
    _handleAnimationEvent = event => {
      const element = this._elementRef.nativeElement;
      if (event.target !== element || !event.animationName.startsWith('_mat-datepicker-content')) {
        return;
      }
      clearTimeout(this._animationFallback);
      this._isAnimating = event.type === 'animationstart';
      element.classList.toggle('mat-datepicker-content-animating', this._isAnimating);
      if (!this._isAnimating) {
        this._animationDone.next();
      }
    };
    _getSelected() {
      return this._model.selection;
    }
    /** Applies the current pending selection to the global model. */
    _applyPendingSelection() {
      if (this._model !== this._globalModel) {
        this._globalModel.updateSelection(this._model.selection, this);
      }
    }
    /**
     * Assigns a new portal containing the datepicker actions.
     * @param portal Portal with the actions to be assigned.
     * @param forceRerender Whether a re-render of the portal should be triggered. This isn't
     * necessary if the portal is assigned during initialization, but it may be required if it's
     * added at a later point.
     */
    _assignActions(portal, forceRerender) {
      // If we have actions, clone the model so that we have the ability to cancel the selection,
      // otherwise update the global model directly. Note that we want to assign this as soon as
      // possible, but `_actionsPortal` isn't available in the constructor so we do it in `ngOnInit`.
      this._model = portal ? this._globalModel.clone() : this._globalModel;
      this._actionsPortal = portal;
      if (forceRerender) {
        this._changeDetectorRef.detectChanges();
      }
    }
    static ɵfac = function MatDatepickerContent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatDatepickerContent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatDatepickerContent,
      selectors: [["mat-datepicker-content"]],
      viewQuery: function MatDatepickerContent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(MatCalendar, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._calendar = _t.first);
        }
      },
      hostAttrs: [1, "mat-datepicker-content"],
      hostVars: 6,
      hostBindings: function MatDatepickerContent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.color ? "mat-" + ctx.color : "");
          i0.ɵɵclassProp("mat-datepicker-content-touch", ctx.datepicker.touchUi)("mat-datepicker-content-animations-enabled", !ctx._animationsDisabled);
        }
      },
      inputs: {
        color: "color"
      },
      exportAs: ["matDatepickerContent"],
      decls: 5,
      vars: 26,
      consts: [["cdkTrapFocus", "", "role", "dialog", 1, "mat-datepicker-content-container"], [3, "yearSelected", "monthSelected", "viewChanged", "_userSelection", "_userDragDrop", "id", "startAt", "startView", "minDate", "maxDate", "dateFilter", "headerComponent", "selected", "dateClass", "comparisonStart", "comparisonEnd", "startDateAccessibleName", "endDateAccessibleName"], [3, "cdkPortalOutlet"], ["type", "button", "matButton", "elevated", 1, "mat-datepicker-close-button", 3, "focus", "blur", "click", "color"]],
      template: function MatDatepickerContent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "mat-calendar", 1);
          i0.ɵɵlistener("yearSelected", function MatDatepickerContent_Template_mat_calendar_yearSelected_1_listener($event) {
            return ctx.datepicker._selectYear($event);
          })("monthSelected", function MatDatepickerContent_Template_mat_calendar_monthSelected_1_listener($event) {
            return ctx.datepicker._selectMonth($event);
          })("viewChanged", function MatDatepickerContent_Template_mat_calendar_viewChanged_1_listener($event) {
            return ctx.datepicker._viewChanged($event);
          })("_userSelection", function MatDatepickerContent_Template_mat_calendar__userSelection_1_listener($event) {
            return ctx._handleUserSelection($event);
          })("_userDragDrop", function MatDatepickerContent_Template_mat_calendar__userDragDrop_1_listener($event) {
            return ctx._handleUserDragDrop($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(2, MatDatepickerContent_ng_template_2_Template, 0, 0, "ng-template", 2);
          i0.ɵɵelementStart(3, "button", 3);
          i0.ɵɵlistener("focus", function MatDatepickerContent_Template_button_focus_3_listener() {
            return ctx._closeButtonFocused = true;
          })("blur", function MatDatepickerContent_Template_button_blur_3_listener() {
            return ctx._closeButtonFocused = false;
          })("click", function MatDatepickerContent_Template_button_click_3_listener() {
            return ctx.datepicker.close();
          });
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("mat-datepicker-content-container-with-custom-header", ctx.datepicker.calendarHeaderComponent)("mat-datepicker-content-container-with-actions", ctx._actionsPortal);
          i0.ɵɵattribute("aria-modal", true)("aria-labelledby", ctx._dialogLabelId ?? undefined);
          i0.ɵɵadvance();
          i0.ɵɵclassMap(ctx.datepicker.panelClass);
          i0.ɵɵproperty("id", ctx.datepicker.id)("startAt", ctx.datepicker.startAt)("startView", ctx.datepicker.startView)("minDate", ctx.datepicker._getMinDate())("maxDate", ctx.datepicker._getMaxDate())("dateFilter", ctx.datepicker._getDateFilter())("headerComponent", ctx.datepicker.calendarHeaderComponent)("selected", ctx._getSelected())("dateClass", ctx.datepicker.dateClass)("comparisonStart", ctx.comparisonStart)("comparisonEnd", ctx.comparisonEnd)("startDateAccessibleName", ctx.startDateAccessibleName)("endDateAccessibleName", ctx.endDateAccessibleName);
          i0.ɵɵadvance();
          i0.ɵɵproperty("cdkPortalOutlet", ctx._actionsPortal);
          i0.ɵɵadvance();
          i0.ɵɵclassProp("cdk-visually-hidden", !ctx._closeButtonFocused);
          i0.ɵɵproperty("color", ctx.color || "primary");
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx._closeButtonText);
        }
      },
      dependencies: [CdkTrapFocus, MatCalendar, CdkPortalOutlet, MatButton],
      styles: ["@keyframes _mat-datepicker-content-dropdown-enter{from{opacity:0;transform:scaleY(0.8)}to{opacity:1;transform:none}}@keyframes _mat-datepicker-content-dialog-enter{from{opacity:0;transform:scale(0.8)}to{opacity:1;transform:none}}@keyframes _mat-datepicker-content-exit{from{opacity:1}to{opacity:0}}.mat-datepicker-content{display:block;background-color:var(--mat-datepicker-calendar-container-background-color, var(--mat-sys-surface-container-high));color:var(--mat-datepicker-calendar-container-text-color, var(--mat-sys-on-surface));box-shadow:var(--mat-datepicker-calendar-container-elevation-shadow, 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12));border-radius:var(--mat-datepicker-calendar-container-shape, var(--mat-sys-corner-large))}.mat-datepicker-content.mat-datepicker-content-animations-enabled{animation:_mat-datepicker-content-dropdown-enter 120ms cubic-bezier(0, 0, 0.2, 1)}.mat-datepicker-content .mat-calendar{width:296px;height:354px}.mat-datepicker-content .mat-datepicker-content-container-with-custom-header .mat-calendar{height:auto}.mat-datepicker-content .mat-datepicker-close-button{position:absolute;top:100%;left:0;margin-top:8px}.mat-datepicker-content-animating .mat-datepicker-content .mat-datepicker-close-button{display:none}.mat-datepicker-content-container{display:flex;flex-direction:column;justify-content:space-between}.mat-datepicker-content-touch{display:block;max-height:80vh;box-shadow:var(--mat-datepicker-calendar-container-touch-elevation-shadow, 0px 0px 0px 0px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12));border-radius:var(--mat-datepicker-calendar-container-touch-shape, var(--mat-sys-corner-extra-large));position:relative;overflow:visible}.mat-datepicker-content-touch.mat-datepicker-content-animations-enabled{animation:_mat-datepicker-content-dialog-enter 150ms cubic-bezier(0, 0, 0.2, 1)}.mat-datepicker-content-touch .mat-datepicker-content-container{min-height:312px;max-height:788px;min-width:250px;max-width:750px}.mat-datepicker-content-touch .mat-calendar{width:100%;height:auto}.mat-datepicker-content-exit.mat-datepicker-content-animations-enabled{animation:_mat-datepicker-content-exit 100ms linear}@media all and (orientation: landscape){.mat-datepicker-content-touch .mat-datepicker-content-container{width:64vh;height:80vh}}@media all and (orientation: portrait){.mat-datepicker-content-touch .mat-datepicker-content-container{width:80vw;height:100vw}.mat-datepicker-content-touch .mat-datepicker-content-container-with-actions{height:115vw}}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatDatepickerContent;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** Base class for a datepicker. */
let MatDatepickerBase = /*#__PURE__*/(() => {
  class MatDatepickerBase {
    _injector = inject(Injector);
    _viewContainerRef = inject(ViewContainerRef);
    _dateAdapter = inject(DateAdapter, {
      optional: true
    });
    _dir = inject(Directionality, {
      optional: true
    });
    _model = inject(MatDateSelectionModel);
    _animationsDisabled = _animationsDisabled();
    _scrollStrategy = inject(MAT_DATEPICKER_SCROLL_STRATEGY);
    _inputStateChanges = Subscription.EMPTY;
    _document = inject(DOCUMENT);
    /** An input indicating the type of the custom header component for the calendar, if set. */
    calendarHeaderComponent;
    /** The date to open the calendar to initially. */
    get startAt() {
      // If an explicit startAt is set we start there, otherwise we start at whatever the currently
      // selected value is.
      return this._startAt || (this.datepickerInput ? this.datepickerInput.getStartValue() : null);
    }
    set startAt(value) {
      this._startAt = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
    }
    _startAt;
    /** The view that the calendar should start in. */
    startView = 'month';
    /**
     * Theme color of the datepicker's calendar. This API is supported in M2 themes only, it
     * has no effect in M3 themes. For color customization in M3, see https://material.angular.dev/components/datepicker/styling.
     *
     * For information on applying color variants in M3, see
     * https://material.angular.dev/guide/material-2-theming#optional-add-backwards-compatibility-styles-for-color-variants
     */
    get color() {
      return this._color || (this.datepickerInput ? this.datepickerInput.getThemePalette() : undefined);
    }
    set color(value) {
      this._color = value;
    }
    _color;
    /**
     * Whether the calendar UI is in touch mode. In touch mode the calendar opens in a dialog rather
     * than a dropdown and elements have more padding to allow for bigger touch targets.
     */
    touchUi = false;
    /** Whether the datepicker pop-up should be disabled. */
    get disabled() {
      return this._disabled === undefined && this.datepickerInput ? this.datepickerInput.disabled : !!this._disabled;
    }
    set disabled(value) {
      if (value !== this._disabled) {
        this._disabled = value;
        this.stateChanges.next(undefined);
      }
    }
    _disabled;
    /** Preferred position of the datepicker in the X axis. */
    xPosition = 'start';
    /** Preferred position of the datepicker in the Y axis. */
    yPosition = 'below';
    /**
     * Whether to restore focus to the previously-focused element when the calendar is closed.
     * Note that automatic focus restoration is an accessibility feature and it is recommended that
     * you provide your own equivalent, if you decide to turn it off.
     */
    restoreFocus = true;
    /**
     * Emits selected year in multiyear view.
     * This doesn't imply a change on the selected date.
     */
    yearSelected = new EventEmitter();
    /**
     * Emits selected month in year view.
     * This doesn't imply a change on the selected date.
     */
    monthSelected = new EventEmitter();
    /**
     * Emits when the current view changes.
     */
    viewChanged = new EventEmitter(true);
    /** Function that can be used to add custom CSS classes to dates. */
    dateClass;
    /** Emits when the datepicker has been opened. */
    openedStream = new EventEmitter();
    /** Emits when the datepicker has been closed. */
    closedStream = new EventEmitter();
    /** Classes to be passed to the date picker panel. */
    get panelClass() {
      return this._panelClass;
    }
    set panelClass(value) {
      this._panelClass = coerceStringArray(value);
    }
    _panelClass;
    /** Whether the calendar is open. */
    get opened() {
      return this._opened;
    }
    set opened(value) {
      if (value) {
        this.open();
      } else {
        this.close();
      }
    }
    _opened = false;
    /** The id for the datepicker calendar. */
    id = inject(_IdGenerator).getId('mat-datepicker-');
    /** The minimum selectable date. */
    _getMinDate() {
      return this.datepickerInput && this.datepickerInput.min;
    }
    /** The maximum selectable date. */
    _getMaxDate() {
      return this.datepickerInput && this.datepickerInput.max;
    }
    _getDateFilter() {
      return this.datepickerInput && this.datepickerInput.dateFilter;
    }
    /** A reference to the overlay into which we've rendered the calendar. */
    _overlayRef;
    /** Reference to the component instance rendered in the overlay. */
    _componentRef;
    /** The element that was focused before the datepicker was opened. */
    _focusedElementBeforeOpen = null;
    /** Unique class that will be added to the backdrop so that the test harnesses can look it up. */
    _backdropHarnessClass = `${this.id}-backdrop`;
    /** Currently-registered actions portal. */
    _actionsPortal;
    /** The input element this datepicker is associated with. */
    datepickerInput;
    /** Emits when the datepicker's state changes. */
    stateChanges = new Subject();
    _changeDetectorRef = inject(ChangeDetectorRef);
    constructor() {
      if (!this._dateAdapter && (typeof ngDevMode === 'undefined' || ngDevMode)) {
        throw createMissingDateImplError('DateAdapter');
      }
      this._model.selectionChanged.subscribe(() => {
        this._changeDetectorRef.markForCheck();
      });
    }
    ngOnChanges(changes) {
      const positionChange = changes['xPosition'] || changes['yPosition'];
      if (positionChange && !positionChange.firstChange && this._overlayRef) {
        const positionStrategy = this._overlayRef.getConfig().positionStrategy;
        if (positionStrategy instanceof FlexibleConnectedPositionStrategy) {
          this._setConnectedPositions(positionStrategy);
          if (this.opened) {
            this._overlayRef.updatePosition();
          }
        }
      }
      this.stateChanges.next(undefined);
    }
    ngOnDestroy() {
      this._destroyOverlay();
      this.close();
      this._inputStateChanges.unsubscribe();
      this.stateChanges.complete();
    }
    /** Selects the given date */
    select(date) {
      this._model.add(date);
    }
    /** Emits the selected year in multiyear view */
    _selectYear(normalizedYear) {
      this.yearSelected.emit(normalizedYear);
    }
    /** Emits selected month in year view */
    _selectMonth(normalizedMonth) {
      this.monthSelected.emit(normalizedMonth);
    }
    /** Emits changed view */
    _viewChanged(view) {
      this.viewChanged.emit(view);
    }
    /**
     * Register an input with this datepicker.
     * @param input The datepicker input to register with this datepicker.
     * @returns Selection model that the input should hook itself up to.
     */
    registerInput(input) {
      if (this.datepickerInput && (typeof ngDevMode === 'undefined' || ngDevMode)) {
        throw Error('A MatDatepicker can only be associated with a single input.');
      }
      this._inputStateChanges.unsubscribe();
      this.datepickerInput = input;
      this._inputStateChanges = input.stateChanges.subscribe(() => this.stateChanges.next(undefined));
      return this._model;
    }
    /**
     * Registers a portal containing action buttons with the datepicker.
     * @param portal Portal to be registered.
     */
    registerActions(portal) {
      if (this._actionsPortal && (typeof ngDevMode === 'undefined' || ngDevMode)) {
        throw Error('A MatDatepicker can only be associated with a single actions row.');
      }
      this._actionsPortal = portal;
      this._componentRef?.instance._assignActions(portal, true);
    }
    /**
     * Removes a portal containing action buttons from the datepicker.
     * @param portal Portal to be removed.
     */
    removeActions(portal) {
      if (portal === this._actionsPortal) {
        this._actionsPortal = null;
        this._componentRef?.instance._assignActions(null, true);
      }
    }
    /** Open the calendar. */
    open() {
      // Skip reopening if there's an in-progress animation to avoid overlapping
      // sequences which can cause "changed after checked" errors. See #25837.
      if (this._opened || this.disabled || this._componentRef?.instance._isAnimating) {
        return;
      }
      if (!this.datepickerInput && (typeof ngDevMode === 'undefined' || ngDevMode)) {
        throw Error('Attempted to open an MatDatepicker with no associated input.');
      }
      this._focusedElementBeforeOpen = _getFocusedElementPierceShadowDom();
      this._openOverlay();
      this._opened = true;
      this.openedStream.emit();
    }
    /** Close the calendar. */
    close() {
      // Skip reopening if there's an in-progress animation to avoid overlapping
      // sequences which can cause "changed after checked" errors. See #25837.
      if (!this._opened || this._componentRef?.instance._isAnimating) {
        return;
      }
      const canRestoreFocus = this.restoreFocus && this._focusedElementBeforeOpen && typeof this._focusedElementBeforeOpen.focus === 'function';
      const completeClose = () => {
        // The `_opened` could've been reset already if
        // we got two events in quick succession.
        if (this._opened) {
          this._opened = false;
          this.closedStream.emit();
        }
      };
      if (this._componentRef) {
        const {
          instance,
          location
        } = this._componentRef;
        instance._animationDone.pipe(take(1)).subscribe(() => {
          const activeElement = this._document.activeElement;
          // Since we restore focus after the exit animation, we have to check that
          // the user didn't move focus themselves inside the `close` handler.
          if (canRestoreFocus && (!activeElement || activeElement === this._document.activeElement || location.nativeElement.contains(activeElement))) {
            this._focusedElementBeforeOpen.focus();
          }
          this._focusedElementBeforeOpen = null;
          this._destroyOverlay();
        });
        instance._startExitAnimation();
      }
      if (canRestoreFocus) {
        // Because IE moves focus asynchronously, we can't count on it being restored before we've
        // marked the datepicker as closed. If the event fires out of sequence and the element that
        // we're refocusing opens the datepicker on focus, the user could be stuck with not being
        // able to close the calendar at all. We work around it by making the logic, that marks
        // the datepicker as closed, async as well.
        setTimeout(completeClose);
      } else {
        completeClose();
      }
    }
    /** Applies the current pending selection on the overlay to the model. */
    _applyPendingSelection() {
      this._componentRef?.instance?._applyPendingSelection();
    }
    /** Forwards relevant values from the datepicker to the datepicker content inside the overlay. */
    _forwardContentValues(instance) {
      instance.datepicker = this;
      instance.color = this.color;
      instance._dialogLabelId = this.datepickerInput.getOverlayLabelId();
      instance._assignActions(this._actionsPortal, false);
    }
    /** Opens the overlay with the calendar. */
    _openOverlay() {
      this._destroyOverlay();
      const isDialog = this.touchUi;
      const portal = new ComponentPortal(MatDatepickerContent, this._viewContainerRef);
      const overlayRef = this._overlayRef = createOverlayRef(this._injector, new OverlayConfig({
        positionStrategy: isDialog ? this._getDialogStrategy() : this._getDropdownStrategy(),
        hasBackdrop: true,
        backdropClass: [isDialog ? 'cdk-overlay-dark-backdrop' : 'mat-overlay-transparent-backdrop', this._backdropHarnessClass],
        direction: this._dir || 'ltr',
        scrollStrategy: isDialog ? createBlockScrollStrategy(this._injector) : this._scrollStrategy(),
        panelClass: `mat-datepicker-${isDialog ? 'dialog' : 'popup'}`,
        disableAnimations: this._animationsDisabled
      }));
      this._getCloseStream(overlayRef).subscribe(event => {
        if (event) {
          event.preventDefault();
        }
        this.close();
      });
      // The `preventDefault` call happens inside the calendar as well, however focus moves into
      // it inside a timeout which can give browsers a chance to fire off a keyboard event in-between
      // that can scroll the page (see #24969). Always block default actions of arrow keys for the
      // entire overlay so the page doesn't get scrolled by accident.
      overlayRef.keydownEvents().subscribe(event => {
        const keyCode = event.keyCode;
        if (keyCode === UP_ARROW || keyCode === DOWN_ARROW || keyCode === LEFT_ARROW || keyCode === RIGHT_ARROW || keyCode === PAGE_UP || keyCode === PAGE_DOWN) {
          event.preventDefault();
        }
      });
      this._componentRef = overlayRef.attach(portal);
      this._forwardContentValues(this._componentRef.instance);
      // Update the position once the calendar has rendered. Only relevant in dropdown mode.
      if (!isDialog) {
        afterNextRender(() => {
          overlayRef.updatePosition();
        }, {
          injector: this._injector
        });
      }
    }
    /** Destroys the current overlay. */
    _destroyOverlay() {
      if (this._overlayRef) {
        this._overlayRef.dispose();
        this._overlayRef = this._componentRef = null;
      }
    }
    /** Gets a position strategy that will open the calendar as a dropdown. */
    _getDialogStrategy() {
      return createGlobalPositionStrategy(this._injector).centerHorizontally().centerVertically();
    }
    /** Gets a position strategy that will open the calendar as a dropdown. */
    _getDropdownStrategy() {
      const strategy = createFlexibleConnectedPositionStrategy(this._injector, this.datepickerInput.getConnectedOverlayOrigin()).withTransformOriginOn('.mat-datepicker-content').withFlexibleDimensions(false).withViewportMargin(8).withLockedPosition();
      return this._setConnectedPositions(strategy);
    }
    /** Sets the positions of the datepicker in dropdown mode based on the current configuration. */
    _setConnectedPositions(strategy) {
      const primaryX = this.xPosition === 'end' ? 'end' : 'start';
      const secondaryX = primaryX === 'start' ? 'end' : 'start';
      const primaryY = this.yPosition === 'above' ? 'bottom' : 'top';
      const secondaryY = primaryY === 'top' ? 'bottom' : 'top';
      return strategy.withPositions([{
        originX: primaryX,
        originY: secondaryY,
        overlayX: primaryX,
        overlayY: primaryY
      }, {
        originX: primaryX,
        originY: primaryY,
        overlayX: primaryX,
        overlayY: secondaryY
      }, {
        originX: secondaryX,
        originY: secondaryY,
        overlayX: secondaryX,
        overlayY: primaryY
      }, {
        originX: secondaryX,
        originY: primaryY,
        overlayX: secondaryX,
        overlayY: secondaryY
      }]);
    }
    /** Gets an observable that will emit when the overlay is supposed to be closed. */
    _getCloseStream(overlayRef) {
      const ctrlShiftMetaModifiers = ['ctrlKey', 'shiftKey', 'metaKey'];
      return merge(overlayRef.backdropClick(), overlayRef.detachments(), overlayRef.keydownEvents().pipe(filter(event => {
        // Closing on alt + up is only valid when there's an input associated with the datepicker.
        return event.keyCode === ESCAPE && !hasModifierKey(event) || this.datepickerInput && hasModifierKey(event, 'altKey') && event.keyCode === UP_ARROW && ctrlShiftMetaModifiers.every(modifier => !hasModifierKey(event, modifier));
      })));
    }
    static ɵfac = function MatDatepickerBase_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatDatepickerBase)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatDatepickerBase,
      inputs: {
        calendarHeaderComponent: "calendarHeaderComponent",
        startAt: "startAt",
        startView: "startView",
        color: "color",
        touchUi: [2, "touchUi", "touchUi", booleanAttribute],
        disabled: [2, "disabled", "disabled", booleanAttribute],
        xPosition: "xPosition",
        yPosition: "yPosition",
        restoreFocus: [2, "restoreFocus", "restoreFocus", booleanAttribute],
        dateClass: "dateClass",
        panelClass: "panelClass",
        opened: [2, "opened", "opened", booleanAttribute]
      },
      outputs: {
        yearSelected: "yearSelected",
        monthSelected: "monthSelected",
        viewChanged: "viewChanged",
        openedStream: "opened",
        closedStream: "closed"
      },
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
  return MatDatepickerBase;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO(mmalerba): We use a component instead of a directive here so the user can use implicit
// template reference variables (e.g. #d vs #d="matDatepicker"). We can change this to a directive
// if angular adds support for `exportAs: '$implicit'` on directives.
/** Component responsible for managing the datepicker popup/dialog. */
let MatDatepicker = /*#__PURE__*/(() => {
  class MatDatepicker extends MatDatepickerBase {
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatDatepicker_BaseFactory;
      return function MatDatepicker_Factory(__ngFactoryType__) {
        return (ɵMatDatepicker_BaseFactory || (ɵMatDatepicker_BaseFactory = i0.ɵɵgetInheritedFactory(MatDatepicker)))(__ngFactoryType__ || MatDatepicker);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatDatepicker,
      selectors: [["mat-datepicker"]],
      exportAs: ["matDatepicker"],
      features: [i0.ɵɵProvidersFeature([MAT_SINGLE_DATE_SELECTION_MODEL_PROVIDER, {
        provide: MatDatepickerBase,
        useExisting: MatDatepicker
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function MatDatepicker_Template(rf, ctx) {},
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatDatepicker;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * An event used for datepicker input and change events. We don't always have access to a native
 * input or change event because the event may have been triggered by the user clicking on the
 * calendar popup. For consistency, we always use MatDatepickerInputEvent instead.
 */
class MatDatepickerInputEvent {
  target;
  targetElement;
  /** The new value for the target datepicker input. */
  value;
  constructor(/** Reference to the datepicker input component that emitted the event. */
  target, /** Reference to the native input element associated with the datepicker input. */
  targetElement) {
    this.target = target;
    this.targetElement = targetElement;
    this.value = this.target.value;
  }
}
/** Base class for datepicker inputs. */
let MatDatepickerInputBase = /*#__PURE__*/(() => {
  class MatDatepickerInputBase {
    _elementRef = inject(ElementRef);
    _dateAdapter = inject(DateAdapter, {
      optional: true
    });
    _dateFormats = inject(MAT_DATE_FORMATS, {
      optional: true
    });
    /** Whether the component has been initialized. */
    _isInitialized;
    /** The value of the input. */
    get value() {
      return this._model ? this._getValueFromModel(this._model.selection) : this._pendingValue;
    }
    set value(value) {
      this._assignValueProgrammatically(value);
    }
    _model;
    /** Whether the datepicker-input is disabled. */
    get disabled() {
      return !!this._disabled || this._parentDisabled();
    }
    set disabled(value) {
      const newValue = value;
      const element = this._elementRef.nativeElement;
      if (this._disabled !== newValue) {
        this._disabled = newValue;
        this.stateChanges.next(undefined);
      }
      // We need to null check the `blur` method, because it's undefined during SSR.
      // In Ivy static bindings are invoked earlier, before the element is attached to the DOM.
      // This can cause an error to be thrown in some browsers (IE/Edge) which assert that the
      // element has been inserted.
      if (newValue && this._isInitialized && element.blur) {
        // Normally, native input elements automatically blur if they turn disabled. This behavior
        // is problematic, because it would mean that it triggers another change detection cycle,
        // which then causes a changed after checked error if the input element was focused before.
        element.blur();
      }
    }
    _disabled;
    /** Emits when a `change` event is fired on this `<input>`. */
    dateChange = new EventEmitter();
    /** Emits when an `input` event is fired on this `<input>`. */
    dateInput = new EventEmitter();
    /** Emits when the internal state has changed */
    stateChanges = new Subject();
    _onTouched = () => {};
    _validatorOnChange = () => {};
    _cvaOnChange = () => {};
    _valueChangesSubscription = Subscription.EMPTY;
    _localeSubscription = Subscription.EMPTY;
    /**
     * Since the value is kept on the model which is assigned in an Input,
     * we might get a value before we have a model. This property keeps track
     * of the value until we have somewhere to assign it.
     */
    _pendingValue;
    /** The form control validator for whether the input parses. */
    _parseValidator = () => {
      return this._lastValueValid ? null : {
        'matDatepickerParse': {
          'text': this._elementRef.nativeElement.value
        }
      };
    };
    /** The form control validator for the date filter. */
    _filterValidator = control => {
      const controlValue = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(control.value));
      return !controlValue || this._matchesFilter(controlValue) ? null : {
        'matDatepickerFilter': true
      };
    };
    /** The form control validator for the min date. */
    _minValidator = control => {
      const controlValue = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(control.value));
      const min = this._getMinDate();
      return !min || !controlValue || this._dateAdapter.compareDate(min, controlValue) <= 0 ? null : {
        'matDatepickerMin': {
          'min': min,
          'actual': controlValue
        }
      };
    };
    /** The form control validator for the max date. */
    _maxValidator = control => {
      const controlValue = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(control.value));
      const max = this._getMaxDate();
      return !max || !controlValue || this._dateAdapter.compareDate(max, controlValue) >= 0 ? null : {
        'matDatepickerMax': {
          'max': max,
          'actual': controlValue
        }
      };
    };
    /** Gets the base validator functions. */
    _getValidators() {
      return [this._parseValidator, this._minValidator, this._maxValidator, this._filterValidator];
    }
    /** Registers a date selection model with the input. */
    _registerModel(model) {
      this._model = model;
      this._valueChangesSubscription.unsubscribe();
      if (this._pendingValue) {
        this._assignValue(this._pendingValue);
      }
      this._valueChangesSubscription = this._model.selectionChanged.subscribe(event => {
        if (this._shouldHandleChangeEvent(event)) {
          const value = this._getValueFromModel(event.selection);
          this._lastValueValid = this._isValidValue(value);
          this._cvaOnChange(value);
          this._onTouched();
          this._formatValue(value);
          this.dateInput.emit(new MatDatepickerInputEvent(this, this._elementRef.nativeElement));
          this.dateChange.emit(new MatDatepickerInputEvent(this, this._elementRef.nativeElement));
        }
      });
    }
    /** Whether the last value set on the input was valid. */
    _lastValueValid = false;
    constructor() {
      if (typeof ngDevMode === 'undefined' || ngDevMode) {
        if (!this._dateAdapter) {
          throw createMissingDateImplError('DateAdapter');
        }
        if (!this._dateFormats) {
          throw createMissingDateImplError('MAT_DATE_FORMATS');
        }
      }
      // Update the displayed date when the locale changes.
      this._localeSubscription = this._dateAdapter.localeChanges.subscribe(() => {
        this._assignValueProgrammatically(this.value);
      });
    }
    ngAfterViewInit() {
      this._isInitialized = true;
    }
    ngOnChanges(changes) {
      if (dateInputsHaveChanged(changes, this._dateAdapter)) {
        this.stateChanges.next(undefined);
      }
    }
    ngOnDestroy() {
      this._valueChangesSubscription.unsubscribe();
      this._localeSubscription.unsubscribe();
      this.stateChanges.complete();
    }
    /** @docs-private */
    registerOnValidatorChange(fn) {
      this._validatorOnChange = fn;
    }
    /** @docs-private */
    validate(c) {
      return this._validator ? this._validator(c) : null;
    }
    // Implemented as part of ControlValueAccessor.
    writeValue(value) {
      this._assignValueProgrammatically(value);
    }
    // Implemented as part of ControlValueAccessor.
    registerOnChange(fn) {
      this._cvaOnChange = fn;
    }
    // Implemented as part of ControlValueAccessor.
    registerOnTouched(fn) {
      this._onTouched = fn;
    }
    // Implemented as part of ControlValueAccessor.
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    _onKeydown(event) {
      const ctrlShiftMetaModifiers = ['ctrlKey', 'shiftKey', 'metaKey'];
      const isAltDownArrow = hasModifierKey(event, 'altKey') && event.keyCode === DOWN_ARROW && ctrlShiftMetaModifiers.every(modifier => !hasModifierKey(event, modifier));
      if (isAltDownArrow && !this._elementRef.nativeElement.readOnly) {
        this._openPopup();
        event.preventDefault();
      }
    }
    _onInput(event) {
      const value = event.target.value;
      const lastValueWasValid = this._lastValueValid;
      let date = this._dateAdapter.parse(value, this._dateFormats.parse.dateInput);
      this._lastValueValid = this._isValidValue(date);
      date = this._dateAdapter.getValidDateOrNull(date);
      const hasChanged = !this._dateAdapter.sameDate(date, this.value);
      // We need to fire the CVA change event for all
      // nulls, otherwise the validators won't run.
      if (!date || hasChanged) {
        this._cvaOnChange(date);
      } else {
        // Call the CVA change handler for invalid values
        // since this is what marks the control as dirty.
        if (value && !this.value) {
          this._cvaOnChange(date);
        }
        if (lastValueWasValid !== this._lastValueValid) {
          this._validatorOnChange();
        }
      }
      if (hasChanged) {
        this._assignValue(date);
        this.dateInput.emit(new MatDatepickerInputEvent(this, this._elementRef.nativeElement));
      }
    }
    _onChange() {
      this.dateChange.emit(new MatDatepickerInputEvent(this, this._elementRef.nativeElement));
    }
    /** Handles blur events on the input. */
    _onBlur() {
      // Reformat the input only if we have a valid value.
      if (this.value) {
        this._formatValue(this.value);
      }
      this._onTouched();
    }
    /** Formats a value and sets it on the input element. */
    _formatValue(value) {
      this._elementRef.nativeElement.value = value != null ? this._dateAdapter.format(value, this._dateFormats.display.dateInput) : '';
    }
    /** Assigns a value to the model. */
    _assignValue(value) {
      // We may get some incoming values before the model was
      // assigned. Save the value so that we can assign it later.
      if (this._model) {
        this._assignValueToModel(value);
        this._pendingValue = null;
      } else {
        this._pendingValue = value;
      }
    }
    /** Whether a value is considered valid. */
    _isValidValue(value) {
      return !value || this._dateAdapter.isValid(value);
    }
    /**
     * Checks whether a parent control is disabled. This is in place so that it can be overridden
     * by inputs extending this one which can be placed inside of a group that can be disabled.
     */
    _parentDisabled() {
      return false;
    }
    /** Programmatically assigns a value to the input. */
    _assignValueProgrammatically(value) {
      value = this._dateAdapter.deserialize(value);
      this._lastValueValid = this._isValidValue(value);
      value = this._dateAdapter.getValidDateOrNull(value);
      this._assignValue(value);
      this._formatValue(value);
    }
    /** Gets whether a value matches the current date filter. */
    _matchesFilter(value) {
      const filter = this._getDateFilter();
      return !filter || filter(value);
    }
    static ɵfac = function MatDatepickerInputBase_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatDatepickerInputBase)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatDatepickerInputBase,
      inputs: {
        value: "value",
        disabled: [2, "disabled", "disabled", booleanAttribute]
      },
      outputs: {
        dateChange: "dateChange",
        dateInput: "dateInput"
      },
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
  return MatDatepickerInputBase;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Checks whether the `SimpleChanges` object from an `ngOnChanges`
 * callback has any changes, accounting for date objects.
 */
function dateInputsHaveChanged(changes, adapter) {
  const keys = Object.keys(changes);
  for (let key of keys) {
    const {
      previousValue,
      currentValue
    } = changes[key];
    if (adapter.isDateInstance(previousValue) && adapter.isDateInstance(currentValue)) {
      if (!adapter.sameDate(previousValue, currentValue)) {
        return true;
      }
    } else {
      return true;
    }
  }
  return false;
}

/** @docs-private */
const MAT_DATEPICKER_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: /*#__PURE__*/forwardRef(() => MatDatepickerInput),
  multi: true
};
/** @docs-private */
const MAT_DATEPICKER_VALIDATORS = {
  provide: NG_VALIDATORS,
  useExisting: /*#__PURE__*/forwardRef(() => MatDatepickerInput),
  multi: true
};
/** Directive used to connect an input to a MatDatepicker. */
let MatDatepickerInput = /*#__PURE__*/(() => {
  class MatDatepickerInput extends MatDatepickerInputBase {
    _formField = inject(MAT_FORM_FIELD, {
      optional: true
    });
    _closedSubscription = Subscription.EMPTY;
    _openedSubscription = Subscription.EMPTY;
    /** The datepicker that this input is associated with. */
    set matDatepicker(datepicker) {
      if (datepicker) {
        this._datepicker = datepicker;
        this._ariaOwns.set(datepicker.opened ? datepicker.id : null);
        this._closedSubscription = datepicker.closedStream.subscribe(() => {
          this._onTouched();
          this._ariaOwns.set(null);
        });
        this._openedSubscription = datepicker.openedStream.subscribe(() => {
          this._ariaOwns.set(datepicker.id);
        });
        this._registerModel(datepicker.registerInput(this));
      }
    }
    _datepicker;
    /** The id of the panel owned by this input. */
    _ariaOwns = signal(null, ...(ngDevMode ? [{
      debugName: "_ariaOwns"
    }] : []));
    /** The minimum valid date. */
    get min() {
      return this._min;
    }
    set min(value) {
      const validValue = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
      if (!this._dateAdapter.sameDate(validValue, this._min)) {
        this._min = validValue;
        this._validatorOnChange();
      }
    }
    _min;
    /** The maximum valid date. */
    get max() {
      return this._max;
    }
    set max(value) {
      const validValue = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
      if (!this._dateAdapter.sameDate(validValue, this._max)) {
        this._max = validValue;
        this._validatorOnChange();
      }
    }
    _max;
    /** Function that can be used to filter out dates within the datepicker. */
    get dateFilter() {
      return this._dateFilter;
    }
    set dateFilter(value) {
      const wasMatchingValue = this._matchesFilter(this.value);
      this._dateFilter = value;
      if (this._matchesFilter(this.value) !== wasMatchingValue) {
        this._validatorOnChange();
      }
    }
    _dateFilter;
    /** The combined form control validator for this input. */
    _validator;
    constructor() {
      super();
      this._validator = Validators.compose(super._getValidators());
    }
    /**
     * Gets the element that the datepicker popup should be connected to.
     * @return The element to connect the popup to.
     */
    getConnectedOverlayOrigin() {
      return this._formField ? this._formField.getConnectedOverlayOrigin() : this._elementRef;
    }
    /** Gets the ID of an element that should be used a description for the calendar overlay. */
    getOverlayLabelId() {
      if (this._formField) {
        return this._formField.getLabelId();
      }
      return this._elementRef.nativeElement.getAttribute('aria-labelledby');
    }
    /** Returns the palette used by the input's form field, if any. */
    getThemePalette() {
      return this._formField ? this._formField.color : undefined;
    }
    /** Gets the value at which the calendar should start. */
    getStartValue() {
      return this.value;
    }
    ngOnDestroy() {
      super.ngOnDestroy();
      this._closedSubscription.unsubscribe();
      this._openedSubscription.unsubscribe();
    }
    /** Opens the associated datepicker. */
    _openPopup() {
      if (this._datepicker) {
        this._datepicker.open();
      }
    }
    _getValueFromModel(modelValue) {
      return modelValue;
    }
    _assignValueToModel(value) {
      if (this._model) {
        this._model.updateSelection(value, this);
      }
    }
    /** Gets the input's minimum date. */
    _getMinDate() {
      return this._min;
    }
    /** Gets the input's maximum date. */
    _getMaxDate() {
      return this._max;
    }
    /** Gets the input's date filtering function. */
    _getDateFilter() {
      return this._dateFilter;
    }
    _shouldHandleChangeEvent(event) {
      return event.source !== this;
    }
    static ɵfac = function MatDatepickerInput_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatDatepickerInput)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatDatepickerInput,
      selectors: [["input", "matDatepicker", ""]],
      hostAttrs: [1, "mat-datepicker-input"],
      hostVars: 6,
      hostBindings: function MatDatepickerInput_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("input", function MatDatepickerInput_input_HostBindingHandler($event) {
            return ctx._onInput($event);
          })("change", function MatDatepickerInput_change_HostBindingHandler() {
            return ctx._onChange();
          })("blur", function MatDatepickerInput_blur_HostBindingHandler() {
            return ctx._onBlur();
          })("keydown", function MatDatepickerInput_keydown_HostBindingHandler($event) {
            return ctx._onKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵdomProperty("disabled", ctx.disabled);
          i0.ɵɵattribute("aria-haspopup", ctx._datepicker ? "dialog" : null)("aria-owns", ctx._ariaOwns())("min", ctx.min ? ctx._dateAdapter.toIso8601(ctx.min) : null)("max", ctx.max ? ctx._dateAdapter.toIso8601(ctx.max) : null)("data-mat-calendar", ctx._datepicker ? ctx._datepicker.id : null);
        }
      },
      inputs: {
        matDatepicker: "matDatepicker",
        min: "min",
        max: "max",
        dateFilter: [0, "matDatepickerFilter", "dateFilter"]
      },
      exportAs: ["matDatepickerInput"],
      features: [i0.ɵɵProvidersFeature([MAT_DATEPICKER_VALUE_ACCESSOR, MAT_DATEPICKER_VALIDATORS, {
        provide: MAT_INPUT_VALUE_ACCESSOR,
        useExisting: MatDatepickerInput
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return MatDatepickerInput;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Can be used to override the icon of a `matDatepickerToggle`. */
let MatDatepickerToggleIcon = /*#__PURE__*/(() => {
  class MatDatepickerToggleIcon {
    static ɵfac = function MatDatepickerToggleIcon_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatDatepickerToggleIcon)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatDatepickerToggleIcon,
      selectors: [["", "matDatepickerToggleIcon", ""]]
    });
  }
  return MatDatepickerToggleIcon;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatDatepickerToggle = /*#__PURE__*/(() => {
  class MatDatepickerToggle {
    _intl = inject(MatDatepickerIntl);
    _changeDetectorRef = inject(ChangeDetectorRef);
    _stateChanges = Subscription.EMPTY;
    /** Datepicker instance that the button will toggle. */
    datepicker;
    /** Tabindex for the toggle. */
    tabIndex;
    /** Screen-reader label for the button. */
    ariaLabel;
    /** Whether the toggle button is disabled. */
    get disabled() {
      if (this._disabled === undefined && this.datepicker) {
        return this.datepicker.disabled;
      }
      return !!this._disabled;
    }
    set disabled(value) {
      this._disabled = value;
    }
    _disabled;
    /** Whether ripples on the toggle should be disabled. */
    disableRipple;
    /** Custom icon set by the consumer. */
    _customIcon;
    /** Underlying button element. */
    _button;
    constructor() {
      const defaultTabIndex = inject(new HostAttributeToken('tabindex'), {
        optional: true
      });
      const parsedTabIndex = Number(defaultTabIndex);
      this.tabIndex = parsedTabIndex || parsedTabIndex === 0 ? parsedTabIndex : null;
    }
    ngOnChanges(changes) {
      if (changes['datepicker']) {
        this._watchStateChanges();
      }
    }
    ngOnDestroy() {
      this._stateChanges.unsubscribe();
    }
    ngAfterContentInit() {
      this._watchStateChanges();
    }
    _open(event) {
      if (this.datepicker && !this.disabled) {
        this.datepicker.open();
        event.stopPropagation();
      }
    }
    _watchStateChanges() {
      const datepickerStateChanged = this.datepicker ? this.datepicker.stateChanges : of();
      const inputStateChanged = this.datepicker && this.datepicker.datepickerInput ? this.datepicker.datepickerInput.stateChanges : of();
      const datepickerToggled = this.datepicker ? merge(this.datepicker.openedStream, this.datepicker.closedStream) : of();
      this._stateChanges.unsubscribe();
      this._stateChanges = merge(this._intl.changes, datepickerStateChanged, inputStateChanged, datepickerToggled).subscribe(() => this._changeDetectorRef.markForCheck());
    }
    static ɵfac = function MatDatepickerToggle_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatDatepickerToggle)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatDatepickerToggle,
      selectors: [["mat-datepicker-toggle"]],
      contentQueries: function MatDatepickerToggle_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, MatDatepickerToggleIcon, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._customIcon = _t.first);
        }
      },
      viewQuery: function MatDatepickerToggle_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c2, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._button = _t.first);
        }
      },
      hostAttrs: [1, "mat-datepicker-toggle"],
      hostVars: 8,
      hostBindings: function MatDatepickerToggle_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function MatDatepickerToggle_click_HostBindingHandler($event) {
            return ctx._open($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("tabindex", null)("data-mat-calendar", ctx.datepicker ? ctx.datepicker.id : null);
          i0.ɵɵclassProp("mat-datepicker-toggle-active", ctx.datepicker && ctx.datepicker.opened)("mat-accent", ctx.datepicker && ctx.datepicker.color === "accent")("mat-warn", ctx.datepicker && ctx.datepicker.color === "warn");
        }
      },
      inputs: {
        datepicker: [0, "for", "datepicker"],
        tabIndex: "tabIndex",
        ariaLabel: [0, "aria-label", "ariaLabel"],
        disabled: [2, "disabled", "disabled", booleanAttribute],
        disableRipple: "disableRipple"
      },
      exportAs: ["matDatepickerToggle"],
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c4,
      decls: 4,
      vars: 7,
      consts: [["button", ""], ["matIconButton", "", "type", "button", 3, "tabIndex", "disabled", "disableRipple"], ["viewBox", "0 0 24 24", "width", "24px", "height", "24px", "fill", "currentColor", "focusable", "false", "aria-hidden", "true", 1, "mat-datepicker-toggle-default-icon"], ["d", "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"]],
      template: function MatDatepickerToggle_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c3);
          i0.ɵɵelementStart(0, "button", 1, 0);
          i0.ɵɵconditionalCreate(2, MatDatepickerToggle_Conditional_2_Template, 2, 0, ":svg:svg", 2);
          i0.ɵɵprojection(3);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("tabIndex", ctx.disabled ? -1 : ctx.tabIndex)("disabled", ctx.disabled)("disableRipple", ctx.disableRipple);
          i0.ɵɵattribute("aria-haspopup", ctx.datepicker ? "dialog" : null)("aria-label", ctx.ariaLabel || ctx._intl.openCalendarLabel)("aria-expanded", ctx.datepicker ? ctx.datepicker.opened : null);
          i0.ɵɵadvance(2);
          i0.ɵɵconditional(!ctx._customIcon ? 2 : -1);
        }
      },
      dependencies: [MatIconButton],
      styles: [".mat-datepicker-toggle{pointer-events:auto;color:var(--mat-datepicker-toggle-icon-color, var(--mat-sys-on-surface-variant))}.mat-datepicker-toggle button{color:inherit}.mat-datepicker-toggle-active{color:var(--mat-datepicker-toggle-active-state-icon-color, var(--mat-sys-primary))}@media(forced-colors: active){.mat-datepicker-toggle-default-icon{color:CanvasText}}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatDatepickerToggle;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatDateRangeInput = /*#__PURE__*/(() => {
  class MatDateRangeInput {
    _changeDetectorRef = inject(ChangeDetectorRef);
    _elementRef = inject(ElementRef);
    _dateAdapter = inject(DateAdapter, {
      optional: true
    });
    _formField = inject(MAT_FORM_FIELD, {
      optional: true
    });
    _closedSubscription = Subscription.EMPTY;
    _openedSubscription = Subscription.EMPTY;
    _startInput;
    _endInput;
    /** Current value of the range input. */
    get value() {
      return this._model ? this._model.selection : null;
    }
    /** Unique ID for the group. */
    id = inject(_IdGenerator).getId('mat-date-range-input-');
    /** Whether the control is focused. */
    focused = false;
    /** Whether the control's label should float. */
    get shouldLabelFloat() {
      return this.focused || !this.empty;
    }
    /** Name of the form control. */
    controlType = 'mat-date-range-input';
    /**
     * Implemented as a part of `MatFormFieldControl`.
     * Set the placeholder attribute on `matStartDate` and `matEndDate`.
     * @docs-private
     */
    get placeholder() {
      const start = this._startInput?._getPlaceholder() || '';
      const end = this._endInput?._getPlaceholder() || '';
      return start || end ? `${start} ${this.separator} ${end}` : '';
    }
    /** The range picker that this input is associated with. */
    get rangePicker() {
      return this._rangePicker;
    }
    set rangePicker(rangePicker) {
      if (rangePicker) {
        this._model = rangePicker.registerInput(this);
        this._rangePicker = rangePicker;
        this._closedSubscription.unsubscribe();
        this._openedSubscription.unsubscribe();
        this._ariaOwns.set(this.rangePicker.opened ? rangePicker.id : null);
        this._closedSubscription = rangePicker.closedStream.subscribe(() => {
          this._startInput?._onTouched();
          this._endInput?._onTouched();
          this._ariaOwns.set(null);
        });
        this._openedSubscription = rangePicker.openedStream.subscribe(() => {
          this._ariaOwns.set(rangePicker.id);
        });
        this._registerModel(this._model);
      }
    }
    _rangePicker;
    /** The id of the panel owned by this input. */
    _ariaOwns = signal(null, ...(ngDevMode ? [{
      debugName: "_ariaOwns"
    }] : []));
    /** Whether the input is required. */
    get required() {
      return this._required ?? (this._isTargetRequired(this) || this._isTargetRequired(this._startInput) || this._isTargetRequired(this._endInput)) ?? false;
    }
    set required(value) {
      this._required = value;
    }
    _required;
    /** Function that can be used to filter out dates within the date range picker. */
    get dateFilter() {
      return this._dateFilter;
    }
    set dateFilter(value) {
      const start = this._startInput;
      const end = this._endInput;
      const wasMatchingStart = start && start._matchesFilter(start.value);
      const wasMatchingEnd = end && end._matchesFilter(start.value);
      this._dateFilter = value;
      if (start && start._matchesFilter(start.value) !== wasMatchingStart) {
        start._validatorOnChange();
      }
      if (end && end._matchesFilter(end.value) !== wasMatchingEnd) {
        end._validatorOnChange();
      }
    }
    _dateFilter;
    /** The minimum valid date. */
    get min() {
      return this._min;
    }
    set min(value) {
      const validValue = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
      if (!this._dateAdapter.sameDate(validValue, this._min)) {
        this._min = validValue;
        this._revalidate();
      }
    }
    _min;
    /** The maximum valid date. */
    get max() {
      return this._max;
    }
    set max(value) {
      const validValue = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(value));
      if (!this._dateAdapter.sameDate(validValue, this._max)) {
        this._max = validValue;
        this._revalidate();
      }
    }
    _max;
    /** Whether the input is disabled. */
    get disabled() {
      return this._startInput && this._endInput ? this._startInput.disabled && this._endInput.disabled : this._groupDisabled;
    }
    set disabled(value) {
      if (value !== this._groupDisabled) {
        this._groupDisabled = value;
        this.stateChanges.next(undefined);
      }
    }
    _groupDisabled = false;
    /** Whether the input is in an error state. */
    get errorState() {
      if (this._startInput && this._endInput) {
        return this._startInput.errorState || this._endInput.errorState;
      }
      return false;
    }
    /** Whether the datepicker input is empty. */
    get empty() {
      const startEmpty = this._startInput ? this._startInput.isEmpty() : false;
      const endEmpty = this._endInput ? this._endInput.isEmpty() : false;
      return startEmpty && endEmpty;
    }
    /** Value for the `aria-describedby` attribute of the inputs. */
    _ariaDescribedBy = null;
    /** Date selection model currently registered with the input. */
    _model;
    /** Separator text to be shown between the inputs. */
    separator = '–';
    /** Start of the comparison range that should be shown in the calendar. */
    comparisonStart = null;
    /** End of the comparison range that should be shown in the calendar. */
    comparisonEnd = null;
    /**
     * Implemented as a part of `MatFormFieldControl`.
     * TODO(crisbeto): change type to `AbstractControlDirective` after #18206 lands.
     * @docs-private
     */
    ngControl;
    /** Emits when the input's state has changed. */
    stateChanges = new Subject();
    /**
     * Disable the automatic labeling to avoid issues like #27241.
     * @docs-private
     */
    disableAutomaticLabeling = true;
    constructor() {
      if (!this._dateAdapter && (typeof ngDevMode === 'undefined' || ngDevMode)) {
        throw createMissingDateImplError('DateAdapter');
      }
      // The datepicker module can be used both with MDC and non-MDC form fields. We have
      // to conditionally add the MDC input class so that the range picker looks correctly.
      if (this._formField?._elementRef.nativeElement.classList.contains('mat-mdc-form-field')) {
        this._elementRef.nativeElement.classList.add('mat-mdc-input-element', 'mat-mdc-form-field-input-control', 'mdc-text-field__input');
      }
      // TODO(crisbeto): remove `as any` after #18206 lands.
      this.ngControl = inject(ControlContainer, {
        optional: true,
        self: true
      });
    }
    /**
     * Implemented as part of MatFormFieldControl.
     * @docs-private
     */
    get describedByIds() {
      const element = this._elementRef.nativeElement;
      const existingDescribedBy = element.getAttribute('aria-describedby');
      return existingDescribedBy?.split(' ') || [];
    }
    /**
     * Implemented as a part of `MatFormFieldControl`.
     * @docs-private
     */
    setDescribedByIds(ids) {
      this._ariaDescribedBy = ids.length ? ids.join(' ') : null;
    }
    /**
     * Implemented as a part of `MatFormFieldControl`.
     * @docs-private
     */
    onContainerClick() {
      if (!this.focused && !this.disabled) {
        if (!this._model || !this._model.selection.start) {
          this._startInput.focus();
        } else {
          this._endInput.focus();
        }
      }
    }
    ngAfterContentInit() {
      if (typeof ngDevMode === 'undefined' || ngDevMode) {
        if (!this._startInput) {
          throw Error('mat-date-range-input must contain a matStartDate input');
        }
        if (!this._endInput) {
          throw Error('mat-date-range-input must contain a matEndDate input');
        }
      }
      if (this._model) {
        this._registerModel(this._model);
      }
      // We don't need to unsubscribe from this, because we
      // know that the input streams will be completed on destroy.
      merge(this._startInput.stateChanges, this._endInput.stateChanges).subscribe(() => {
        this.stateChanges.next(undefined);
      });
    }
    ngOnChanges(changes) {
      if (dateInputsHaveChanged(changes, this._dateAdapter)) {
        this.stateChanges.next(undefined);
      }
    }
    ngOnDestroy() {
      this._closedSubscription.unsubscribe();
      this._openedSubscription.unsubscribe();
      this.stateChanges.complete();
    }
    /** Gets the date at which the calendar should start. */
    getStartValue() {
      return this.value ? this.value.start : null;
    }
    /** Gets the input's theme palette. */
    getThemePalette() {
      return this._formField ? this._formField.color : undefined;
    }
    /** Gets the element to which the calendar overlay should be attached. */
    getConnectedOverlayOrigin() {
      return this._formField ? this._formField.getConnectedOverlayOrigin() : this._elementRef;
    }
    /** Gets the ID of an element that should be used a description for the calendar overlay. */
    getOverlayLabelId() {
      return this._formField ? this._formField.getLabelId() : null;
    }
    /** Gets the value that is used to mirror the state input. */
    _getInputMirrorValue(part) {
      const input = part === 'start' ? this._startInput : this._endInput;
      return input ? input.getMirrorValue() : '';
    }
    /** Whether the input placeholders should be hidden. */
    _shouldHidePlaceholders() {
      return this._startInput ? !this._startInput.isEmpty() : false;
    }
    /** Handles the value in one of the child inputs changing. */
    _handleChildValueChange() {
      this.stateChanges.next(undefined);
      this._changeDetectorRef.markForCheck();
    }
    /** Opens the date range picker associated with the input. */
    _openDatepicker() {
      if (this._rangePicker) {
        this._rangePicker.open();
      }
    }
    /** Whether the separate text should be hidden. */
    _shouldHideSeparator() {
      return (!this._formField || this._formField.getLabelId() && !this._formField._shouldLabelFloat()) && this.empty;
    }
    /** Gets the value for the `aria-labelledby` attribute of the inputs. */
    _getAriaLabelledby() {
      const formField = this._formField;
      return formField && formField._hasFloatingLabel() ? formField._labelId : null;
    }
    _getStartDateAccessibleName() {
      return this._startInput._getAccessibleName();
    }
    _getEndDateAccessibleName() {
      return this._endInput._getAccessibleName();
    }
    /** Updates the focused state of the range input. */
    _updateFocus(origin) {
      this.focused = origin !== null;
      this.stateChanges.next();
    }
    /** Re-runs the validators on the start/end inputs. */
    _revalidate() {
      if (this._startInput) {
        this._startInput._validatorOnChange();
      }
      if (this._endInput) {
        this._endInput._validatorOnChange();
      }
    }
    /** Registers the current date selection model with the start/end inputs. */
    _registerModel(model) {
      if (this._startInput) {
        this._startInput._registerModel(model);
      }
      if (this._endInput) {
        this._endInput._registerModel(model);
      }
    }
    /** Checks whether a specific range input directive is required. */
    _isTargetRequired(target) {
      return target?.ngControl?.control?.hasValidator(Validators.required);
    }
    static ɵfac = function MatDateRangeInput_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatDateRangeInput)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatDateRangeInput,
      selectors: [["mat-date-range-input"]],
      hostAttrs: ["role", "group", 1, "mat-date-range-input"],
      hostVars: 8,
      hostBindings: function MatDateRangeInput_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("id", ctx.id)("aria-labelledby", ctx._getAriaLabelledby())("aria-describedby", ctx._ariaDescribedBy)("data-mat-calendar", ctx.rangePicker ? ctx.rangePicker.id : null);
          i0.ɵɵclassProp("mat-date-range-input-hide-placeholders", ctx._shouldHidePlaceholders())("mat-date-range-input-required", ctx.required);
        }
      },
      inputs: {
        rangePicker: "rangePicker",
        required: [2, "required", "required", booleanAttribute],
        dateFilter: "dateFilter",
        min: "min",
        max: "max",
        disabled: [2, "disabled", "disabled", booleanAttribute],
        separator: "separator",
        comparisonStart: "comparisonStart",
        comparisonEnd: "comparisonEnd"
      },
      exportAs: ["matDateRangeInput"],
      features: [i0.ɵɵProvidersFeature([{
        provide: MatFormFieldControl,
        useExisting: MatDateRangeInput
      }]), i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c6,
      decls: 11,
      vars: 5,
      consts: [["cdkMonitorSubtreeFocus", "", 1, "mat-date-range-input-container", 3, "cdkFocusChange"], [1, "mat-date-range-input-wrapper"], ["aria-hidden", "true", 1, "mat-date-range-input-mirror"], [1, "mat-date-range-input-separator"], [1, "mat-date-range-input-wrapper", "mat-date-range-input-end-wrapper"]],
      template: function MatDateRangeInput_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef(_c5);
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("cdkFocusChange", function MatDateRangeInput_Template_div_cdkFocusChange_0_listener($event) {
            return ctx._updateFocus($event);
          });
          i0.ɵɵelementStart(1, "div", 1);
          i0.ɵɵprojection(2);
          i0.ɵɵelementStart(3, "span", 2);
          i0.ɵɵtext(4);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(5, "span", 3);
          i0.ɵɵtext(6);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(7, "div", 4);
          i0.ɵɵprojection(8, 1);
          i0.ɵɵelementStart(9, "span", 2);
          i0.ɵɵtext(10);
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(ctx._getInputMirrorValue("start"));
          i0.ɵɵadvance();
          i0.ɵɵclassProp("mat-date-range-input-separator-hidden", ctx._shouldHideSeparator());
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(ctx.separator);
          i0.ɵɵadvance(4);
          i0.ɵɵtextInterpolate(ctx._getInputMirrorValue("end"));
        }
      },
      dependencies: [CdkMonitorFocus],
      styles: [".mat-date-range-input{display:block;width:100%}.mat-date-range-input-container{display:flex;align-items:center}.mat-date-range-input-separator{transition:opacity 400ms 133.3333333333ms cubic-bezier(0.25, 0.8, 0.25, 1);margin:0 4px;color:var(--mat-datepicker-range-input-separator-color, var(--mat-sys-on-surface))}.mat-form-field-disabled .mat-date-range-input-separator{color:var(--mat-datepicker-range-input-disabled-state-separator-color, color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent))}._mat-animation-noopable .mat-date-range-input-separator{transition:none}.mat-date-range-input-separator-hidden{-webkit-user-select:none;user-select:none;opacity:0;transition:none}.mat-date-range-input-wrapper{position:relative;overflow:hidden;max-width:calc(50% - 4px)}.mat-date-range-input-end-wrapper{flex-grow:1}.mat-date-range-input-inner{position:absolute;top:0;left:0;font:inherit;background:rgba(0,0,0,0);color:currentColor;border:none;outline:none;padding:0;margin:0;vertical-align:bottom;text-align:inherit;-webkit-appearance:none;width:100%;height:100%}.mat-date-range-input-inner:-moz-ui-invalid{box-shadow:none}.mat-date-range-input-inner::placeholder{transition:color 400ms 133.3333333333ms cubic-bezier(0.25, 0.8, 0.25, 1)}.mat-date-range-input-inner::-moz-placeholder{transition:color 400ms 133.3333333333ms cubic-bezier(0.25, 0.8, 0.25, 1)}.mat-date-range-input-inner::-webkit-input-placeholder{transition:color 400ms 133.3333333333ms cubic-bezier(0.25, 0.8, 0.25, 1)}.mat-date-range-input-inner:-ms-input-placeholder{transition:color 400ms 133.3333333333ms cubic-bezier(0.25, 0.8, 0.25, 1)}.mat-date-range-input-inner[disabled]{color:var(--mat-datepicker-range-input-disabled-state-text-color, color-mix(in srgb, var(--mat-sys-on-surface) 38%, transparent))}.mat-form-field-hide-placeholder .mat-date-range-input-inner::placeholder,.mat-date-range-input-hide-placeholders .mat-date-range-input-inner::placeholder{-webkit-user-select:none;user-select:none;color:rgba(0,0,0,0) !important;-webkit-text-fill-color:rgba(0,0,0,0);transition:none}@media(forced-colors: active){.mat-form-field-hide-placeholder .mat-date-range-input-inner::placeholder,.mat-date-range-input-hide-placeholders .mat-date-range-input-inner::placeholder{opacity:0}}.mat-form-field-hide-placeholder .mat-date-range-input-inner::-moz-placeholder,.mat-date-range-input-hide-placeholders .mat-date-range-input-inner::-moz-placeholder{-webkit-user-select:none;user-select:none;color:rgba(0,0,0,0) !important;-webkit-text-fill-color:rgba(0,0,0,0);transition:none}@media(forced-colors: active){.mat-form-field-hide-placeholder .mat-date-range-input-inner::-moz-placeholder,.mat-date-range-input-hide-placeholders .mat-date-range-input-inner::-moz-placeholder{opacity:0}}.mat-form-field-hide-placeholder .mat-date-range-input-inner::-webkit-input-placeholder,.mat-date-range-input-hide-placeholders .mat-date-range-input-inner::-webkit-input-placeholder{-webkit-user-select:none;user-select:none;color:rgba(0,0,0,0) !important;-webkit-text-fill-color:rgba(0,0,0,0);transition:none}@media(forced-colors: active){.mat-form-field-hide-placeholder .mat-date-range-input-inner::-webkit-input-placeholder,.mat-date-range-input-hide-placeholders .mat-date-range-input-inner::-webkit-input-placeholder{opacity:0}}.mat-form-field-hide-placeholder .mat-date-range-input-inner:-ms-input-placeholder,.mat-date-range-input-hide-placeholders .mat-date-range-input-inner:-ms-input-placeholder{-webkit-user-select:none;user-select:none;color:rgba(0,0,0,0) !important;-webkit-text-fill-color:rgba(0,0,0,0);transition:none}@media(forced-colors: active){.mat-form-field-hide-placeholder .mat-date-range-input-inner:-ms-input-placeholder,.mat-date-range-input-hide-placeholders .mat-date-range-input-inner:-ms-input-placeholder{opacity:0}}._mat-animation-noopable .mat-date-range-input-inner::placeholder{transition:none}._mat-animation-noopable .mat-date-range-input-inner::-moz-placeholder{transition:none}._mat-animation-noopable .mat-date-range-input-inner::-webkit-input-placeholder{transition:none}._mat-animation-noopable .mat-date-range-input-inner:-ms-input-placeholder{transition:none}.mat-date-range-input-mirror{-webkit-user-select:none;user-select:none;visibility:hidden;white-space:nowrap;display:inline-block;min-width:2px}.mat-mdc-form-field-type-mat-date-range-input .mat-mdc-form-field-infix{width:200px}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatDateRangeInput;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// This file contains the `_computeAriaAccessibleName` function, which computes what the *expected*
// ARIA accessible name would be for a given element. Implements a subset of ARIA specification
// [Accessible Name and Description Computation 1.2](https://www.w3.org/TR/accname-1.2/).
//
// Specification accname-1.2 can be summarized by returning the result of the first method
// available.
//
//  1. `aria-labelledby` attribute
//     ```
//       <!-- example using aria-labelledby-->
//       <label id='label-id'>Start Date</label>
//       <input aria-labelledby='label-id'/>
//     ```
//  2. `aria-label` attribute (e.g. `<input aria-label="Departure"/>`)
//  3. Label with `for`/`id`
//     ```
//       <!-- example using for/id -->
//       <label for="current-node">Label</label>
//       <input id="current-node"/>
//     ```
//  4. `placeholder` attribute (e.g. `<input placeholder="06/03/1990"/>`)
//  5. `title` attribute (e.g. `<input title="Check-In"/>`)
//  6. text content
//     ```
//       <!-- example using text content -->
//       <label for="current-node"><span>Departure</span> Date</label>
//       <input id="current-node"/>
//     ```
/**
 * Computes the *expected* ARIA accessible name for argument element based on [accname-1.2
 * specification](https://www.w3.org/TR/accname-1.2/). Implements a subset of accname-1.2,
 * and should only be used for the Datepicker's specific use case.
 *
 * Intended use:
 * This is not a general use implementation. Only implements the parts of accname-1.2 that are
 * required for the Datepicker's specific use case. This function is not intended for any other
 * use.
 *
 * Limitations:
 *  - Only covers the needs of `matStartDate` and `matEndDate`. Does not support other use cases.
 *  - See NOTES's in implementation for specific details on what parts of the accname-1.2
 *  specification are not implemented.
 *
 *  @param element {HTMLInputElement} native &lt;input/&gt; element of `matStartDate` or
 *  `matEndDate` component. Corresponds to the 'Root Element' from accname-1.2
 *
 *  @return expected ARIA accessible name of argument &lt;input/&gt;
 */
function _computeAriaAccessibleName(element) {
  return _computeAriaAccessibleNameInternal(element, true);
}
/**
 * Determine if argument node is an Element based on `nodeType` property. This function is safe to
 * use with server-side rendering.
 */
function ssrSafeIsElement(node) {
  return node.nodeType === Node.ELEMENT_NODE;
}
/**
 * Determine if argument node is an HTMLInputElement based on `nodeName` property. This funciton is
 * safe to use with server-side rendering.
 */
function ssrSafeIsHTMLInputElement(node) {
  return node.nodeName === 'INPUT';
}
/**
 * Determine if argument node is an HTMLTextAreaElement based on `nodeName` property. This
 * funciton is safe to use with server-side rendering.
 */
function ssrSafeIsHTMLTextAreaElement(node) {
  return node.nodeName === 'TEXTAREA';
}
/**
 * Calculate the expected ARIA accessible name for given DOM Node. Given DOM Node may be either the
 * "Root node" passed to `_computeAriaAccessibleName` or "Current node" as result of recursion.
 *
 * @return the accessible name of argument DOM Node
 *
 * @param currentNode node to determine accessible name of
 * @param isDirectlyReferenced true if `currentNode` is the root node to calculate ARIA accessible
 * name of. False if it is a result of recursion.
 */
function _computeAriaAccessibleNameInternal(currentNode, isDirectlyReferenced) {
  // NOTE: this differs from accname-1.2 specification.
  //  - Does not implement Step 1. of accname-1.2: '''If `currentNode`'s role prohibits naming,
  //    return the empty string ("")'''.
  //  - Does not implement Step 2.A. of accname-1.2: '''if current node is hidden and not directly
  //    referenced by aria-labelledby... return the empty string.'''
  // acc-name-1.2 Step 2.B.: aria-labelledby
  if (ssrSafeIsElement(currentNode) && isDirectlyReferenced) {
    const labelledbyIds = currentNode.getAttribute?.('aria-labelledby')?.split(/\s+/g) || [];
    const validIdRefs = labelledbyIds.reduce((validIds, id) => {
      const elem = document.getElementById(id);
      if (elem) {
        validIds.push(elem);
      }
      return validIds;
    }, []);
    if (validIdRefs.length) {
      return validIdRefs.map(idRef => {
        return _computeAriaAccessibleNameInternal(idRef, false);
      }).join(' ');
    }
  }
  // acc-name-1.2 Step 2.C.: aria-label
  if (ssrSafeIsElement(currentNode)) {
    const ariaLabel = currentNode.getAttribute('aria-label')?.trim();
    if (ariaLabel) {
      return ariaLabel;
    }
  }
  // acc-name-1.2 Step 2.D. attribute or element that defines a text alternative
  //
  // NOTE: this differs from accname-1.2 specification.
  // Only implements Step 2.D. for `<label>`,`<input/>`, and `<textarea/>` element. Does not
  // implement other elements that have an attribute or element that defines a text alternative.
  if (ssrSafeIsHTMLInputElement(currentNode) || ssrSafeIsHTMLTextAreaElement(currentNode)) {
    // use label with a `for` attribute referencing the current node
    if (currentNode.labels?.length) {
      return Array.from(currentNode.labels).map(x => _computeAriaAccessibleNameInternal(x, false)).join(' ');
    }
    // use placeholder if available
    const placeholder = currentNode.getAttribute('placeholder')?.trim();
    if (placeholder) {
      return placeholder;
    }
    // use title if available
    const title = currentNode.getAttribute('title')?.trim();
    if (title) {
      return title;
    }
  }
  // NOTE: this differs from accname-1.2 specification.
  //  - does not implement acc-name-1.2 Step 2.E.: '''if the current node is a control embedded
  //     within the label... then include the embedded control as part of the text alternative in
  //     the following manner...'''. Step 2E applies to embedded controls such as textbox, listbox,
  //     range, etc.
  //  - does not implement acc-name-1.2 step 2.F.: check that '''role allows name from content''',
  //    which applies to `currentNode` and its children.
  //  - does not implement acc-name-1.2 Step 2.F.ii.: '''Check for CSS generated textual content'''
  //    (e.g. :before and :after).
  //  - does not implement acc-name-1.2 Step 2.I.: '''if the current node has a Tooltip attribute,
  //    return its value'''
  // Return text content with whitespace collapsed into a single space character. Accomplish
  // acc-name-1.2 steps 2F, 2G, and 2H.
  return (currentNode.textContent || '').replace(/\s+/g, ' ').trim();
}

/**
 * Base class for the individual inputs that can be projected inside a `mat-date-range-input`.
 */
let MatDateRangeInputPartBase = /*#__PURE__*/(() => {
  class MatDateRangeInputPartBase extends MatDatepickerInputBase {
    _rangeInput = inject(MatDateRangeInput);
    _elementRef = inject(ElementRef);
    _defaultErrorStateMatcher = inject(ErrorStateMatcher);
    _injector = inject(Injector);
    _rawValue = signal('', ...(ngDevMode ? [{
      debugName: "_rawValue"
    }] : []));
    _parentForm = inject(NgForm, {
      optional: true
    });
    _parentFormGroup = inject(FormGroupDirective, {
      optional: true
    });
    /**
     * Form control bound to this input part.
     * @docs-private
     */
    ngControl;
    _dir = inject(Directionality, {
      optional: true
    });
    _errorStateTracker;
    /** Object used to control when error messages are shown. */
    get errorStateMatcher() {
      return this._errorStateTracker.matcher;
    }
    set errorStateMatcher(value) {
      this._errorStateTracker.matcher = value;
    }
    /** Whether the input is in an error state. */
    get errorState() {
      return this._errorStateTracker.errorState;
    }
    set errorState(value) {
      this._errorStateTracker.errorState = value;
    }
    constructor() {
      super();
      this._errorStateTracker = new _ErrorStateTracker(this._defaultErrorStateMatcher, null, this._parentFormGroup, this._parentForm, this.stateChanges);
    }
    ngOnInit() {
      // We need the date input to provide itself as a `ControlValueAccessor` and a `Validator`, while
      // injecting its `NgControl` so that the error state is handled correctly. This introduces a
      // circular dependency, because both `ControlValueAccessor` and `Validator` depend on the input
      // itself. Usually we can work around it for the CVA, but there's no API to do it for the
      // validator. We work around it here by injecting the `NgControl` in `ngOnInit`, after
      // everything has been resolved.
      const ngControl = this._injector.get(NgControl, null, {
        optional: true,
        self: true
      });
      if (ngControl) {
        this.ngControl = ngControl;
        this._errorStateTracker.ngControl = ngControl;
      }
    }
    ngAfterContentInit() {
      this._register();
    }
    ngDoCheck() {
      if (this.ngControl) {
        // We need to re-evaluate this on every change detection cycle, because there are some
        // error triggers that we can't subscribe to (e.g. parent form submissions). This means
        // that whatever logic is in here has to be super lean or we risk destroying the performance.
        this.updateErrorState();
      }
      this._rawValue.set(this._elementRef.nativeElement.value);
    }
    /** Gets whether the input is empty. */
    isEmpty() {
      return this._rawValue().length === 0;
    }
    /** Gets the placeholder of the input. */
    _getPlaceholder() {
      return this._elementRef.nativeElement.placeholder;
    }
    /** Focuses the input. */
    focus() {
      this._elementRef.nativeElement.focus();
    }
    /** Gets the value that should be used when mirroring the input's size. */
    getMirrorValue() {
      const value = this._rawValue();
      return value.length > 0 ? value : this._getPlaceholder();
    }
    /** Refreshes the error state of the input. */
    updateErrorState() {
      this._errorStateTracker.updateErrorState();
    }
    /** Handles `input` events on the input element. */
    _onInput(event) {
      super._onInput(event);
      this._rangeInput._handleChildValueChange();
    }
    /** Opens the datepicker associated with the input. */
    _openPopup() {
      this._rangeInput._openDatepicker();
    }
    /** Gets the minimum date from the range input. */
    _getMinDate() {
      return this._rangeInput.min;
    }
    /** Gets the maximum date from the range input. */
    _getMaxDate() {
      return this._rangeInput.max;
    }
    /** Gets the date filter function from the range input. */
    _getDateFilter() {
      return this._rangeInput.dateFilter;
    }
    _parentDisabled() {
      return this._rangeInput._groupDisabled;
    }
    _shouldHandleChangeEvent({
      source
    }) {
      return source !== this._rangeInput._startInput && source !== this._rangeInput._endInput;
    }
    _assignValueProgrammatically(value) {
      super._assignValueProgrammatically(value);
      const opposite = this === this._rangeInput._startInput ? this._rangeInput._endInput : this._rangeInput._startInput;
      opposite?._validatorOnChange();
      this._rawValue.set(this._elementRef.nativeElement.value);
    }
    _formatValue(value) {
      super._formatValue(value);
      // Any time the input value is reformatted we need to tell the parent.
      this._rangeInput._handleChildValueChange();
    }
    /** return the ARIA accessible name of the input element */
    _getAccessibleName() {
      return _computeAriaAccessibleName(this._elementRef.nativeElement);
    }
    static ɵfac = function MatDateRangeInputPartBase_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatDateRangeInputPartBase)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatDateRangeInputPartBase,
      inputs: {
        errorStateMatcher: "errorStateMatcher"
      },
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
  return MatDateRangeInputPartBase;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** Input for entering the start date in a `mat-date-range-input`. */
let MatStartDate = /*#__PURE__*/(() => {
  class MatStartDate extends MatDateRangeInputPartBase {
    /** Validator that checks that the start date isn't after the end date. */
    _startValidator = control => {
      const start = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(control.value));
      const end = this._model ? this._model.selection.end : null;
      return !start || !end || this._dateAdapter.compareDate(start, end) <= 0 ? null : {
        'matStartDateInvalid': {
          'end': end,
          'actual': start
        }
      };
    };
    _validator = Validators.compose([...super._getValidators(), this._startValidator]);
    _register() {
      this._rangeInput._startInput = this;
    }
    _getValueFromModel(modelValue) {
      return modelValue.start;
    }
    _shouldHandleChangeEvent(change) {
      if (!super._shouldHandleChangeEvent(change)) {
        return false;
      } else {
        return !change.oldValue?.start ? !!change.selection.start : !change.selection.start || !!this._dateAdapter.compareDate(change.oldValue.start, change.selection.start);
      }
    }
    _assignValueToModel(value) {
      if (this._model) {
        const range = new DateRange(value, this._model.selection.end);
        this._model.updateSelection(range, this);
        this._rangeInput._handleChildValueChange();
      }
    }
    _onKeydown(event) {
      const endInput = this._rangeInput._endInput;
      const element = this._elementRef.nativeElement;
      const isLtr = this._dir?.value !== 'rtl';
      // If the user hits RIGHT (LTR) when at the end of the input (and no
      // selection), move the cursor to the start of the end input.
      if ((event.keyCode === RIGHT_ARROW && isLtr || event.keyCode === LEFT_ARROW && !isLtr) && element.selectionStart === element.value.length && element.selectionEnd === element.value.length) {
        event.preventDefault();
        endInput._elementRef.nativeElement.setSelectionRange(0, 0);
        endInput.focus();
      } else {
        super._onKeydown(event);
      }
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatStartDate_BaseFactory;
      return function MatStartDate_Factory(__ngFactoryType__) {
        return (ɵMatStartDate_BaseFactory || (ɵMatStartDate_BaseFactory = i0.ɵɵgetInheritedFactory(MatStartDate)))(__ngFactoryType__ || MatStartDate);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatStartDate,
      selectors: [["input", "matStartDate", ""]],
      hostAttrs: ["type", "text", 1, "mat-start-date", "mat-date-range-input-inner"],
      hostVars: 5,
      hostBindings: function MatStartDate_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("input", function MatStartDate_input_HostBindingHandler($event) {
            return ctx._onInput($event);
          })("change", function MatStartDate_change_HostBindingHandler() {
            return ctx._onChange();
          })("keydown", function MatStartDate_keydown_HostBindingHandler($event) {
            return ctx._onKeydown($event);
          })("blur", function MatStartDate_blur_HostBindingHandler() {
            return ctx._onBlur();
          });
        }
        if (rf & 2) {
          i0.ɵɵdomProperty("disabled", ctx.disabled);
          i0.ɵɵattribute("aria-haspopup", ctx._rangeInput.rangePicker ? "dialog" : null)("aria-owns", ctx._rangeInput._ariaOwns() || null)("min", ctx._getMinDate() ? ctx._dateAdapter.toIso8601(ctx._getMinDate()) : null)("max", ctx._getMaxDate() ? ctx._dateAdapter.toIso8601(ctx._getMaxDate()) : null);
        }
      },
      outputs: {
        dateChange: "dateChange",
        dateInput: "dateInput"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: MatStartDate,
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: MatStartDate,
        multi: true
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return MatStartDate;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** Input for entering the end date in a `mat-date-range-input`. */
let MatEndDate = /*#__PURE__*/(() => {
  class MatEndDate extends MatDateRangeInputPartBase {
    /** Validator that checks that the end date isn't before the start date. */
    _endValidator = control => {
      const end = this._dateAdapter.getValidDateOrNull(this._dateAdapter.deserialize(control.value));
      const start = this._model ? this._model.selection.start : null;
      return !end || !start || this._dateAdapter.compareDate(end, start) >= 0 ? null : {
        'matEndDateInvalid': {
          'start': start,
          'actual': end
        }
      };
    };
    _register() {
      this._rangeInput._endInput = this;
    }
    _validator = Validators.compose([...super._getValidators(), this._endValidator]);
    _getValueFromModel(modelValue) {
      return modelValue.end;
    }
    _shouldHandleChangeEvent(change) {
      if (!super._shouldHandleChangeEvent(change)) {
        return false;
      } else {
        return !change.oldValue?.end ? !!change.selection.end : !change.selection.end || !!this._dateAdapter.compareDate(change.oldValue.end, change.selection.end);
      }
    }
    _assignValueToModel(value) {
      if (this._model) {
        const range = new DateRange(this._model.selection.start, value);
        this._model.updateSelection(range, this);
      }
    }
    _moveCaretToEndOfStartInput() {
      const startInput = this._rangeInput._startInput._elementRef.nativeElement;
      const value = startInput.value;
      if (value.length > 0) {
        startInput.setSelectionRange(value.length, value.length);
      }
      startInput.focus();
    }
    _onKeydown(event) {
      const element = this._elementRef.nativeElement;
      const isLtr = this._dir?.value !== 'rtl';
      // If the user is pressing backspace on an empty end input, move focus back to the start.
      if (event.keyCode === BACKSPACE && !element.value) {
        this._moveCaretToEndOfStartInput();
      }
      // If the user hits LEFT (LTR) when at the start of the input (and no
      // selection), move the cursor to the end of the start input.
      else if ((event.keyCode === LEFT_ARROW && isLtr || event.keyCode === RIGHT_ARROW && !isLtr) && element.selectionStart === 0 && element.selectionEnd === 0) {
        event.preventDefault();
        this._moveCaretToEndOfStartInput();
      } else {
        super._onKeydown(event);
      }
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatEndDate_BaseFactory;
      return function MatEndDate_Factory(__ngFactoryType__) {
        return (ɵMatEndDate_BaseFactory || (ɵMatEndDate_BaseFactory = i0.ɵɵgetInheritedFactory(MatEndDate)))(__ngFactoryType__ || MatEndDate);
      };
    })();
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatEndDate,
      selectors: [["input", "matEndDate", ""]],
      hostAttrs: ["type", "text", 1, "mat-end-date", "mat-date-range-input-inner"],
      hostVars: 5,
      hostBindings: function MatEndDate_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("input", function MatEndDate_input_HostBindingHandler($event) {
            return ctx._onInput($event);
          })("change", function MatEndDate_change_HostBindingHandler() {
            return ctx._onChange();
          })("keydown", function MatEndDate_keydown_HostBindingHandler($event) {
            return ctx._onKeydown($event);
          })("blur", function MatEndDate_blur_HostBindingHandler() {
            return ctx._onBlur();
          });
        }
        if (rf & 2) {
          i0.ɵɵdomProperty("disabled", ctx.disabled);
          i0.ɵɵattribute("aria-haspopup", ctx._rangeInput.rangePicker ? "dialog" : null)("aria-owns", ctx._rangeInput._ariaOwns() || null)("min", ctx._getMinDate() ? ctx._dateAdapter.toIso8601(ctx._getMinDate()) : null)("max", ctx._getMaxDate() ? ctx._dateAdapter.toIso8601(ctx._getMaxDate()) : null);
        }
      },
      outputs: {
        dateChange: "dateChange",
        dateInput: "dateInput"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: MatEndDate,
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: MatEndDate,
        multi: true
      }]), i0.ɵɵInheritDefinitionFeature]
    });
  }
  return MatEndDate;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO(mmalerba): We use a component instead of a directive here so the user can use implicit
// template reference variables (e.g. #d vs #d="matDateRangePicker"). We can change this to a
// directive if angular adds support for `exportAs: '$implicit'` on directives.
/** Component responsible for managing the date range picker popup/dialog. */
let MatDateRangePicker = /*#__PURE__*/(() => {
  class MatDateRangePicker extends MatDatepickerBase {
    _forwardContentValues(instance) {
      super._forwardContentValues(instance);
      const input = this.datepickerInput;
      if (input) {
        instance.comparisonStart = input.comparisonStart;
        instance.comparisonEnd = input.comparisonEnd;
        instance.startDateAccessibleName = input._getStartDateAccessibleName();
        instance.endDateAccessibleName = input._getEndDateAccessibleName();
      }
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵMatDateRangePicker_BaseFactory;
      return function MatDateRangePicker_Factory(__ngFactoryType__) {
        return (ɵMatDateRangePicker_BaseFactory || (ɵMatDateRangePicker_BaseFactory = i0.ɵɵgetInheritedFactory(MatDateRangePicker)))(__ngFactoryType__ || MatDateRangePicker);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatDateRangePicker,
      selectors: [["mat-date-range-picker"]],
      exportAs: ["matDateRangePicker"],
      features: [i0.ɵɵProvidersFeature([MAT_RANGE_DATE_SELECTION_MODEL_PROVIDER, MAT_CALENDAR_RANGE_STRATEGY_PROVIDER, {
        provide: MatDatepickerBase,
        useExisting: MatDateRangePicker
      }]), i0.ɵɵInheritDefinitionFeature],
      decls: 0,
      vars: 0,
      template: function MatDateRangePicker_Template(rf, ctx) {},
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatDateRangePicker;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Button that will close the datepicker and assign the current selection to the data model. */
let MatDatepickerApply = /*#__PURE__*/(() => {
  class MatDatepickerApply {
    _datepicker = inject(MatDatepickerBase);
    constructor() {}
    _applySelection() {
      this._datepicker._applyPendingSelection();
      this._datepicker.close();
    }
    static ɵfac = function MatDatepickerApply_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatDatepickerApply)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatDatepickerApply,
      selectors: [["", "matDatepickerApply", ""], ["", "matDateRangePickerApply", ""]],
      hostBindings: function MatDatepickerApply_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function MatDatepickerApply_click_HostBindingHandler() {
            return ctx._applySelection();
          });
        }
      }
    });
  }
  return MatDatepickerApply;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/** Button that will close the datepicker and discard the current selection. */
let MatDatepickerCancel = /*#__PURE__*/(() => {
  class MatDatepickerCancel {
    _datepicker = inject(MatDatepickerBase);
    constructor() {}
    static ɵfac = function MatDatepickerCancel_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatDatepickerCancel)();
    };
    static ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: MatDatepickerCancel,
      selectors: [["", "matDatepickerCancel", ""], ["", "matDateRangePickerCancel", ""]],
      hostBindings: function MatDatepickerCancel_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function MatDatepickerCancel_click_HostBindingHandler() {
            return ctx._datepicker.close();
          });
        }
      }
    });
  }
  return MatDatepickerCancel;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 * Container that can be used to project a row of action buttons
 * to the bottom of a datepicker or date range picker.
 */
let MatDatepickerActions = /*#__PURE__*/(() => {
  class MatDatepickerActions {
    _datepicker = inject(MatDatepickerBase);
    _viewContainerRef = inject(ViewContainerRef);
    _template;
    _portal;
    constructor() {}
    ngAfterViewInit() {
      this._portal = new TemplatePortal(this._template, this._viewContainerRef);
      this._datepicker.registerActions(this._portal);
    }
    ngOnDestroy() {
      this._datepicker.removeActions(this._portal);
      // Needs to be null checked since we initialize it in `ngAfterViewInit`.
      if (this._portal && this._portal.isAttached) {
        this._portal?.detach();
      }
    }
    static ɵfac = function MatDatepickerActions_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatDatepickerActions)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MatDatepickerActions,
      selectors: [["mat-datepicker-actions"], ["mat-date-range-picker-actions"]],
      viewQuery: function MatDatepickerActions_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._template = _t.first);
        }
      },
      ngContentSelectors: _c1,
      decls: 1,
      vars: 0,
      consts: [[1, "mat-datepicker-actions"]],
      template: function MatDatepickerActions_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵdomTemplate(0, MatDatepickerActions_ng_template_0_Template, 2, 0, "ng-template");
        }
      },
      styles: [".mat-datepicker-actions{display:flex;justify-content:flex-end;align-items:center;padding:0 8px 8px 8px}.mat-datepicker-actions .mat-mdc-button-base+.mat-mdc-button-base{margin-left:8px}[dir=rtl] .mat-datepicker-actions .mat-mdc-button-base+.mat-mdc-button-base{margin-left:0;margin-right:8px}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return MatDatepickerActions;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MatDatepickerModule = /*#__PURE__*/(() => {
  class MatDatepickerModule {
    static ɵfac = function MatDatepickerModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatDatepickerModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MatDatepickerModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [MatDatepickerIntl, MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER],
      imports: [MatButtonModule, OverlayModule, A11yModule, PortalModule, MatCommonModule, MatDatepickerContent, MatDatepickerToggle, MatCalendarHeader, CdkScrollableModule]
    });
  }
  return MatDatepickerModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Animations used by the Material datepicker.
 * @docs-private
 * @deprecated No longer used, will be removed.
 * @breaking-change 21.0.0
 */
const matDatepickerAnimations = {
  // Represents:
  // trigger('transformPanel', [
  //   transition(
  //     'void => enter-dropdown',
  //     animate(
  //       '120ms cubic-bezier(0, 0, 0.2, 1)',
  //       keyframes([
  //         style({opacity: 0, transform: 'scale(1, 0.8)'}),
  //         style({opacity: 1, transform: 'scale(1, 1)'}),
  //       ]),
  //     ),
  //   ),
  //   transition(
  //     'void => enter-dialog',
  //     animate(
  //       '150ms cubic-bezier(0, 0, 0.2, 1)',
  //       keyframes([
  //         style({opacity: 0, transform: 'scale(0.7)'}),
  //         style({transform: 'none', opacity: 1}),
  //       ]),
  //     ),
  //   ),
  //   transition('* => void', animate('100ms linear', style({opacity: 0}))),
  // ])
  /** Transforms the height of the datepicker's calendar. */
  transformPanel: {
    type: 7,
    name: 'transformPanel',
    definitions: [{
      type: 1,
      expr: 'void => enter-dropdown',
      animation: {
        type: 4,
        styles: {
          type: 5,
          steps: [{
            type: 6,
            styles: {
              opacity: 0,
              transform: 'scale(1, 0.8)'
            },
            offset: null
          }, {
            type: 6,
            styles: {
              opacity: 1,
              transform: 'scale(1, 1)'
            },
            offset: null
          }]
        },
        timings: '120ms cubic-bezier(0, 0, 0.2, 1)'
      },
      options: null
    }, {
      type: 1,
      expr: 'void => enter-dialog',
      animation: {
        type: 4,
        styles: {
          type: 5,
          steps: [{
            type: 6,
            styles: {
              opacity: 0,
              transform: 'scale(0.7)'
            },
            offset: null
          }, {
            type: 6,
            styles: {
              transform: 'none',
              opacity: 1
            },
            offset: null
          }]
        },
        timings: '150ms cubic-bezier(0, 0, 0.2, 1)'
      },
      options: null
    }, {
      type: 1,
      expr: '* => void',
      animation: {
        type: 4,
        styles: {
          type: 6,
          styles: {
            opacity: 0
          },
          offset: null
        },
        timings: '100ms linear'
      },
      options: null
    }],
    options: {}
  },
  // Represents:
  // trigger('fadeInCalendar', [
  //   state('void', style({opacity: 0})),
  //   state('enter', style({opacity: 1})),
  //   // TODO(crisbeto): this animation should be removed since it isn't quite on spec, but we
  //   // need to keep it until #12440 gets in, otherwise the exit animation will look glitchy.
  //   transition('void => *', animate('120ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)')),
  // ])
  /** Fades in the content of the calendar. */
  fadeInCalendar: {
    type: 7,
    name: 'fadeInCalendar',
    definitions: [{
      type: 0,
      name: 'void',
      styles: {
        type: 6,
        styles: {
          opacity: 0
        },
        offset: null
      }
    }, {
      type: 0,
      name: 'enter',
      styles: {
        type: 6,
        styles: {
          opacity: 1
        },
        offset: null
      }
    }, {
      type: 1,
      expr: 'void => *',
      animation: {
        type: 4,
        styles: null,
        timings: '120ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)'
      },
      options: null
    }],
    options: {}
  }
};
export { DateRange, DefaultMatCalendarRangeStrategy, MAT_DATEPICKER_SCROLL_STRATEGY, MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY, MAT_DATEPICKER_SCROLL_STRATEGY_FACTORY_PROVIDER, MAT_DATEPICKER_VALIDATORS, MAT_DATEPICKER_VALUE_ACCESSOR, MAT_DATE_RANGE_SELECTION_STRATEGY, MAT_RANGE_DATE_SELECTION_MODEL_FACTORY, MAT_RANGE_DATE_SELECTION_MODEL_PROVIDER, MAT_SINGLE_DATE_SELECTION_MODEL_FACTORY, MAT_SINGLE_DATE_SELECTION_MODEL_PROVIDER, MatCalendar, MatCalendarBody, MatCalendarCell, MatCalendarHeader, MatDateRangeInput, MatDateRangePicker, MatDateSelectionModel, MatDatepicker, MatDatepickerActions, MatDatepickerApply, MatDatepickerCancel, MatDatepickerContent, MatDatepickerInput, MatDatepickerInputEvent, MatDatepickerIntl, MatDatepickerModule, MatDatepickerToggle, MatDatepickerToggleIcon, MatEndDate, MatMonthView, MatMultiYearView, MatRangeDateSelectionModel, MatSingleDateSelectionModel, MatStartDate, MatYearView, matDatepickerAnimations, yearsPerPage, yearsPerRow };
